import React, { useState } from 'react';
import style from './../../Css/Courses.module.css';

function Reactjscourse() {
    // State to keep track of the selected chapter
    const [selectedChapter, setSelectedChapter] = useState('chapter1')

    // Function to handle chapter selection
    const handleChapterClick = (chapter) => {
        setSelectedChapter(chapter)
    }

    // State to track the active chapter
    const [activeChapter, setActiveChapter] = useState('chapter1');

    // Function to handle chapter click
    const handleChapterActive = (chapter) => {
        setActiveChapter(chapter);
    };
    const handleClick = (chapter) => {
        handleChapterActive(chapter);
        handleChapterClick(chapter);
        window.scrollTo(0,0);
    };


    return (
        <div className={`${style.firstcontainer} container-fluid`}>

            <div className={`${style.therow} row`}>
            <div className={`${style.droupdownbtnbar} dropdown`}>
                    <button className={`${style.droupdownbtn} btn dropdown-toggle`} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    React.js
                    </button>
                    
                    <ul className={`${style.dropdownmenu} dropdown-menu`}>

                    <h5 className={style.stickyheading} >  React.js Tutorial</h5>

                        <li onClick={() => handleClick('chapter1')}
                            className={`${style.chapter1} ${activeChapter === 'chapter1' ? style.active : ''} text-decoration-none dropdown-item`} >
                       Introduction 
                        </li>



                        <li
                    onClick={() => handleClick('chapter2')}
                    className={`${style.chapter2} ${activeChapter === 'chapter2' ? style.active : ''} dropdown-item `}>
                  Setting Up the Development Environment
                </li>


                <li onClick={() => handleClick('chapter3')}
                     className={`${style.chapter3} ${activeChapter === 'chapter3' ? style.active : ''} dropdown-item `}>
               Creating Your First React App (Using create-react-app or Vite)
             </li>
    
                <li onClick={() => handleClick('chapter4')} 
                  className={`${style.chapter4} ${activeChapter === 'chapter4' ? style.active : ''} dropdown-item `}>
              Understanding JSX (JavaScript XML)
                </li>


                <li onClick={() => handleClick('chapter5')} 
                className={`${style.chapter5} ${activeChapter === 'chapter5' ? style.active : ''} dropdown-item  `}>
      Function vs Class Components
                </li>



                <li onClick={() => handleClick('chapter6')}
                className={`${style.chapter6} ${activeChapter === 'chapter6' ? style.active : ''} dropdown-item `}>
       Props in React
                </li>

                <li onClick={() => handleClick('chapter7')} 
                className={`${style.chapter7} ${activeChapter === 'chapter7' ? style.active : ''} dropdown-item `}>
          State in React
                </li>

<h5> React Core Concepts </h5>

                <li onClick={() => handleClick('chapter8')}
                className={`${style.chapter8} ${activeChapter === 'chapter8' ? style.active : ''} dropdown-item `}>
             Component Lifecycle (Class Components)
                </li>

                <li onClick={() => handleClick('chapter9')}
                  className={`${style.chapter9} ${activeChapter === 'chapter9' ? style.active : ''} dropdown-item `}>
   Functional Components and React Hooks


                </li>

                <li onClick={() => handleClick('chapter10')}
                className={`${style.chapter10} ${activeChapter === 'chapter10' ? style.active : ''} dropdown-item `}>
         Event Handling in React
                </li>

                <li onClick={() => handleClick('chapter11')} 
                className={`${style.chapter11} ${activeChapter === 'chapter11' ? style.active : ''} dropdown-item `}>
          Conditional Rendering in React.js
                    </li>


                <li onClick={() => handleClick('chapter12')}
                className={`${style.chapter12} ${activeChapter === 'chapter12' ? style.active : ''} dropdown-item `}>
              Lists and Keys in React
                </li>

<h5>Advanced Component Handling  </h5>
            <li onClick={() => handleClick('chapter13')} 
                className={`${style.chapter13} ${activeChapter === 'chapter13' ? style.active : ''} dropdown-item  `}>
           Controlled vs Uncontrolled Components
                </li>

                <li onClick={() => handleClick('chapter14')} 
                className={`${style.chapter14} ${activeChapter === 'chapter14' ? style.active : ''} dropdown-item `}>
             Forms in React:
Handling Input Fields
Form Validation
                </li>

                <li onClick={() => handleClick('chapter15')} 
                  className={`${style.chapter15} ${activeChapter === 'chapter15' ? style.active : ''} dropdown-item  `}>
               Higher-Order Components (HOCs)
                </li>



                <li onClick={() => handleClick('chapter16')} 
                className={`${style.chapter16} ${activeChapter === 'chapter16' ? style.active : ''} dropdown-item  `}>
       Render Props
                </li>

                <li onClick={() => handleClick('chapter17')}
                  className={`${style.chapter17} ${activeChapter === 'chapter17' ? style.active : ''} dropdown-item `}>
             React Portals
                </li>

<h5>React Router</h5>
                <li onClick={() => handleClick('chapter18')} 
                className={`${style.chapter18} ${activeChapter === 'chapter18' ? style.active : ''} dropdown-item `}>
     Setting Up React Router
                </li>



                <li onClick={() => handleClick('chapter19')}
                className={`${style.chapter19} ${activeChapter === 'chapter19' ? style.active : ''} dropdown-item `}>
         Navigating Between Pages
                </li>

                <li onClick={() => handleClick('chapter20')} 
                className={`${style.chapter20} ${activeChapter === 'chapter20' ? style.active : ''} dropdown-item `}>
          Route Parameters and Query Strings
                </li>

                <li onClick={() => handleClick('chapter21')}
                className={`${style.chapter21} ${activeChapter === 'chapter21' ? style.active : ''} dropdown-item `}>
           Nested Routes
                </li>


                <li onClick={() => handleClick('chapter22')} 
                className={`${style.chapter22} ${activeChapter === 'chapter22' ? style.active : ''} dropdown-item `}>
             Redirects and Navigation Guards
                </li>


<h5>State Management in React </h5>
                <li onClick={() => handleClick('chapter23')} 
                className={`${style.chapter23} ${activeChapter === 'chapter23' ? style.active : ''} dropdown-item `}>
            Context API:
Creating and Using Context
Updating Context Values
                </li>


                <li onClick={() => handleClick('chapter24')} 
                className={`${style.chapter24} ${activeChapter === 'chapter24' ? style.active : ''} dropdown-item  `}>
                Redux

                </li>
                
                <li onClick={() => handleClick('chapter25')} 
                className={`${style.chapter25} ${activeChapter === 'chapter25' ? style.active : ''} dropdown-item `}>
        State Management Libraries:
Zustand
MobX
Recoil
                </li>

<h5>Styling in React</h5>
                <li onClick={() => handleClick('chapter26')} 
                className={`${style.chapter26} ${activeChapter === 'chapter26' ? style.active : ''} dropdown-item `}>
            CSS Modules
                </li>

                <li onClick={() => handleClick('chapter27')} 
                className={`${style.chapter27} ${activeChapter === 'chapter27' ? style.active : ''} dropdown-item `}>
         Styled Components
                </li>


                <li onClick={() => handleClick('chapter28')} 
                 className={`${style.chapter28} ${activeChapter === 'chapter28' ? style.active : ''} dropdown-item `}>
              Emotion.js
                </li>


                <li onClick={() => handleClick('chapter29')} 
                className={`${style.chapter29} ${activeChapter === 'chapter29' ? style.active : ''} dropdown-item `}>
             Inline Styles in React
                </li>

                <li onClick={() => handleClick('chapter30')} 
                className={`${style.chapter30} ${activeChapter === 'chapter30' ? style.active : ''} dropdown-item `}>
       Tailwind CSS Integration
                </li>


                <li onClick={() => handleClick('chapter31')} 
                className={`${style.chapter31} ${activeChapter === 'chapter31' ? style.active : ''} dropdown-item `}>
   Theming in React.js
                </li>


<h5>Asynchronous Operations in React</h5>
                <li onClick={() => handleClick('chapter32')} 
                className={`${style.chapter32} ${activeChapter === 'chapter32' ? style.active : ''} dropdown-item `}>
             Fetching Data with fetch API and Axios
                </li>


                <li onClick={() => handleClick('chapter33')} 
                className={`${style.chapter33} ${activeChapter === 'chapter33' ? style.active : ''} dropdown-item `}>
          React Query (for Data Fetching and Caching)
                </li>

                <li onClick={() => handleClick('chapter34')} 
                className={`${style.chapter34} ${activeChapter === 'chapter34' ? style.active : ''} dropdown-item `}>
Handling Loading States
                </li>


                <li onClick={() => handleClick('chapter35')} 
                className={`${style.chapter35} ${activeChapter === 'chapter35' ? style.active : ''} dropdown-item `}>
            Error Handling in React.js
                </li>

   <h5> Performance Optimization</h5>
                <li onClick={() => handleClick('chapter36')} 
                className={`${style.chapter36} ${activeChapter === 'chapter36' ? style.active : ''} dropdown-item `}>
     Memoization with React.memo
                </li>



                
                <li onClick={() => handleClick('chapter37')} 
                className={`${style.chapter37} ${activeChapter === 'chapter37' ? style.active : ''} dropdown-item `}>
            Lazy Loading Components with React.lazy and Suspense
                </li>

                <li onClick={() => handleClick('chapter38')} 
                className={`${style.chapter38} ${activeChapter === 'chapter38' ? style.active : ''} dropdown-item `}>
             Code Splitting
                </li>

                <li onClick={() => handleClick('chapter39')} 
                className={`${style.chapter39} ${activeChapter === 'chapter39' ? style.active : ''} dropdown-item `}>
       Avoiding Re-renders with useCallback and useMemo
                </li>

<h5>Testing in React</h5>
                <li onClick={() => handleClick('chapter40')} 
                className={`${style.chapter40} ${activeChapter === 'chapter40' ? style.active : ''} dropdown-item `}>
        Introduction to Testing in React.js

                </li>


                <li onClick={() => handleClick('chapter41')} 
                className={`${style.chapter41} ${activeChapter === 'chapter41' ? style.active : ''} dropdown-item `}>
             Unit Testing with Jest
                </li>

                <li onClick={() => handleClick('chapter42')} 
                className={`${style.chapter42} ${activeChapter === 'chapter42' ? style.active : ''} dropdown-item `}>
           Component Testing with React Testing Library
                </li>

                <li onClick={() => handleClick('chapter43')} 
                className={`${style.chapter43} ${activeChapter === 'chapter43' ? style.active : ''} dropdown-item `}>
             End-to-End Testing with Cypress or Playwright
                </li>


<h5> React Ecosystem</h5>

                <li onClick={() => handleClick('chapter44')} 
                className={`${style.chapter44} ${activeChapter === 'chapter44' ? style.active : ''} dropdown-item `}>
          Using Third-Party Libraries:
React Bootstrap
Material-UI (MUI)
Ant Design
                </li>

                <li onClick={() => handleClick('chapter45')} 
                className={`${style.chapter45} ${activeChapter === 'chapter45' ? style.active : ''} dropdown-item  `}>
               Integrating Charts and Graphs
                </li>

                <li onClick={() => handleClick('chapter46')} 
                className={`${style.chapter46} ${activeChapter === 'chapter46' ? style.active : ''} dropdown-item  `}>
        Working with React Native for Mobile Apps
                </li>


                <h5>React with APIs</h5>
                <li
                    onClick={() => handleClick('chapter47')}                  
                    className={`${style.chapter47} ${activeChapter === 'chapter47' ? style.active : ''} dropdown-item  `}>
                    REST API Intregration
                    </li>
               


                    <li
                    onClick={() => handleClick('chapter48')}
                    className={`${style.chapter48} ${activeChapter === 'chapter48' ? style.active : ''} dropdown-item  `}>
                   GraphQL with Apollo client
                </li>
                
                
                <li onClick={() => handleClick('chapter49')}
                     className={`${style.chapter49} ${activeChapter === 'chapter49' ? style.active : ''} dropdown-item  `}>
                      WebSocket and Real-Time Data Updates
             </li>



    <h5>React With Backent</h5>
                <li onClick={() => handleClick('chapter50')} 
                  className={`${style.chapter50} ${activeChapter === 'chapter50' ? style.active : ''} dropdown-item   `}>
                React with Node.js and Express
                </li>


                <li onClick={() => handleClick('chapter51')} 
                className={`${style.chapter51} ${activeChapter === 'chapter51' ? style.active : ''} dropdown-item  `}>
                  React with Firebase
                </li>



                <li onClick={() => handleClick('chapter52')}
                className={`${style.chapter52} ${activeChapter === 'chapter52' ? style.active : ''} dropdown-item  `}>
                  SSR (Server-Side Rendering) With Next.js
                </li>

                <li onClick={() => handleClick('chapter53')} 
                className={`${style.chapter53} ${activeChapter === 'chapter53' ? style.active : ''} dropdown-item  `}>
                  Static Site Generation with Next.js
                </li>

<h5>Building and Deploying React Apps</h5>
                <li onClick={() => handleClick('chapter54')}
                className={`${style.chapter54} ${activeChapter === 'chapter54' ? style.active : ''} dropdown-item  `}>
                  Production Builds (npm build)
                </li>


<h6>Deploying React Apps to:</h6>
                <li onClick={() => handleClick('chapter55')}
                  className={`${style.chapter55} ${activeChapter === 'chapter55' ? style.active : ''} dropdown-item  `}>
                    Vercel
                </li>

                <li onClick={() => handleClick('chapter56')}
                className={`${style.chapter56} ${activeChapter === 'chapter56' ? style.active : ''} dropdown-item  `}>
                  Netlify
                </li>

                <li onClick={() => handleClick('chapter57')} 
                className={`${style.chapter57} ${activeChapter === 'chapter57' ? style.active : ''} dropdown-item  `}>
                  AWS Amplify
                </li>


                <li onClick={() => handleClick('chapter58')}
                className={`${style.chapter58} ${activeChapter === 'chapter58' ? style.active : ''} dropdown-item  `}>
                  GitHub Pages
                </li>


            <li onClick={() => handleClick('chapter59')} 
                className={`${style.chapter59} ${activeChapter === 'chapter59' ? style.active : ''} dropdown-item  `}>
                  CI/CD for React Apps
                </li>

<h5>Important Topics</h5>
                <li onClick={() => handleClick('chapter60')} 
                className={`${style.chapter61} ${activeChapter === 'chapter61' ? style.active : ''} dropdown-item  `}>
                  Accessibility in React
                </li>

                <li onClick={() => handleClick('chapter61')} 
                  className={`${style.chapter61} ${activeChapter === 'chapter61' ? style.active : ''} dropdown-item  `}>
                    Internationalization (i18n)
                </li>



                <li onClick={() => handleClick('chapter62')} 
                className={`${style.chapter62} ${activeChapter === 'chapter62' ? style.active : ''} dropdown-item  `}>
                  Custom Hooks
                </li>

                <li onClick={() => handleClick('chapter63')}
                  className={`${style.chapter63} ${activeChapter === 'chapter63' ? style.active : ''} dropdown-item  `}>
                    TypeScript with React.js
                </li>


                <li onClick={() => handleClick('chapter64')} 
                className={`${style.chapter64} ${activeChapter === 'chapter64' ? style.active : ''} dropdown-item  `}>
                  Animations with Framer Motion or React Spring
                </li>



                <li onClick={() => handleClick('chapter65')}
                className={`${style.chapter65} ${activeChapter === 'chapter65' ? style.active : ''} dropdown-item  `}>
                  Building Progressive Web Apps (PWAs) with React.js
                </li>

              </ul>
                </div>





                <div className={`${style.leftcolumn} col-2`}>

                    <ul className={`${style.chapters} `}>
                    <h5 className={style.stickyheading} > React.js Tutorial</h5>
                
                <li
                    onClick={() => handleClick('chapter1')}

                    className={`${style.chapter1} ${activeChapter === 'chapter1' ? style.active : ''} `}>
                    Intoduction
                    </li>


               


                    <li
                    onClick={() => handleClick('chapter2')}
                    className={`${style.chapter2} ${activeChapter === 'chapter2' ? style.active : ''}  `}>
                  Setting Up the Development Environment
                </li>


                <li onClick={() => handleClick('chapter3')}
                     className={`${style.chapter3} ${activeChapter === 'chapter3' ? style.active : ''} `}>
               Creating Your First React App (Using create-react-app or Vite)
             </li>
    
                <li onClick={() => handleClick('chapter4')} 
                  className={`${style.chapter4} ${activeChapter === 'chapter4' ? style.active : ''}  `}>
              Understanding JSX (JavaScript XML)
                </li>


                <li onClick={() => handleClick('chapter5')} 
                className={`${style.chapter5} ${activeChapter === 'chapter5' ? style.active : ''}  `}>
      Function vs Class Components
                </li>



                <li onClick={() => handleClick('chapter6')}
                className={`${style.chapter6} ${activeChapter === 'chapter6' ? style.active : ''} `}>
       Props in React
                </li>

                <li onClick={() => handleClick('chapter7')} 
                className={`${style.chapter7} ${activeChapter === 'chapter7' ? style.active : ''} `}>
          State in React
                </li>

<h5> React Core Concepts </h5>

                <li onClick={() => handleClick('chapter8')}
                className={`${style.chapter8} ${activeChapter === 'chapter8' ? style.active : ''}  `}>
             Component Lifecycle (Class Components)
                </li>

                <li onClick={() => handleClick('chapter9')}
                  className={`${style.chapter9} ${activeChapter === 'chapter9' ? style.active : ''} `}>
   Functional Components and React Hooks


                </li>

                <li onClick={() => handleClick('chapter10')}
                className={`${style.chapter10} ${activeChapter === 'chapter10' ? style.active : ''}  `}>
         Event Handling in React
                </li>

                <li onClick={() => handleClick('chapter11')} 
                className={`${style.chapter11} ${activeChapter === 'chapter11' ? style.active : ''} `}>
          Conditional Rendering in React.js
                    </li>


                <li onClick={() => handleClick('chapter12')}
                className={`${style.chapter12} ${activeChapter === 'chapter12' ? style.active : ''} `}>
              Lists and Keys in React
                </li>

<h5>Advanced Component Handling  </h5>
            <li onClick={() => handleClick('chapter13')} 
                className={`${style.chapter13} ${activeChapter === 'chapter13' ? style.active : ''}  `}>
           Controlled vs Uncontrolled Components
                </li>

                <li onClick={() => handleClick('chapter14')} 
                className={`${style.chapter14} ${activeChapter === 'chapter14' ? style.active : ''}  `}>
             Forms in React:
Handling Input Fields
Form Validation
                </li>

                <li onClick={() => handleClick('chapter15')} 
                  className={`${style.chapter15} ${activeChapter === 'chapter15' ? style.active : ''}  `}>
               Higher-Order Components (HOCs)
                </li>



                <li onClick={() => handleClick('chapter16')} 
                className={`${style.chapter16} ${activeChapter === 'chapter16' ? style.active : ''}  `}>
       Render Props
                </li>

                <li onClick={() => handleClick('chapter17')}
                  className={`${style.chapter17} ${activeChapter === 'chapter17' ? style.active : ''}  `}>
             React Portals
                </li>

<h5>React Router</h5>
                <li onClick={() => handleClick('chapter18')} 
                className={`${style.chapter18} ${activeChapter === 'chapter18' ? style.active : ''}  `}>
     Setting Up React Router
                </li>



                <li onClick={() => handleClick('chapter19')}
                className={`${style.chapter19} ${activeChapter === 'chapter19' ? style.active : ''}  `}>
         Navigating Between Pages
                </li>

                <li onClick={() => handleClick('chapter20')} 
                className={`${style.chapter20} ${activeChapter === 'chapter20' ? style.active : ''}  `}>
          Route Parameters and Query Strings
                </li>

                <li onClick={() => handleClick('chapter21')}
                className={`${style.chapter21} ${activeChapter === 'chapter21' ? style.active : ''}  `}>
           Nested Routes
                </li>


                <li onClick={() => handleClick('chapter22')} 
                className={`${style.chapter22} ${activeChapter === 'chapter22' ? style.active : ''}  `}>
             Redirects and Navigation Guards
                </li>


<h5>State Management in React </h5>
                <li onClick={() => handleClick('chapter23')} 
                className={`${style.chapter23} ${activeChapter === 'chapter23' ? style.active : ''}  `}>
            Context API:
Creating and Using Context
Updating Context Values
                </li>


                <li onClick={() => handleClick('chapter24')} 
                className={`${style.chapter24} ${activeChapter === 'chapter24' ? style.active : ''}  `}>
                Redux

                </li>
                
                <li onClick={() => handleClick('chapter25')} 
                className={`${style.chapter25} ${activeChapter === 'chapter25' ? style.active : ''}  `}>
        State Management Libraries:
Zustand
MobX
Recoil
                </li>

<h5>Styling in React</h5>
                <li onClick={() => handleClick('chapter26')} 
                className={`${style.chapter26} ${activeChapter === 'chapter26' ? style.active : ''}  `}>
            CSS Modules
                </li>

                <li onClick={() => handleClick('chapter27')} 
                className={`${style.chapter27} ${activeChapter === 'chapter27' ? style.active : ''}  `}>
         Styled Components
                </li>


                <li onClick={() => handleClick('chapter28')} 
                 className={`${style.chapter28} ${activeChapter === 'chapter28' ? style.active : ''}  `}>
              Emotion.js
                </li>


                <li onClick={() => handleClick('chapter29')} 
                className={`${style.chapter29} ${activeChapter === 'chapter29' ? style.active : ''} `}>
             Inline Styles in React
                </li>

                <li onClick={() => handleClick('chapter30')} 
                className={`${style.chapter30} ${activeChapter === 'chapter30' ? style.active : ''} `}>
       Tailwind CSS Integration
                </li>


                <li onClick={() => handleClick('chapter31')} 
                className={`${style.chapter31} ${activeChapter === 'chapter31' ? style.active : ''} `}>
   Theming in React.js
                </li>


<h5>Asynchronous Operations in React</h5>
                <li onClick={() => handleClick('chapter32')} 
                className={`${style.chapter32} ${activeChapter === 'chapter32' ? style.active : ''} `}>
             Fetching Data with fetch API and Axios
                </li>


                <li onClick={() => handleClick('chapter33')} 
                className={`${style.chapter33} ${activeChapter === 'chapter33' ? style.active : ''} `}>
          React Query (for Data Fetching and Caching)
                </li>

                <li onClick={() => handleClick('chapter34')} 
                className={`${style.chapter34} ${activeChapter === 'chapter34' ? style.active : ''} `}>
Handling Loading States
                </li>


                <li onClick={() => handleClick('chapter35')} 
                className={`${style.chapter35} ${activeChapter === 'chapter35' ? style.active : ''}  `}>
            Error Handling in React.js
                </li>

   <h5> Performance Optimization</h5>
                <li onClick={() => handleClick('chapter36')} 
                className={`${style.chapter36} ${activeChapter === 'chapter36' ? style.active : ''}  `}>
     Memoization with React.memo
                </li>



                
                <li onClick={() => handleClick('chapter37')} 
                className={`${style.chapter37} ${activeChapter === 'chapter37' ? style.active : ''}  `}>
            Lazy Loading Components with React.lazy and Suspense
                </li>

                <li onClick={() => handleClick('chapter38')} 
                className={`${style.chapter38} ${activeChapter === 'chapter38' ? style.active : ''}  `}>
             Code Splitting
                </li>

                <li onClick={() => handleClick('chapter39')} 
                className={`${style.chapter39} ${activeChapter === 'chapter39' ? style.active : ''}  `}>
       Avoiding Re-renders with useCallback and useMemo
                </li>

<h5>Testing in React</h5>
                <li onClick={() => handleClick('chapter40')} 
                className={`${style.chapter40} ${activeChapter === 'chapter40' ? style.active : ''}  `}>
        Introduction to Testing in React.js
                </li>


                <li onClick={() => handleClick('chapter41')} 
                className={`${style.chapter41} ${activeChapter === 'chapter41' ? style.active : ''}  `}>
             Unit Testing with Jest
                </li>

                <li onClick={() => handleClick('chapter42')} 
                className={`${style.chapter42} ${activeChapter === 'chapter42' ? style.active : ''}  `}>
           Component Testing with React Testing Library
                </li>

                <li onClick={() => handleClick('chapter43')} 
                className={`${style.chapter43} ${activeChapter === 'chapter43' ? style.active : ''}  `}>
             End-to-End Testing with Cypress or Playwright
                </li>


<h5> React Ecosystem</h5>

                <li onClick={() => handleClick('chapter44')} 
                className={`${style.chapter44} ${activeChapter === 'chapter44' ? style.active : ''}  `}>
          Using Third-Party Libraries:
React Bootstrap
Material-UI (MUI)
Ant Design
                </li>

                <li onClick={() => handleClick('chapter45')} 
                className={`${style.chapter45} ${activeChapter === 'chapter45' ? style.active : ''}  `}>
               Integrating Charts and Graphs
                </li>

                <li onClick={() => handleClick('chapter46')} 
                className={`${style.chapter46} ${activeChapter === 'chapter46' ? style.active : ''}  `}>
        Working with React Native for Mobile Apps
                </li>

                <h5>React with APIs</h5>
                <li
                    onClick={() => handleClick('chapter47')}                  
                    className={`${style.chapter47} ${activeChapter === 'chapter47' ? style.active : ''} `}>
                    REST API Intregration
                    </li>
               


                    <li
                    onClick={() => handleClick('chapter48')}
                    className={`${style.chapter48} ${activeChapter === 'chapter48' ? style.active : ''}  `}>
                   GraphQL with Apollo client
                </li>
                
                
                <li onClick={() => handleClick('chapter49')}
                     className={`${style.chapter49} ${activeChapter === 'chapter49' ? style.active : ''} `}>
                      WebSocket and Real-Time Data Updates
             </li>



    <h5>React With Backent</h5>
                <li onClick={() => handleClick('chapter50')} 
                  className={`${style.chapter50} ${activeChapter === 'chapter50' ? style.active : ''}  `}>
                React with Node.js and Express
                </li>


                <li onClick={() => handleClick('chapter51')} 
                className={`${style.chapter51} ${activeChapter === 'chapter51' ? style.active : ''}  `}>
                  React with Firebase
                </li>



                <li onClick={() => handleClick('chapter52')}
                className={`${style.chapter52} ${activeChapter === 'chapter52' ? style.active : ''} `}>
                  SSR (Server-Side Rendering) With Next.js
                </li>

                <li onClick={() => handleClick('chapter53')} 
                className={`${style.chapter53} ${activeChapter === 'chapter53' ? style.active : ''} `}>
                  Static Site Generation with Next.js
                </li>

<h5>Building and Deploying React Apps</h5>
                <li onClick={() => handleClick('chapter54')}
                className={`${style.chapter54} ${activeChapter === 'chapter54' ? style.active : ''}  `}>
                  Production Builds (npm build)
                </li>


<h6>Deploying React Apps to:</h6>
                <li onClick={() => handleClick('chapter55')}
                  className={`${style.chapter55} ${activeChapter === 'chapter55' ? style.active : ''} `}>
                    Vercel
                </li>

                <li onClick={() => handleClick('chapter56')}
                className={`${style.chapter56} ${activeChapter === 'chapter56' ? style.active : ''}  `}>
                  Netlify
                </li>

                <li onClick={() => handleClick('chapter57')} 
                className={`${style.chapter57} ${activeChapter === 'chapter57' ? style.active : ''} `}>
                  AWS Amplify
                </li>


                <li onClick={() => handleClick('chapter58')}
                className={`${style.chapter58} ${activeChapter === 'chapter58' ? style.active : ''} `}>
                  GitHub Pages
                </li>


            <li onClick={() => handleClick('chapter59')} 
                className={`${style.chapter59} ${activeChapter === 'chapter59' ? style.active : ''}  `}>
                  CI/CD for React Apps
                </li>

<h5>Important Topics</h5>
                <li onClick={() => handleClick('chapter60')} 
                className={`${style.chapter60} ${activeChapter === 'chapter60' ? style.active : ''}  `}>
                  Accessibility in React
                </li>

                <li onClick={() => handleClick('chapter61')} 
                  className={`${style.chapter61} ${activeChapter === 'chapter61' ? style.active : ''}  `}>
                    Internationalization (i18n)
                </li>



                <li onClick={() => handleClick('chapter62')} 
                className={`${style.chapter62} ${activeChapter === 'chapter62' ? style.active : ''}  `}>
                  Custom Hooks
                </li>

                <li onClick={() => handleClick('chapter63')}
                  className={`${style.chapter63} ${activeChapter === 'chapter63' ? style.active : ''}  `}>
                    TypeScript with React.js
                </li>


                <li onClick={() => handleClick('chapter64')} 
                className={`${style.chapter64} ${activeChapter === 'chapter64' ? style.active : ''}  `}>
                  Animations with Framer Motion or React Spring
                </li>



                <li onClick={() => handleClick('chapter65')}
                className={`${style.chapter65} ${activeChapter === 'chapter65' ? style.active : ''}  `}>
                  Building Progressive Web Apps (PWAs) with React.js
                </li>




                    </ul>
                </div>




                <div className={`${style.rightcolumn} col`}>


                    {/* Chapter Content */}


       
                    {selectedChapter === 'chapter1' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Introduction</h1>
    <p>Here’s a detailed outline for the <strong>Introduction to React.js</strong> topic for your course:</p>

  <br />

    <h2 style={{paddingBottom:"6px"}}>1. What is React?</h2>
    <ul>
      <li><strong>Definition:</strong> React is a JavaScript library for building user interfaces.</li><br />
      <li><strong>Origin:</strong> Created by Facebook, initially released in 2013.</li><br />
      <li><strong>Key Features:</strong>
        <ul>
          <li>Declarative UI</li><br />
          <li>Component-Based Architecture</li><br />
          <li>Virtual DOM</li><br />
          <li>Reusability</li><br />
          <li>Unidirectional Data Flow</li>
        </ul>
      </li>
    </ul>
<br />

    <h2 style={{paddingBottom:"6px"}}>2. Why Use React?</h2>
    <ul>
      <li><strong>Comparison with Vanilla JavaScript:</strong>
        <ul>
          <li>Faster and more efficient UI updates with the Virtual DOM.</li><br />
          <li>Easier to manage state and logic through components.</li>
        </ul><br />
      </li>
      <li><strong>Comparison with Other Frameworks:</strong>
        <ul>
          <li>Lightweight compared to Angular.</li><br />
          <li>Easier to integrate with other libraries or frameworks.</li>
        </ul>
      </li><br />
      <li><strong>Industry Adoption:</strong> Examples: Facebook, Instagram, Netflix, Airbnb.</li>
    </ul>

    <br />
    <h2 style={{paddingBottom:"6px"}}>3. Prerequisites for Learning React</h2>
    <ul>
      <li><strong>Basic Knowledge of:</strong>
        <ul>
          <li>HTML</li><br />
          <li>CSS</li><br />
          <li>JavaScript (ES6+ features like <code>let/const</code>, arrow functions, destructuring, modules, etc.)</li>
        </ul><br />
      </li>
      <li><strong>Tools Required:</strong>
        <ul>
          <li>Node.js and npm (or Yarn)</li><br />
          <li>A Code Editor (e.g., Visual Studio Code)</li>
        </ul>
      </li>
    </ul>

    <br />

    <h2>4. Setting Up the React Environment</h2>
    <ul>
      <li><strong>Install Node.js:</strong>
        <p>Download from <a href="https://nodejs.org/" target="_blank" rel="noopener noreferrer">Node.js Official Website</a>.</p>
      </li><br />
      <li><strong>Install a Package Manager:</strong> npm (comes with Node.js) or Yarn.</li><br />
      <li><strong>Create a New React Application:</strong></li>
    </ul><br />
    <pre>
      <code>
        npx create-react-app my-app{`\n`}
        cd my-app{`\n`}
        npm start
      </code>
    </pre>

   <br />

    <h2 style={{paddingBottom:"6px"}}>5. Key Concepts of React</h2>
    <ul>
      <li><strong>React Components:</strong>
        <ul>
          <li>Definition: Building blocks of a React application.</li><br />
          <li>Types:
            <ul>
              <li>Function Components</li><br />
              <li>Class Components</li>
            </ul>
          </li><br />
        </ul>
      </li>
      <li><strong>JSX:</strong>
        <p>Syntax Extension for JavaScript that combines HTML with JavaScript.</p>
        <pre>
          <code>
            const App = () {"=>"} {'{'} return &lt;h1&gt;Hello, React!&lt;/h1&gt;; {'}'};
          </code>
        </pre>
      </li><br />
      <li><strong>Virtual DOM:</strong>
        <ul>
          <li>What is it?</li><br />
          <li>How it differs from the Real DOM.</li><br />
          <li>Benefits for Performance.</li>
        </ul><br />
      </li>
      <li><strong>State and Props:</strong>
        <ul>
          <li><strong>State:</strong> Manages data within a component.</li><br />
          <li><strong>Props:</strong> Passes data between components.</li>
        </ul>
      </li>
    </ul>

   <br />

    <h2 style={{paddingBottom:"6px"}}>6. Creating Your First React App</h2>
    <ol>
      <li><strong>Overview of Project Structure:</strong>
        <ul>
          <li><code>src</code> folder: Contains all the code.</li><br />
          <li><code>public</code> folder: Static assets.</li><br />
          <li>Key files:
            <ul>
              <li><code>index.js</code>: Entry point.</li><br />
              <li><code>App.js</code>: Main component.</li>
            </ul>
          </li>
        </ul><br />
      </li>
      <li><strong>Editing the Default App:</strong>
        <p>Replace the default template with a simple "Hello, World!" example.</p>
      </li><br />
      <li><strong>Live Reloading:</strong>
        <p>Make changes and watch them update instantly.</p>
      </li>
    </ol>
<br />

    <h2  style={{paddingBottom:"6px"}}>7. Advantages and Disadvantages of React</h2>
    <h3>Advantages:</h3>
    <ul>
      <li>Easy to Learn and Use.</li><br />
      <li>High Performance with Virtual DOM.</li><br />
      <li>Component Reusability.</li><br />
      <li>Strong Community Support.</li>
    </ul><br />
    <h3 style={{paddingBottom:"6px"}}>Disadvantages:</h3>
    <ul>
      <li>Initial Learning Curve for JSX and Tools.</li><br />
      <li>Only Covers the UI Layer (needs additional libraries for routing or state management).</li>
    </ul>

    <br />

    <h2 style={{paddingBottom:"6px"}}>8. Tools for React Development</h2>
    <ul>
      <li><strong>Code Editors:</strong>
        <ul>
          <li>Visual Studio Code (recommended).</li><br />
          <li>Sublime Text.</li>
        </ul>
      </li><br />
      <li><strong>Browser Extensions:</strong>
        <ul>
          <li>React Developer Tools for Chrome/Firefox.</li>
        </ul>
      </li>
    </ul>

   <br />

    <h2 style={{paddingBottom:"6px"}}>9. Closing and Next Steps</h2>
    <ul>
      <li><strong>Recap:</strong>
        <ul>
          <li>What React is.</li><br />
          <li>Its advantages and setup.</li>
        </ul><br />
      </li>
      <li><strong>What’s Next:</strong>
        <ul>
          <li>Deep dive into JSX, components, state, and props.</li>
        </ul>
      </li>
    </ul>
  </div>
)}


 


{selectedChapter === 'chapter2' && (
  <div className={style.chaptercontent}>
     <h1 className={style.heading}>Setting Up the React Development Environment</h1>
          <p>
            To start building React applications, you'll need to set up your development environment properly. Follow these steps:
          </p><br />

          <h2>1. Install Node.js</h2>
          <ul>
            <li>
              Download and install Node.js from the{" "}
              <a href="https://nodejs.org/" target="_blank" rel="noopener noreferrer">
                official Node.js website
              </a>.
            </li><br />
            <li>
              Node.js comes bundled with npm (Node Package Manager), which is essential for managing dependencies.
            </li>
          </ul>

          <h2>2. Install a Code Editor</h2>
          <ul>
            <li>
              It’s recommended to use{" "}
              <a
                href="https://code.visualstudio.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visual Studio Code (VS Code)
              </a>
              .
            </li><br />
            <li>VS Code offers great support for JavaScript and React development.</li>
          </ul><br />

          <h2>3. Create a New React Application</h2>
          <p>
            Use the following commands to create a React application using Create React App:
          </p>
          <pre className={style.codeBlock}>
            <code>
              npx create-react-app my-app
              <br />
              cd my-app
              <br />
              npm start
            </code>
          </pre>
          <ul>
            <li>
              <strong>npx create-react-app my-app</strong>: Creates a new React application.
            </li><br />
            <li>
              <strong>cd my-app</strong>: Navigates into the application folder.
            </li><br />
            <li>
              <strong>npm start</strong>: Starts the development server and opens the app in your default browser.
            </li>
          </ul><br />

          <h2>4. Install Browser Extensions</h2>
          <ul>
            <li>
              Install the{" "}
              <a
                href="https://react.dev/"
                target="_blank"
                rel="noopener noreferrer"
              >
                React Developer Tools
              </a>{" "}
              extension for Chrome or Firefox.
            </li><br />
            <li>Helps in debugging React applications.</li>
          </ul><br />

          <h2>5. Optional: Install Yarn (Alternative Package Manager)</h2>
          <p>
            Yarn is an alternative to npm for managing packages. Install it with:
          </p>
          <pre className={style.codeBlock}>
            <code>npm install --global yarn</code>
          </pre><br />

          <h2>6. Verify Installation</h2>
          <p>
            Ensure Node.js and npm are installed correctly by running:
          </p>
          <pre className={style.codeBlock}>
            <code>
              node -v
              <br />
              npm -v
            </code>
          </pre>
          <p>
            These commands will display the installed versions of Node.js and npm, respectively.
          </p><br />

          <h2>7. Start Coding!</h2>
          <p>
            Open the created project folder in your code editor and start building your React application.
          </p>
    

  </div>
)}


{selectedChapter === 'chapter3' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>
      Creating Your First React App (Using create-react-app or Vite)
    </h1>
    <p>
      React is a popular JavaScript library for building user interfaces. Getting started with React requires setting up a React application, which can be done using tools like <strong>create-react-app</strong> or <strong>Vite</strong>.
    </p><br />

    <h2>1. Using create-react-app</h2>
    <p>
      <strong>create-react-app</strong> is a toolchain recommended by React for beginners. It sets up a project with the necessary configuration to start building immediately.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Steps:</h3>
    <ol>
      <li>
        <strong>Install Node.js</strong><br />
        Ensure you have Node.js installed. You can download it from{' '}
        <a href="https://nodejs.org/" target="_blank" rel="noopener noreferrer">
          Node.js Official Website
        </a>.
      </li><br />
      <li>
        <strong>Install create-react-app globally (optional)</strong>
        <pre>
          <code>npx create-react-app my-app</code>
        </pre>
        Here, <code>npx</code> is a package runner that comes with Node.js. Replace <code>my-app</code> with your desired project name.
      </li><br />
      <li>
        <strong>Navigate to Your Project Directory:</strong>
        <pre>
          <code>cd my-app</code>
        </pre>
      </li><br />
      <li>
        <strong>Run the Application:</strong>
        <pre>
          <code>npm start</code>
        </pre>
        This starts a development server and opens the app in your default browser at <code>http://localhost:3000/</code>.
      </li>
    </ol>

    <h3 style={{paddingBottom:"6px"}}>Features of create-react-app:</h3>
    <ul>
      <li>No manual configuration needed for Webpack, Babel, etc.</li><br />
      <li>Comes pre-configured with a development server and testing setup.</li><br />
      <li>Focuses on simplicity and productivity for beginners.</li>
    </ul>

   <br />

    <h2>2. Using Vite</h2>
    <p>
      <strong>Vite</strong> is a fast and modern build tool optimized for development. It offers faster startup times compared to <strong>create-react-app</strong>.
    </p>

    <h3>Steps:</h3>
    <ol>
      <li>
        <strong>Install Node.js</strong><br />
        Make sure Node.js is installed.
      </li><br />
      <li>
        <strong>Create a New Vite Project:</strong>
        <pre>
          <code>npm create vite@latest my-app</code>
        </pre>
        Select <code>React</code> (or <code>React + TypeScript</code>, if desired) when prompted. Replace <code>my-app</code> with your project name.
      </li><br />
      <li>
        <strong>Navigate to Your Project Directory:</strong>
        <pre>
          <code>cd my-app</code>
        </pre>
      </li><br />
      <li>
        <strong>Install Dependencies:</strong>
        <pre>
          <code>npm install</code>
        </pre>
      </li><br />
      <li>
        <strong>Run the Development Server:</strong>
        <pre>
          <code>npm run dev</code>
        </pre>
        This will start the Vite server and display a link (e.g., <code>http://localhost:5173/</code>) to preview your app.
      </li>
    </ol><br />

    <h3 style={{paddingBottom:"6px"}}>Features of Vite:</h3>
    <ul>
      <li>Faster builds and HMR (Hot Module Replacement) compared to <strong>create-react-app</strong>.</li><br />
      <li>Lightweight and highly optimized for modern browsers.</li><br />
      <li>Configurable and extendable for advanced use cases.</li>
    </ul>

 <br />

    <h3>Comparison:</h3>
    <table>
      <thead>
        <tr>
          <th>Feature</th>
          <th>create-react-app</th>
          <th>Vite</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Speed</td>
          <td>Moderate build and reload times</td>
          <td>Faster build and reload times</td>
        </tr>
        <tr>
          <td>Configuration</td>
          <td>Pre-configured, limited flexibility</td>
          <td>Highly configurable</td>
        </tr>
        <tr>
          <td>Complexity</td>
          <td>Easy for beginners</td>
          <td>Slightly advanced, but user-friendly</td>
        </tr>
        <tr>
          <td>Development Server</td>
          <td>Basic setup</td>
          <td>Advanced with HMR</td>
        </tr>
      </tbody>
    </table>

   <br />

    <h2>Conclusion</h2>
    <p>
      - Use <strong>create-react-app</strong> if you're new to React and want a straightforward setup with minimal decisions.<br /><br />
      - Choose <strong>Vite</strong> for faster performance, flexibility, and scalability, especially for larger or more modern applications.
    </p>
  </div>
)}


{selectedChapter === 'chapter4' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Understanding JSX (JavaScript XML) </h1>
    <div className={style.content}>
      <h2>What is JSX?</h2>
      <p>
        JSX (JavaScript XML) is a syntax extension for JavaScript that allows you to write HTML-like code within
        JavaScript. It is commonly used in React to describe the user interface's structure in a way that is both
        human-readable and closer to HTML.
      </p>
      <p>
        While JSX is not required in React, it makes the code more expressive and easier to understand, especially
        for building complex UI components.
      </p>
    <br />

      <h2 style={{paddingBottom:"6px"}}>Why Use JSX?</h2>
      <ol>
        <li>
          <strong>Declarative Syntax:</strong> JSX allows you to declare what the UI should look like, making it
          easy to visualize the structure.
        </li><br />
        <li>
          <strong>JavaScript Power:</strong> JSX enables embedding JavaScript expressions directly in your UI
          code.
        </li><br />
        <li>
          <strong>Easier Debugging:</strong> Errors in JSX are more descriptive, making debugging simpler.
        </li><br />
        <li>
          <strong>Closer to HTML:</strong> The syntax is similar to HTML, making it easier for developers familiar
          with HTML to learn and use React.
        </li>
      </ol>
    <br />

      <h2>Example of JSX</h2>
      <pre>
        <code>
{`function Welcome() {
  return (
    <div>
      <h1>Hello, World!</h1>
      <p>Welcome to React.</p>
    </div>
  );
}`}
        </code>
      </pre>
      <p>
        - <strong>JSX Syntax:</strong> The {'<div>'}, {'<h1>'}, and {'<p>'} tags look like HTML but are actually
        JSX.
        <br /><br />- <strong>JavaScript Power:</strong> You can embed JavaScript expressions inside {'{}'} within JSX.
      </p>
      <br />

      <h2>How JSX Works</h2>
      <p>
        JSX is <strong>not valid JavaScript</strong>. Before being rendered in the browser, JSX is transformed
        into regular JavaScript using tools like Babel.
      </p>
      <pre>
        <code>
{`const element = <h1>Hello, World!</h1>;
// Transformed to:
const element = React.createElement('h1', null, 'Hello, World!');`}
        </code>
      </pre>
     <br />

      <h2>JSX Rules</h2>
      <ul>
        <li>JSX must have a single parent element.</li>
        <li><br />
          Tags like {'<img />'}, {'<input />'}, and {'<br />'} must be self-closing.
        </li><br />
        <li>
          Use <code>className</code> instead of <code>class</code> for applying CSS classes.
        </li>
      </ul>
   <br />

      <h2 style={{paddingBottom:"6px"}}>Advantages of JSX</h2>
      <ul>
        <li>Readability: Easier to understand the UI structure.</li><br />
        <li>Dynamic Content: Embed JavaScript expressions for dynamic content rendering.</li><br />
        <li>Component Reusability: Easily create reusable components.</li><br />
        <li>Improved Error Detection: JSX errors are caught during the build process.</li>
      </ul>
      <br />

      <h2 style={{paddingBottom:"6px"}}>Disadvantages of JSX</h2>
      <ul>
        <li>Learning Curve: New developers may need time to understand the JSX syntax.</li><br />
        <li>Build Dependency: Requires a build tool like Babel to convert JSX into JavaScript.</li><br />
        <li>Complex Nesting: Deeply nested JSX can be hard to manage.</li>
      </ul>
     <br />

      <h2>Conclusion</h2>
      <p>
        JSX is a powerful feature of React that enhances the development experience by combining the power of
        JavaScript with the simplicity of HTML-like syntax. It simplifies the creation of complex UI structures,
        making React development more intuitive and efficient.
      </p>
    </div>
  </div>
)}


{selectedChapter === 'chapter5' && (
  <div className={style.chaptercontent}>
          <h1 className={style.heading}>Function vs. Class Components</h1>
          <p>
            React provides two primary ways to define components: <strong>Function Components</strong> and{' '}
            <strong>Class Components</strong>. Each approach has its own syntax and use cases, but function components
            are now preferred due to React's modern hooks system.
          </p>
          <br />
          <h2>1. Function Components</h2>
          <p style={{paddingBottom:"6px"}}>
            A <strong>Function Component</strong> is a JavaScript function that returns React elements. These
            components are simpler and more concise, making them the recommended approach for most use cases.
          </p>
          <h3>Syntax:</h3>
          <pre>
            <code>{`function Welcome(props) {
  return <h1>Hello, {props.name}!</h1>;
}`}</code>
          </pre><br />
          <h3 style={{paddingBottom:"6px"}}>Key Features:</h3>
          <ul>
            <li>
              <strong>Stateless or Stateful:</strong> Initially designed for stateless components. With React Hooks
              (e.g., <code>useState</code>, <code>useEffect</code>), they can manage state and lifecycle.
            </li><br />
            <li>
              <strong>No `this` Keyword:</strong> You don't need the <code>this</code> keyword to access props or
              methods.
            </li><br />
            <li>
              <strong>Hooks Support:</strong> Function components can use hooks like <code>useState</code>,{' '}
              <code>useEffect</code>, <code>useContext</code>, etc., to add state and side effects.
            </li><br />
            <li>
              <strong>Lightweight:</strong> Easier to read and write due to their simplicity.
            </li>
          </ul><br />
          <h3>Example with State (Using Hooks):</h3>
          <pre>
            <code>{`import React, { useState } from 'react';

function Counter() {
  const [count, setCount] = useState(0);

  return (
    <div>
      <p>Current count: {count}</p>
      <button onClick={() => setCount(count + 1)}>Increment</button>
    </div>
  );
}`}</code>
          </pre>
         <br />
          <h2>2. Class Components</h2>
          <p style={{paddingBottom:"6px"}}>
            A <strong>Class Component</strong> is a React component defined using a JavaScript class. They were the
            original way to manage state and lifecycle methods before hooks were introduced.
          </p>
          <h3>Syntax:</h3>
          <pre>
            <code>{`import React, { Component } from 'react';

class Welcome extends Component {
  render() {
    return <h1>Hello, {this.props.name}!</h1>;
  }
}`}</code>
          </pre>
          <h3 style={{paddingBottom:"6px"}}>Key Features:</h3>
          <ul>
            <li>
              <strong>Stateful:</strong> Class components can manage state using <code>this.state</code>.
            </li><br />
            <li>
              <strong>Lifecycle Methods:</strong> Use lifecycle methods such as <code>componentDidMount</code>,{' '}
              <code>componentDidUpdate</code>, and <code>componentWillUnmount</code> for managing side effects.
            </li><br />
            <li>
              <strong>`this` Keyword:</strong> You need to use <code>this</code> to access props, state, and methods,
              which can lead to issues with method binding.
            </li><br />
            <li>
              <strong>More Boilerplate:</strong> Typically require more code than function components.
            </li>
          </ul><br />
          <h3>Example with State and Lifecycle:</h3>
          <pre>
            <code>{`import React, { Component } from 'react';

class Counter extends Component {
  constructor(props) {
    super(props);
    this.state = { count: 0 };
  }

  increment = () => {
    this.setState({ count: this.state.count + 1 });
  };

  render() {
    return (
      <div>
        <p>Current count: {this.state.count}</p>
        <button onClick={this.increment}>Increment</button>
      </div>
    );
  }
}`}</code>
          </pre>
          <br />
          <h2>Comparison</h2>
          <table>
            <thead>
              <tr>
                <th>Feature</th>
                <th>Function Components</th>
                <th>Class Components</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Definition</td>
                <td>JavaScript function</td>
                <td>JavaScript class</td>
              </tr>
              <tr>
                <td>State Management</td>
                <td>Via hooks (<code>useState</code>)</td>
                <td>Via <code>this.state</code></td>
              </tr>
              <tr>
                <td>Lifecycle Methods</td>
                <td>Via hooks (<code>useEffect</code>)</td>
                <td>Built-in lifecycle methods</td>
              </tr>
              <tr>
                <td>Readability</td>
                <td>Concise and simple</td>
                <td>Requires more boilerplate</td>
              </tr>
              <tr>
                <td>Performance</td>
                <td>Lightweight</td>
                <td>Slightly heavier</td>
              </tr>
              <tr>
                <td>Preferred in Modern React</td>
                <td>✅ Yes</td>
                <td>❌ No (except in legacy systems)</td>
              </tr>
            </tbody>
          </table>
          <br />
          <h2>Conclusion</h2>
          <p>
            Function components, enhanced with hooks, are the modern standard in React development due to their
            simplicity and flexibility. Class components are still supported but are becoming less relevant for new
            applications. If you're starting fresh, focus on mastering function components and React hooks!
          </p>
        </div>
)}

{selectedChapter === 'chapter6' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Props in React.js</h1>

    <p>
      In React, <strong>props</strong> (short for properties) are used to pass data from one 
      component to another, typically from a parent component to a child component. They are a 
      way of making components dynamic and reusable by customizing their behavior or 
      appearance based on the values passed.
    </p>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Key Characteristics of Props</h2>
    <ol>
      <li>
        <strong>Read-Only:</strong> Props are immutable; you cannot change their value within the
        receiving component. If you need to change the data, modify it in the parent component
        and pass it down again.
      </li><br />
      <li>
        <strong>Uni-Directional Data Flow:</strong> Props follow a "top-down" data flow, meaning 
        data is passed from parent to child components.
      </li><br />
      <li>
        <strong>JavaScript Expressions:</strong> You can pass JavaScript expressions or variables
        as props using curly braces <code>{"{}"}</code>.
      </li><br />
      <li>
        <strong>Type:</strong> Props can be any data type: strings, numbers, arrays, objects, 
        functions, or even other React components.
      </li>
    </ol>

    <br />

    <h2 style={{paddingBottom:"6px"}}>Using Props</h2>

    <h3>1. Passing Props</h3>
    <pre>
      <code>
{`function ParentComponent() {
  return (
    <ChildComponent name="John" age={30} />
  );
}`}
      </code>
    </pre><br />

    <h3>2. Receiving Props</h3>
    <pre>
      <code>
{`function ChildComponent(props) {
  return (
    <div>
      <h1>Hello, {props.name}!</h1>
      <p>You are {props.age} years old.</p>
    </div>
  );
}`}
      </code>
    </pre>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Example: Props in Action</h2>

    <h3>Parent Component:</h3>
    <pre>
      <code>
{`function Greeting() {
  const user = {
    name: "Alice",
    age: 25,
  };

  return <UserCard name={user.name} age={user.age} />;
}`}
      </code>
    </pre><br />

    <h3>Child Component:</h3>
    <pre>
      <code>
{`function UserCard(props) {
  return (
    <div>
      <h2>Welcome, {props.name}!</h2>
      <p>Age: {props.age}</p>
    </div>
  );
}`}
      </code>
    </pre> <br/>



    <h2>Default Props</h2>
    <p>
      You can set default values for props in case the parent component does not provide them.
    </p>
    <pre>
      <code>
{`function Welcome(props) {
  return <h1>Hello, {props.name}!</h1>;
}

Welcome.defaultProps = {
  name: "Guest",
};`}
      </code>
    </pre>

    <br/>

    <h2>Prop Validation</h2>
    <p>
      To ensure the correct data type for props, React provides <strong>PropTypes</strong>. This is
      especially helpful for debugging.
    </p>
    <pre>
      <code>
{`import PropTypes from 'prop-types';

function UserCard(props) {
  return (
    <div>
      <h1>{props.name}</h1>
      <p>Age: {props.age}</p>
    </div>
  );
}

UserCard.propTypes = {
  name: PropTypes.string.isRequired,
  age: PropTypes.number,
};`}
      </code>
    </pre>

    <br />

    <h2>Passing Functions as Props</h2>
    <p style={{paddingBottom:"6px"}}>
      Props can also be used to pass functions, enabling parent components to control child 
      components’ behavior.
    </p>

    <h3>Parent Component:</h3>
    <pre>
      <code>
{`function Parent() {
  const showMessage = () => {
    alert("Button clicked!");
  };

  return <Child onClick={showMessage} />;
}`}
      </code>
    </pre><br />

    <h3>Child Component:</h3>
    <pre>
      <code>
{`function Child(props) {
  return <button onClick={props.onClick}>Click Me</button>;
}`}
      </code>
    </pre>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Advantages of Props</h2>
    <ul>
      <li>Enables component reusability.</li><br />
      <li>Simplifies data passing in a unidirectional flow.</li><br />
      <li>Facilitates better control over child components.</li>
    </ul><br />

 
    <h2>Conclusion</h2>
    <p>
      Props are an essential concept in React for creating dynamic and interactive components. 
      By leveraging props effectively, you can build modular and scalable React applications.
    </p>
  </div>
)}


{selectedChapter === 'chapter7' && (
  <div className={style.chaptercontent}>
   <h1 className={style.heading}> State in React</h1>

<p>
  In React.js, <strong>state</strong> refers to an object that holds data or information about the component's current situation or behavior. Each component can have its own state, and when the state changes, React automatically re-renders the component to reflect the updated data.
</p><br />

<h2 style={{paddingBottom:"6px"}}>1. State Basics:</h2>
<ul>
  <li>State is used to store dynamic data that can change over time and impact how the component renders or behaves.</li><br />
  <li>It allows components to be interactive by allowing changes in the UI based on user input, server responses, or other events.</li>
</ul><br />

<h2>2. Setting State:</h2>
<p style={{paddingBottom:"6px"}}>State is usually initialized in a component’s constructor (for class components) or directly in the function (for functional components using hooks).</p>

<h3>For <strong>Class Components</strong>:</h3>
<pre>
  {`class MyComponent extends React.Component {
constructor(props) {
super(props);
this.state = { count: 0 };
}

render() {
return <div><p>{this.state.count}</p></div>;
}
}`}
</pre><br />

<h3>For <strong>Functional Components</strong> (using <code>useState</code> hook):</h3>
<pre>
  {`import React, { useState } from 'react';

const MyComponent = () => {
const [count, setCount] = useState(0);

return <div><p>{count}</p></div>;
};`}
</pre><br />

<h2>3. Updating State:</h2>
<p style={{paddingBottom:"6px"}}>The state can be updated using the <code>setState</code> method in class components and the state updater function (like <code>setCount</code>) in functional components.</p>

<h3>For <strong>Class Components</strong>:</h3>
<pre>{`this.setState({ count: this.state.count + 1 });`}</pre><br />

<h3>For <strong>Functional Components</strong>:</h3>
<pre>{`setCount(count + 1);`}</pre><br />

<h2 style={{paddingBottom:"6px"}}>4. Why State is Important:</h2>
<ul>
  <li><strong>Dynamic behavior:</strong> State allows components to hold dynamic data and make the UI interactive.</li><br />
  <li><strong>Reactivity:</strong> When state changes, React updates the UI to reflect those changes, ensuring the UI is always in sync with the underlying data.</li><br />
  <li><strong>Encapsulation:</strong> Each component has its own state, making it easy to manage and isolate data and logic for individual components.</li>
</ul><br />

<h2 style={{paddingBottom:"6px"}}>5. State vs Props:</h2>
<ul>
  <li><strong>State</strong> is local to the component and can be changed by the component itself.</li><br />
  <li><strong>Props</strong> are read-only and are passed down from parent to child components to allow for communication between components.</li>
</ul><br />

<p>In summary, <strong>state</strong> in React enables components to manage and display dynamic data, ensuring the UI can update in response to events or changes.</p>
</div>
)}


{selectedChapter === 'chapter8' && (
  <div className={style.chaptercontent}>
     <h1 className={style.heading}>Component Lifecycle (Class Components)</h1>

<p>
  In React, <strong>Component Lifecycle</strong> refers to the sequence of methods that are invoked at different stages of a component's existence, from its creation to its removal from the DOM. For <strong>Class Components</strong>, the lifecycle is divided into three main phases: <strong>Mounting</strong>, <strong>Updating</strong>, and <strong>Unmounting</strong>. Each of these phases has specific methods that React calls automatically.
</p><br />

<h2>1. Mounting Phase:</h2>
<p style={{paddingBottom:"6px"}}>This is the phase where the component is being created and inserted into the DOM.</p>

<ul>
  <li>
    <strong>constructor(props):</strong>
    <p>This is the first method called when a component is being created. It is used to initialize state and bind methods to the component instance.</p>
   <pre><code>
      {`constructor(props) {
super(props);
this.state = { count: 0 };
}`}
    </code></pre> 
  </li><br />

  <li>
    <strong>static getDerivedStateFromProps(nextProps, nextState):</strong>
    <p>Called right before rendering, both on the initial mount and on updates. It is used to update the state based on changes in props.</p>
   <pre> <code>
      {`static getDerivedStateFromProps(nextProps, nextState) {
if (nextProps.count !== nextState.count) {
return { count: nextProps.count };
}
return null;
}`}
    </code></pre>
  </li><br />

  <li>
    <strong>render():</strong>
    <p>The required method that returns JSX for rendering the component UI.</p>
    <pre><code>
      {`render() {
return <div>{this.state.count}</div>;
}`}
    </code></pre>
  </li><br />

  <li>
    <strong>componentDidMount():</strong>
    <p>This method is called after the component is inserted into the DOM, useful for fetching data or performing setup.</p>
   <pre><code>
      {`componentDidMount() {
console.log('Component mounted!');
}`}
    </code></pre> 
  </li>
</ul><br />

<h2>2. Updating Phase:</h2>
<p style={{paddingBottom:"6px"}}>This phase occurs when a component's state or props change. React will re-render the component to reflect the changes.</p>

<ul>
  <li>
    <strong>shouldComponentUpdate(nextProps, nextState):</strong>
    <p>Used to optimize performance by determining if the component needs to re-render when props or state change.</p>
  <pre> <code>
      {`shouldComponentUpdate(nextProps, nextState) {
if (this.state.count === nextState.count) {
return false;
}
return true;
}`}
    </code></pre> 
  </li><br />

  <li>
    <strong>getSnapshotBeforeUpdate(prevProps, prevState):</strong>
    <p>This method is called right before changes from the update are flushed to the DOM.</p>
   <pre> <code>
      {`getSnapshotBeforeUpdate(prevProps, prevState) {
if (prevState.count !== this.state.count) {
return 'count changed';
}
return null;
}`}
    </code></pre>
  </li><br />

  <li>
    <strong>componentDidUpdate(prevProps, prevState, snapshot):</strong>
    <p>Called after the component has been re-rendered, useful for performing actions based on the previous props or state.</p>
    <pre><code>
      {`componentDidUpdate(prevProps, prevState, snapshot) {
if (prevState.count !== this.state.count) {
console.log('Count updated!');
}
}`}
    </code></pre>
  </li>
</ul><br />

<h2>3. Unmounting Phase:</h2>
<p>This phase occurs when a component is being removed from the DOM.</p>

<ul>
  <li>
    <strong>componentWillUnmount():</strong>
    <p>The last lifecycle method before the component is destroyed. Used for cleanup like removing event listeners or canceling network requests.</p>
    <pre><code>
      {`componentWillUnmount() {
console.log('Component will unmount!');
}`}
    </code></pre>
  </li>
</ul><br />

<h2>4. Error Handling:</h2>
<ul style={{paddingBottom:"6px"}}>
  <li>
    <strong>componentDidCatch(error, info):</strong>
    <p>Used for error boundary handling to catch JavaScript errors anywhere in the component tree.</p>
   <pre> <code>
      {`componentDidCatch(error, info) {
console.error('Error occurred:', error);
this.setState({ hasError: true });
}`}
    </code></pre>
  </li>
</ul>

<h3>Complete Example of Class Component Lifecycle:</h3><pre>
<code>
  {`import React, { Component } from 'react';

class Counter extends Component {
constructor(props) {
super(props);
this.state = { count: 0 };
console.log('Constructor: Initializing state');
}

static getDerivedStateFromProps(nextProps, nextState) {
console.log('getDerivedStateFromProps: Called');
return null;
}

shouldComponentUpdate(nextProps, nextState) {
console.log('shouldComponentUpdate: Deciding whether to re-render');
return true;
}

componentDidMount() {
console.log('componentDidMount: Component mounted');
}

getSnapshotBeforeUpdate(prevProps, prevState) {
console.log('getSnapshotBeforeUpdate: Capturing info before the update');
return null;
}

componentDidUpdate(prevProps, prevState, snapshot) {
console.log('componentDidUpdate: Component updated');
}

componentWillUnmount() {
console.log('componentWillUnmount: Cleaning up before unmounting');
}

render() {
console.log('render: Rendering the component');
return (
<div>
<h1>Count: {this.state.count}</h1>
<button onClick={() => this.setState({ count: this.state.count + 1 })}>
Increment
</button>
</div>
);
}
}

export default Counter;`}
</code></pre><br />

<h3 style={{paddingBottom:"6px"}}>Key Takeaways:</h3>
<ul>
  <li>Lifecycle methods allow you to control how components behave during their lifecycle.</li><br />
  <li>Methods like <code>shouldComponentUpdate</code> help optimize performance.</li><br />
  <li>Always use <code>componentWillUnmount</code> for cleanup tasks.</li>
</ul><br />
</div>
)}




{selectedChapter === 'chapter9' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Functional Components and Hooks</h1>

<p>
  In React, functional components and hooks provide a more modern and streamlined way to manage component state and lifecycle methods compared to class components. Let's break down the important concepts:
</p><br />

<h2>1. Functional Components</h2>
<p>
  A functional component is simply a JavaScript function that accepts props as an argument and returns JSX (React elements). They are simpler and more concise than class components.
</p>

<pre>
  <code>
    {`import React from 'react';

const Hello = () => {
return <h1>Hello, World!</h1>;
};

export default Hello;`}
  </code>
</pre><br />

<h2>2. React Hooks</h2>
<p style={{paddingBottom:"6px"}}>
  React introduced <strong>Hooks</strong> to provide functional components with the ability to manage state, handle side effects, and interact with lifecycle events. The following are some of the most commonly used hooks in React:
</p>

<h3>useState</h3>
<p>
  The <code>useState</code> hook allows you to add state to functional components. It returns an array where the first element is the current state value and the second element is a function to update that value.
</p>

<pre>
  <code>
    {`import React, { useState } from 'react';

const Counter = () => {
const [count, setCount] = useState(0);

return (
<div>
  <h1>Count: {count}</h1>
  <button onClick={() => setCount(count + 1)}>Increment</button>
</div>
);
};

export default Counter;`}
  </code>
</pre><br />

<h3>useEffect</h3>
<p>
  The <code>useEffect</code> hook is used to perform side effects in functional components. It replaces lifecycle methods like <code>componentDidMount</code>, <code>componentDidUpdate</code>, and <code>componentWillUnmount</code> in class components.
</p>

<pre>
  <code>
    {`import React, { useState, useEffect } from 'react';

const FetchData = () => {
const [data, setData] = useState(null);

useEffect(() => {
fetch('https://api.example.com/data')
  .then(response => response.json())
  .then(data => setData(data));
}, []); 

return <div>{data ? <pre>{JSON.stringify(data)}</pre> : 'Loading...'}</div>;
};

export default FetchData;`}
  </code>
</pre><br />

<h3>useRef</h3>
<p>
  The <code>useRef</code> hook is used to persist values across renders without causing re-renders. It is often used for accessing and interacting with DOM elements directly.
</p>

<pre>
  <code>
    {`import React, { useRef } from 'react';

const FocusInput = () => {
const inputRef = useRef(null);

const handleFocus = () => {
inputRef.current.focus();
};

return (
<div>
  <input ref={inputRef} type="text" />
  <button onClick={handleFocus}>Focus Input</button>
</div>
);
};

export default FocusInput;`}
  </code>
</pre><br />

<h3>useReducer</h3>
<p>
  The <code>useReducer</code> hook is an advanced alternative to <code>useState</code> for managing state. It is useful for handling more complex state logic.
</p>

<pre>
  <code>
    {`import React, { useReducer } from 'react';

const counterReducer = (state, action) => {
switch (action.type) {
case 'increment':
  return { count: state.count + 1 };
case 'decrement':
  return { count: state.count - 1 };
default:
  return state;
}
};

const Counter = () => {
const [state, dispatch] = useReducer(counterReducer, { count: 0 });

return (
<div>
  <h1>Count: {state.count}</h1>
  <button onClick={() => dispatch({ type: 'increment' })}>Increment</button>
  <button onClick={() => dispatch({ type: 'decrement' })}>Decrement</button>
</div>
);
};

export default Counter;`}
  </code>
</pre><br />

<h3>useMemo</h3>
<p>
  The <code>useMemo</code> hook is used to memoize expensive calculations or computations to avoid unnecessary recalculations on every render.
</p>

<pre>
  <code>
    {`import React, { useMemo } from 'react';

const ExpensiveComputation = ({ number }) => {
const computeFactorial = (n) => {
let result = 1;
for (let i = 2; i <= n; i++) {
  result *= i;
}
return result;
};

const factorial = useMemo(() => computeFactorial(number), [number]);

return <h1>Factorial of {number} is {factorial}</h1>;
};

export default ExpensiveComputation;`}
  </code>
</pre><br />

<h3>useCallback</h3>
<p>
  The <code>useCallback</code> hook is used to memoize callback functions, preventing them from being recreated on each render.
</p>

<pre>
  <code>
    {`import React, { useState, useCallback } from 'react';

const Button = React.memo(({ onClick }) => {
console.log('Button rendered');
return <button onClick={onClick}>Click Me</button>;
});

const Parent = () => {
const [count, setCount] = useState(0);

const increment = useCallback(() => setCount((prev) => prev + 1), []);

return (
<div>
  <h1>Count: {count}</h1>
  <Button onClick={increment} />
</div>
);
};

export default Parent;`}
  </code>
</pre><br />

<h2 style={{paddingBottom:"6px"}}>Summary</h2>
<ul>
  <li><strong>useState:</strong> Adds state to functional components.</li><br />
  <li><strong>useEffect:</strong> Handles side effects like data fetching or DOM updates.</li><br />
  <li><strong>useRef:</strong> Provides a reference to a DOM element or persistent value across renders.</li><br />
  <li><strong>useReducer:</strong> A more advanced way to manage complex state, especially with logic that depends on previous state.</li><br />
  <li><strong>useMemo:</strong> Memoizes the result of a computation to optimize performance.</li><br />
  <li><strong>useCallback:</strong> Memoizes functions to avoid unnecessary re-creations and re-renders.</li>
</ul><br />

<p>
  These hooks make functional components highly flexible and powerful, allowing you to manage state, side effects, and other features that were previously only possible in class components.
</p>
</div>
)}


{selectedChapter === 'chapter10' && (
  <div className={style.chaptercontent}>
       <h1 className={style.heading}>Event Handling in React</h1>
      <p>
        Event handling in React is similar to handling events in regular HTML, but with some important differences. In React, events are handled in a more declarative way using JSX and React's synthetic event system. Here's a breakdown of how event handling works in React:
      </p><br />

      <h2>1. Synthetic Events</h2>
      <p>
        React uses a synthetic event system, which is a cross-browser wrapper around the browser's native events. It normalizes events so that they have consistent behavior across different browsers. React’s synthetic events are pooled, meaning the event objects are reused for performance reasons, and therefore, React requires you to use <code>.persist()</code> if you want to keep the event object around after the event handler has run.
      </p><br />

      <h2>2. Event Binding in JSX</h2>
      <p style={{paddingBottom:"6px"}}>
        In React, events are specified using camelCase syntax rather than lowercase (as in traditional HTML). For example, instead of <code>onclick</code>, you would use <code>onClick</code> in JSX.
      </p>

      <h3>Example of Event Handling:</h3>
      <pre>
        {`import React, { useState } from 'react';

const ButtonComponent = () => {
  const [count, setCount] = useState(0);

  const handleClick = () => {
    setCount(count + 1);
  };

  return (
    <div>
      <button onClick={handleClick}>Click me</button>
      <p>You clicked {count} times.</p>
    </div>
  );
};

export default ButtonComponent;`}
      </pre><br />

      <h2>3. Passing Arguments to Event Handlers</h2>
      <p style={{paddingBottom:"6px"}}>
        To pass arguments to an event handler, you can use an arrow function in JSX. This ensures the correct value is passed when the event handler is triggered.
      </p>

      <h3>Example:</h3>
      <pre>
        {`import React from 'react';

const ButtonComponent = () => {
  const handleClick = (name) => {
    alert(\`Hello, \${name}!\`);
  };

  return (
    <div>
      <button onClick={() => handleClick('Alice')}>Click me</button>
    </div>
  );
};

export default ButtonComponent;`}
      </pre><br />

      <h2>4. Handling Different Events</h2>
      <p>
        React supports a variety of event types, such as:
        <ul>
          <li>Mouse events (onClick, onMouseEnter, onMouseLeave, etc.)</li><br />
          <li>Keyboard events (onKeyDown, onKeyUp, onChange, etc.)</li><br />
          <li>Form events (onSubmit, onFocus, onBlur, etc.)</li>
        </ul>
      </p><br />

      <h3>Example of Handling Multiple Event Types:</h3>
      <pre>
        {`import React, { useState } from 'react';

const FormComponent = () => {
  const [inputValue, setInputValue] = useState('');

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(\`Submitted: \${inputValue}\`);
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        value={inputValue}
        onChange={handleChange}
        placeholder="Type something"
      />
      <button type="submit">Submit</button>
    </form>
  );
};

export default FormComponent;`}
      </pre><br />

      <h2>5. Event Object</h2>
      <p style={{paddingBottom:"6px"}}>
        In React, the event handler receives an event object, which contains information about the event, such as the target element, event type, etc. This is similar to traditional JavaScript events.
      </p>

      <h3>Example:</h3>
      <pre>
        {`import React from 'react';

const MouseEventComponent = () => {
  const handleMouseEnter = (e) => {
    console.log(\`Mouse entered at: \${e.clientX}, \${e.clientY}\`);
  };

  return <div onMouseEnter={handleMouseEnter}>Hover over me!</div>;
};

export default MouseEventComponent;`}
      </pre><br />

      <h2>6. Event Handling with Class Components</h2>
      <p style={{paddingBottom:"6px"}}>
        In class components, event handling is done similarly, but you need to bind the event handlers to <code>this</code> in the constructor, or use arrow functions.
      </p>

      <h3>Example in a Class Component:</h3>
      <pre>
        {`import React, { Component } from 'react';

class ButtonComponent extends Component {
  constructor() {
    super();
    this.state = { count: 0 };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState({ count: this.state.count + 1 });
  }

  render() {
    return (
      <div>
        <button onClick={this.handleClick}>Click me</button>
        <p>You clicked {this.state.count} times.</p>
      </div>
    );
  }
}

export default ButtonComponent;`}
      </pre><br />

      <h2>7. Event Pooling in React</h2>
      <p style={{paddingBottom:"6px"}}>
        React’s synthetic events are pooled for performance reasons. This means that the event object is reused after the event handler is called. If you need to access the event object asynchronously, you should call <code>event.persist()</code> to prevent it from being pooled.
      </p>

      <h3>Example:</h3>
      <pre><code>
        {`import React from 'react';

const AsyncEventHandling = () => {
  const handleClick = (e) => {
    e.persist(); // Prevents event object from being pooled
    setTimeout(() => {
      console.log(e.type); // Access event asynchronously
    }, 1000);
  };

  return <button onClick={handleClick}>Click me</button>;
};

export default AsyncEventHandling;`}
      </code></pre><br />

      <h2 style={{paddingBottom:"6px"}}>Summary</h2>
      <ul>
        <li>In React, events are handled using <strong>camelCase</strong> naming conventions (e.g., <code>onClick</code>, <code>onChange</code>).</li><br />
        <li>React’s <strong>synthetic events</strong> provide consistent event handling across browsers.</li><br />
        <li>Event handlers can be passed to JSX elements in a declarative manner.</li><br />
        <li>You can use <strong>arrow functions</strong> to pass arguments to event handlers.</li><br />
        <li>React allows you to handle various event types like mouse, keyboard, and form events.</li><br />
        <li>React components can handle events both in <strong>functional components</strong> (with hooks) and <strong>class components</strong>.</li>
      </ul><br />

      <p>
        This structured event-handling system in React makes it easier to manage interactions within your application and ensures that events are handled efficiently and consistently.
      </p>
    </div>
)}




{selectedChapter === 'chapter11' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Conditional Rendering in React.js</h1>

<p>
  Conditional rendering in React allows you to render different UI elements based on certain conditions, such as user interactions, state changes, or props. It’s an essential concept that helps you display dynamic content in response to the app's state.
</p><br />

<p>
  In React, conditional rendering is achieved using JavaScript operators like:
  <ul>
    <li>`if` statements</li><br />
    <li>Ternary operator (`? :`)</li><br />
    <li>Logical `&&` (AND) operator</li><br />
    <li>`switch` statements</li>
  </ul>
</p><br />

<h2>1. Using if-else Statement</h2>
<p>
  You can use the traditional `if-else` statements in the render method to decide what to display.
</p>
<pre>
  <code>
    {`function Greeting(props) {
if (props.isLoggedIn) {
return <h1>Welcome back!</h1>;
} else {
return <h1>Please sign up.</h1>;
}
}`}
  </code>
</pre><br />

<h2>2. Using Ternary Operator</h2>
<p>
  The ternary operator is a concise way to handle conditional rendering within JSX. It’s helpful when you need to display one element based on a condition and another if the condition is false.
</p>
<pre>
  <code>
    {`function Greeting(props) {
return (
<h1>
{props.isLoggedIn ? 'Welcome back!' : 'Please sign up.'}
</h1>
);
}`}
  </code>
</pre>
<p>If `isLoggedIn` is `true`, "Welcome back!" will be rendered. If `isLoggedIn` is `false`, "Please sign up." will be rendered.</p>
<br />

<h2>3. Using Logical AND (`&&`) Operator</h2>
<p>
  The logical AND operator (`&&`) is useful when you want to conditionally render a component or element only when a specific condition is true.
</p>
<pre>
  <code>
    {`function Notification(props) {
return (
<div>
{props.hasNewMessages && <h2>You have new messages!</h2>}
</div>
);
}`}
  </code>
</pre>
<p>
  If `hasNewMessages` is `true`, the message "You have new messages!" will be rendered. If `hasNewMessages` is `false`, nothing will be rendered.
</p>
<br />

<h2>4. Using `switch` Statement</h2>
<p>
  A `switch` statement can also be used for more complex conditional rendering scenarios, especially when there are multiple conditions to check.
</p>
<pre>
  <code>
    {`function Status(props) {
switch (props.status) {
case 'loading':
return <h1>Loading...</h1>;
case 'success':
return <h1>Data Loaded!</h1>;
case 'error':
return <h1>Error loading data.</h1>;
default:
return <h1>Unknown status</h1>;
}
}`}
  </code>
</pre>
<p>
  Based on the value of `props.status`, different messages will be displayed.
</p><br />

<h2>5. Returning `null` for No Rendering</h2>
<p>
  Sometimes, you might want to conditionally render nothing. You can return `null` in such cases to prevent any UI from being rendered.
</p>
<pre>
  <code>
    {`function Warning(props) {
if (!props.show) {
return null; // No rendering if show is false
}
return <h1>Warning: Something went wrong!</h1>;
}`}
  </code>
</pre>

<h2 style={{paddingBottom:"6px"}}>Summary</h2>
<ul>
  <li><strong>`if` and `else`:</strong> Full conditional rendering, used in functions.</li><br />
  <li><strong>Ternary operator (`? :`):</strong> Concise and commonly used in JSX for two possible outcomes.</li><br />
  <li><strong>Logical AND (`&&`):</strong> Simple conditional rendering when you only want to display an element if the condition is `true`.</li><br />
  <li><strong>`switch` statement:</strong> Useful for multiple conditions.</li><br />
  <li><strong>`null`:</strong> Return `null` when you want nothing to render.</li>
</ul><br />

<h2 style={{paddingBottom:"6px"}}>Best Practices</h2>
<ul>
  <li><strong>Avoid too many nested conditions:</strong> It can make your code hard to read. Instead, consider splitting large components into smaller ones.</li><br />
  <li><strong>Component-based logic:</strong> Use conditional rendering to decide which component to show based on the state or props.</li>
</ul>
</div>
)}


{selectedChapter === 'chapter12' && (
  <div className={style.chaptercontent}>
      <h1 className={style.heading}>Lists and Keys in React.js</h1>

<p>
  In React, <strong>lists</strong> and <strong>keys</strong> are essential concepts when you need to display multiple items dynamically within your application. React uses <strong>keys</strong> to keep track of items in a list, ensuring efficient updates, reordering, and rendering of the list items.
</p><br />

<h2>1. Rendering Lists in React</h2>
<p style={{paddingBottom:"6px"}}>
  React allows you to render dynamic lists using the <code>map()</code> method. This is commonly used to iterate over an array and render a list of elements.
</p>

<h3>Example of Rendering a List in React:</h3>
<pre style={{paddingBottom:"6px"}}>
  <code>{`
import React from 'react';

const ListExample = () => {
const items = ['Apple', 'Banana', 'Cherry'];

return (
<ul>
{items.map((item, index) => (
  <li key={index}>{item}</li>
))}
</ul>
);
};

export default ListExample;
  `}</code>
</pre>

<p>
  In this example:
  <ul>
    <li>We have an array <code>items</code> containing strings.</li><br />
    <li>We use <code>map()</code> to iterate over the array and render each item inside an <code>&lt;li&gt;</code> element.</li><br />
    <li>Each item needs a <strong>key</strong> prop for React to track changes efficiently.</li>
  </ul>
</p><br />

<h2>2. Why Do We Need Keys?</h2>
<p style={{paddingBottom:"6px"}}>
  Keys are special props used by React to identify which items have changed, been added, or removed from a list. By providing a unique key to each list element, React can efficiently update the UI when the state of the list changes (like when items are added, deleted, or reordered).
</p>

<ul>
  <li><strong>Key importance:</strong> When items in a list are updated, React can identify which items have changed without needing to re-render the entire list. It can compare the old and new lists and only update the items that have changed.</li><br />
  <li><strong>Key uniqueness:</strong> Each key should be unique among sibling elements. Typically, you can use an item's unique id, but if no unique id is available, you can use the index of the array.</li>
</ul><br />

<h3>Example of Using Keys:</h3>
<pre style={{paddingBottom:"6px"}}>
  <code>{`
import React from 'react';

const ListWithKeys = () => {
const users = [
{ id: 1, name: 'John' },
{ id: 2, name: 'Jane' },
{ id: 3, name: 'Jim' }
];

return (
<ul>
{users.map((user) => (
  <li key={user.id}>{user.name}</li> // Use a unique \`id\` as the key
))}
</ul>
);
};

export default ListWithKeys;
  `}</code>
</pre>

<p>
  In this example:
  <ul>
    <li>Each user in the <code>users</code> array has a unique <code>id</code> that we use as the <code>key</code> for the <code>&lt;li&gt;</code> element.</li><br />
    <li>Using the unique <code>id</code> ensures React can optimize updates and re-renders efficiently when the list changes.</li>
  </ul>
</p><br />

<h2 style={{paddingBottom:"6px"}}>3. Important Points About Keys:</h2>
<ul>
  <li><strong>Keys are used for identification, not for display:</strong> The <code>key</code> prop helps React identify which list items are changed. It does not appear in the DOM or affect how the item is displayed.</li><br />
  <li><strong>Keys should be stable:</strong> A good key is something that doesn’t change between renders. For example, use an id or another unique identifier instead of the array index, which may change if the array is reordered.</li><br />
  <li><strong>Avoid using array indexes as keys in some cases:</strong> Using array indexes as keys can cause issues when elements are reordered, inserted, or removed. This can lead to performance problems and unexpected behaviors. It’s best to use a unique identifier from the data itself when possible.</li>
</ul><br />

<h2>4. Handling Dynamic Lists (Adding, Removing Items)</h2>
<p style={{paddingBottom:"6px"}}>
  When handling dynamic lists where items can be added or removed, React uses the keys to efficiently update the list.
</p>

<h3>Example of Adding and Removing List Items:</h3>
<pre style={{paddingBottom:"6px"}}>
  <code>{`
import React, { useState } from 'react';

const DynamicList = () => {
const [items, setItems] = useState(['Apple', 'Banana', 'Cherry']);

const addItem = () => {
setItems([...items, \`New Item \${items.length + 1}\`]);
};

const removeItem = () => {
const newItems = items.slice(0, -1); // Remove the last item
setItems(newItems);
};

return (
<div>
<button onClick={addItem}>Add Item</button>
<button onClick={removeItem}>Remove Item</button>
<ul>
  {items.map((item, index) => (
    <li key={index}>{item}</li>
  ))}
</ul>
</div>
);
};

export default DynamicList;
  `}</code>
</pre>

<p>
  In this example:
  <ul>
    <li><strong>Adding an item:</strong> When the "Add Item" button is clicked, a new item is added to the list using the <code>setItems</code> function.</li><br />
    <li><strong>Removing an item:</strong> When the "Remove Item" button is clicked, the last item is removed from the list.</li><br />
    <li>React efficiently updates the list because each item has a <code>key</code> prop.</li>
  </ul>
</p><br />

<h2 style={{paddingBottom:"6px"}}>Summary:</h2>
<ul>
  <li><strong>Lists in React:</strong> You can use <code>map()</code> to render lists dynamically in React.</li><br />
  <li><strong>Keys in React:</strong> Keys help React identify and track list items to optimize rendering. Each list element should have a unique <code>key</code> prop.</li><br />
  <li><strong>Key considerations:</strong> Avoid using array indices as keys when the list can change dynamically, as it can lead to performance issues and UI bugs.</li>
</ul><br />
</div>
)}




{selectedChapter === 'chapter13' && (
  <div className={style.chaptercontent}>
  <h1 className={style.heading}>Controlled vs Uncontrolled Components </h1>

<p>In React, the way you handle form elements and their values can either be <strong>controlled</strong> or <strong>uncontrolled</strong>. Understanding the difference between these two types of components is essential when building dynamic, user-interactive applications.</p><br />

<h4>1. <strong>Controlled Components</strong></h4>
<p>A <strong>controlled component</strong> is a form element whose value is controlled by the state of the React component. The value of the form element is set via React state, and any changes to the input are handled by a React event (like <code>onChange</code>).</p>
<p>In other words, React is the "single source of truth" for form values.</p><br />

<h5 style={{paddingBottom:"6px"}}>Characteristics:</h5>
<ul>
  <li><strong>State Management</strong>: The value of the input is linked to the component's state.</li><br />
  <li><strong>Two-way binding</strong>: The value of the input is always in sync with the state, and when the state changes, the input’s value is updated accordingly.</li><br />
  <li><strong>Event Handling</strong>: The input updates the state on user input through an event handler (e.g., <code>onChange</code>).</li>
</ul><br />

<h5>Example of Controlled Component:</h5>
<pre style={{paddingBottom:"6px"}}>
  <code>
    {`import React, { useState } from 'react';

const ControlledForm = () => {
const [name, setName] = useState('');

const handleInputChange = (event) => {
setName(event.target.value); // Update state with the input's value
};

return (
<div>
<label>
  Name:
  <input
    type="text"
    value={name} // Controlled by React state
    onChange={handleInputChange} // Updates state on input change
  />
</label>
<p>Your name is: {name}</p>
</div>
);
};

export default ControlledForm;`}
  </code>
</pre>

<h5 style={{paddingBottom:"6px"}}>In this example:</h5>
<ul>
  <li>The <code>value</code> of the input field is bound to the <code>name</code> state.</li><br />
  <li>Whenever the user types in the input, the <code>onChange</code> handler updates the state with the new value.</li><br />
  <li>React is always in charge of the input value, which is why it’s called a "controlled" component.</li>
</ul><br />

<h5 style={{paddingBottom:"6px"}}>Advantages of Controlled Components:</h5>
<ul>
  <li><strong>Consistency</strong>: Since React is in charge of the state, the data is always synchronized with the UI, which is easier to debug.</li><br />
  <li><strong>Validation</strong>: You can validate or manipulate the form input directly within the state handler.</li><br />
  <li><strong>Access to Data</strong>: Since the value is stored in the state, it’s easier to access, manage, and update.</li>
</ul><br />

<h5 style={{paddingBottom:"6px"}}>Disadvantages:</h5>
<ul>
  <li><strong>More Boilerplate</strong>: You need to write additional code for handling state updates and input values.</li><br />
  <li><strong>Performance</strong>: When you have many form fields, using controlled components may result in more renders, which could impact performance.</li>
</ul>
<br />
<h4>2. <strong>Uncontrolled Components</strong></h4>
<p>An <strong>uncontrolled component</strong> is a form element where the value is <strong>not</strong> controlled by React state. Instead, it is managed by the DOM itself. You can still interact with these elements, but React doesn’t directly handle their value. Instead, you use a <strong>ref</strong> (reference) to get or set the value.</p><br />

<h5 style={{paddingBottom:"6px"}}>Characteristics:</h5>
<ul>
  <li><strong>State Management</strong>: The value is managed by the DOM, not React state.</li><br />
  <li><strong>Ref Handling</strong>: You use a <code>ref</code> to interact with the DOM element directly, especially to get the current value.</li><br />
  <li><strong>No onChange</strong>: There's no need for an <code>onChange</code> handler to track the input value.</li>
</ul><br />

<h5>Example of Uncontrolled Component:</h5>
<pre style={{paddingBottom:"6px"}}>
  <code>
    {`import React, { useRef } from 'react';

const UncontrolledForm = () => {
const nameRef = useRef(); // Create a ref to directly access the input value

const handleSubmit = (event) => {
event.preventDefault();
alert(\`Your name is: \${nameRef.current.value}\`); // Access the value directly using ref
};

return (
<form onSubmit={handleSubmit}>
<label>
  Name:
  <input type="text" ref={nameRef} /> {/* Uncontrolled input */}
</label>
<button type="submit">Submit</button>
</form>
);
};

export default UncontrolledForm;`}
  </code>
</pre>

<h5>In this example:</h5>
<ul>
  <li>The <code>nameRef</code> is used to create a reference to the input element.</li><br />
  <li>Instead of using the state to manage the input’s value, we use <code>nameRef.current.value</code> to access the input value when submitting the form.</li>
</ul><br />

<h5 style={{paddingBottom:"6px"}}>Advantages of Uncontrolled Components:</h5>
<ul>
  <li><strong>Less Boilerplate</strong>: You don’t need to set up state and event handlers, which makes it simpler for basic form usage.</li><br />
  <li><strong>More Natural for DOM Interactions</strong>: If you need to work directly with the DOM or when integrating with non-React libraries, uncontrolled components may be a better choice.</li>
</ul>

<h5 style={{paddingBottom:"6px"}}>Disadvantages:</h5>
<ul>
  <li><strong>No React Control</strong>: Since React isn’t managing the value, it’s harder to perform validations, transformations, or track the input value in the UI.</li><br />
  <li><strong>No Sync with State</strong>: The input isn’t synchronized with React state, which can make it harder to use the data in the component’s logic.</li><br />
  <li><strong>Limited Features</strong>: You don’t get access to features like form validation, event handling, or conditionally enabling/disabling elements as easily as in controlled components.</li>
</ul>

<br />

<h4>3. <strong>When to Use Controlled vs Uncontrolled Components</strong></h4>
<ul>
  <li><strong>Use Controlled Components when:</strong></li>
  <ul>
    <li>You need to control form input values directly through React state.</li><br />
    <li>You need to apply validation, formatting, or transformation to user input.</li><br />
    <li>You want to perform some action (e.g., form submission, conditional rendering) based on form data.</li>
  </ul><br />
  <li><strong>Use Uncontrolled Components when:</strong></li>
  <ul>
    <li>You prefer simplicity and don’t need React to manage form values (e.g., for simple forms or integrating with non-React code).</li><br />
    <li>You are working with legacy code or integrating third-party libraries that manage the DOM.</li>
  </ul>
</ul><br />

<h3 style={{paddingBottom:"6px"}}>Summary:</h3>
<ul>
  <li><strong>Controlled Components</strong>: Form elements whose value is controlled by React state. They offer better control and synchronization, ideal for handling complex forms and validations.</li><br />
  <li><strong>Uncontrolled Components</strong>: Form elements whose value is managed by the DOM. They are simpler but lack the benefits of React’s state management and require using refs.</li>
</ul><br />

<p>Understanding when and how to use controlled vs uncontrolled components can help you make the best choice based on your application’s needs and complexity.</p>
</div>
)}

   



{selectedChapter === 'chapter14' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}> Handling Input Fields and Form Validation</h1>


<h3>1. Introduction to Forms in React</h3>
<p style={{paddingBottom:"6px"}}>Forms are essential in web applications to capture user inputs. React allows handling forms in a declarative manner by managing input field values with state.</p>



<h3 style={{paddingBottom:"6px"}}>2. Components Involved in Forms</h3>
<ul>
  <li><strong>Input Fields</strong>: Captures user data like text, numbers, and emails.</li><br />
  <li><strong>Form State</strong>: Managed with React’s <code>useState</code> hook to track input values.</li><br />
  <li><strong>Error Messages</strong>: Displayed when validation fails upon form submission.</li>
</ul>

<br />

<h3>3. Managing Form State</h3>
<p style={{paddingBottom:"6px"}}>Form elements are controlled components in React. The input field values are tied to the component’s state.</p>
<ul>
  <li><strong>State Initialization</strong>: Initialize state variables for each field (e.g., name, email).</li><br />
  <li><strong>Event Handling</strong>: Use <code>onChange</code> to update state as users input data.</li>
</ul><br />

<p><strong>Example: Managing Form State</strong></p>
<pre>
  <code>
    {`import React, { useState } from 'react';\n
    const FormComponent = () => {\n
      const [formData, setFormData] = useState({ name: '', email: '' });\n
      const handleChange = (e) => {\n
        const { name, value } = e.target;\n
        setFormData({ ...formData, [name]: value });\n
      };\n
      return (\n
        <form>\n
          <div>\n
            <label>Name:</label>\n
            <input type="text" name="name" value={formData.name} onChange={handleChange} />\n
          </div>\n
          <div>\n
            <label>Email:</label>\n
            <input type="email" name="email" value={formData.email} onChange={handleChange} />\n
          </div>\n
        </form>\n
      );\n
    };\n
    export default FormComponent;`}
  </code>
</pre>

<br />

<h3>4. Form Validation</h3>
<p style={{paddingBottom:"6px"}}>Form validation ensures the input data is valid before submission. It checks for required fields, proper formats (e.g., email), and other rules.</p>
<ul>
  <li><strong>Validation Function</strong>: Checks each input’s validity and returns error messages if necessary.</li><br />
  <li><strong>Conditional Rendering</strong>: Error messages are displayed under invalid fields.</li>
</ul><br />

<p><strong>Example: Adding Validation</strong></p>
<pre>
  <code>
    {`const validate = () => {\n
      const newErrors = {};\n
      if (!formData.name) newErrors.name = 'Name is required';\n
      if (!formData.email) newErrors.email = 'Email is required';\n
      else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Invalid email';\n
      setErrors(newErrors);\n
      return Object.keys(newErrors).length === 0;\n
    };`}
  </code>
</pre>

<br />

<h3>5. Displaying Error Messages</h3>
<p style={{paddingBottom:"6px"}}>Error messages are dynamically displayed based on the validation outcome. Each input field will show an error message when validation fails.</p>

<p><strong>Example: Error Display</strong></p>
<pre>
  <code>
    {`const [errors, setErrors] = useState({ name: '', email: '' });\n
    return (\n
      <form onSubmit={handleSubmit}>\n
        <div>\n
          <label>Name:</label>\n
          <input type="text" name="name" value={formData.name} onChange={handleChange} />\n
          {errors.name && <p style={{ color: 'red' }}>{errors.name}</p>}\n
        </div>\n
        <div>\n
          <label>Email:</label>\n
          <input type="email" name="email" value={formData.email} onChange={handleChange} />\n
          {errors.email && <p style={{ color: 'red' }}>{errors.email}</p>}\n
        </div>\n
        <button type="submit">Submit</button>\n
      </form>\n
    );`}
  </code>
</pre>

<br />

<h3>6. Handling Form Submission</h3>
<p>Upon form submission, validation is triggered. If the form is valid, the data can be processed (e.g., sent to a server).</p>

<p><strong>Example: Handling Form Submission</strong></p>
<pre>
  <code>
    {`const handleSubmit = (e) => {\n
      e.preventDefault();\n
      if (validate()) {\n
        alert('Form submitted successfully');\n
        // Submit form data to the server\n
      }\n
    };`}
  </code>
</pre>

<br />

<h3>7. Complete Form Example</h3>
<p>Here’s a complete form component that integrates state management, validation, error handling, and submission:</p>

<pre>
  <code>
    {`import React, { useState } from 'react';\n
    const FormComponent = () => {\n
      const [formData, setFormData] = useState({ name: '', email: '' });\n
      const [errors, setErrors] = useState({ name: '', email: '' });\n
      const handleChange = (e) => {\n
        const { name, value } = e.target;\n
        setFormData({ ...formData, [name]: value });\n
      };\n
      const validate = () => {\n
        const newErrors = {};\n
        if (!formData.name) newErrors.name = 'Name is required';\n
        if (!formData.email) newErrors.email = 'Email is required';\n
        else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Invalid email';\n
        setErrors(newErrors);\n
        return Object.keys(newErrors).length === 0;\n
      };\n
      const handleSubmit = (e) => {\n
        e.preventDefault();\n
        if (validate()) {\n
          alert('Form submitted successfully');\n
        }\n
      };\n
      return (\n
        <form onSubmit={handleSubmit}>\n
          <div>\n
            <label>Name:</label>\n
            <input type="text" name="name" value={formData.name} onChange={handleChange} />\n
            {errors.name && <p style={{ color: 'red' }}>{errors.name}</p>}\n
          </div>\n
          <div>\n
            <label>Email:</label>\n
            <input type="email" name="email" value={formData.email} onChange={handleChange} />\n
            {errors.email && <p style={{ color: 'red' }}>{errors.email}</p>}\n
          </div>\n
          <button type="submit">Submit</button>\n
        </form>\n
      );\n
    };\n
    export default FormComponent;`}
  </code>
</pre>

<br />

<h3>8. Conclusion</h3>
<p>In React, form handling involves managing input data through state, validating inputs, and handling errors. This allows for better control over form submissions and user interaction.</p>
</div>
)}




{selectedChapter === 'chapter15' && (
  <div className={style.chaptercontent}>
  
    <h1 className={style.heading}>Higher-Order Components (HOCs) </h1>

    <p>
      A <strong>Higher-Order Component (HOC)</strong> is a pattern in React that allows you to reuse component logic across multiple components. It is not a feature or API provided by React but a design pattern that follows the principle of <strong>"decorating" a component with additional functionality</strong>.
    </p>
    
    <p>
      HOCs are functions that take a component as an argument and return a new component with additional props, behavior, or logic. They are used to enhance or modify the behavior of the component passed to them.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Key Concepts of HOCs:</h3>
    <ul>
      <li><strong>Function as a Component Modifier</strong>: An HOC takes a component and returns a new component that enhances or modifies the original component.</li><br />
      <li><strong>Props Management</strong>: The HOC has control over the props passed to the wrapped component and can modify or add additional props.</li><br />
      <li><strong>Reusability</strong>: By using HOCs, you can create reusable logic that can be shared across multiple components without changing their structure.</li><br />
      <li><strong>Composability</strong>: Multiple HOCs can be composed together, and each one can enhance the component in different ways.</li>
    </ul><br />

    <h3>Syntax of HOC:</h3>
    <pre><code>{`const withExtraInfo = (WrappedComponent) => {
  return (props) => {
    // Adding additional props or behavior
    return <WrappedComponent {...props} extraData="Some extra data" />;
  };
};`}</code></pre><br />

    <h3>Example:</h3>
    <p>Let’s consider a simple example to understand HOCs.</p>

    <h4>Create the Base Component:</h4>
    <p>A simple <code>User</code> component that displays user data:</p>
    <pre><code>{`import React from 'react';

const User = ({ name, email }) => {
  return (
    <div>
      <h2>{name}</h2>
      <p>{email}</p>
    </div>
  );
};

export default User;`}</code></pre><br />

    <h4>Create the HOC:</h4>
    <p>Now, we create an HOC <code>withUserData</code> that adds additional functionality, such as fetching user data from an API and passing it as props to the wrapped <code>User</code> component.</p>
    <pre><code>{`import React, { useState, useEffect } from 'react';

const withUserData = (WrappedComponent) => {
  return function HOC(props) {
    const [userData, setUserData] = useState(null);

    useEffect(() => {
      // Simulating an API call
      setTimeout(() => {
        setUserData({ name: 'John Doe', email: 'john.doe@example.com' });
      }, 1000);
    }, []);

    // If data is loading, show a loading message
    if (!userData) return <p>Loading...</p>;

    return <WrappedComponent {...props} name={userData.name} email={userData.email} />;
  };
};

export default withUserData;`}</code></pre><br />

    <h4>Use the HOC to Enhance the Component:</h4>
    <p>Now, you can use the <code>withUserData</code> HOC to enhance the <code>User</code> component by wrapping it.</p>
    <pre><code>{`import React from 'react';
import withUserData from './withUserData';  // HOC
import User from './User';  // Base Component

const EnhancedUser = withUserData(User);

const App = () => {
  return (
    <div>
      <EnhancedUser />
    </div>
  );
};

export default App;`}</code></pre><br />

    <h3 style={{paddingBottom:"6px"}}>In this example:</h3>
    <ul>
      <li><code>User</code> is the base component that displays user information.</li><br />
      <li><code>withUserData</code> is the HOC that fetches user data (simulated here with <code>setTimeout</code>) and passes it as props to the <code>User</code> component.</li><br />
      <li><code>EnhancedUser</code> is the enhanced version of <code>User</code> with the additional functionality provided by the HOC.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Benefits of HOCs:</h3>
    <ul>
      <li><strong>Code Reusability</strong>: Logic such as data fetching, authentication checks, or adding event listeners can be abstracted into HOCs and reused across multiple components.</li><br />
      <li><strong>Separation of Concerns</strong>: You can separate logic (e.g., data fetching, subscriptions, or timers) from the UI components, keeping components cleaner and more focused.</li><br />
      <li><strong>Enhanced Composition</strong>: HOCs allow composing different logic pieces together in a flexible and scalable way.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Common Use Cases for HOCs:</h3>
    <ul>
      <li><strong>Authentication and Authorization</strong>: You can create an HOC to handle user authentication by checking whether the user is logged in and redirecting them if necessary.</li><br />
      <li><strong>Data Fetching</strong>: An HOC can be used to fetch data from an API and pass it down to the component as props.</li><br />
      <li><strong>Performance Optimization</strong>: An HOC can implement memoization or handle <code>shouldComponentUpdate</code> logic to prevent unnecessary re-renders.</li>
    </ul><br />

    <h3>Conclusion:</h3>
    <p>
      Higher-Order Components (HOCs) are an essential pattern for enhancing components in React. They allow you to reuse logic, improve component composition, and separate concerns within your app. By understanding and using HOCs, you can make your React applications more modular, maintainable, and scalable.
    </p>
  </div>
)}






{selectedChapter === 'chapter16' && (
  <div className={style.chaptercontent}>
     <h1 className={style.heading}>Render Props</h1>

<p>
  <strong>Render Props</strong> is a design pattern in React that allows a component to share its logic with other components by passing a function as a prop. This pattern enables a component to expose a function to its children, which the children can then invoke to render something dynamically.
</p><br />

<h3 style={{paddingBottom:"6px"}}>Key Concepts of Render Props:</h3>
<ul>
  <li>
    <strong>Render Prop</strong>: A function passed as a prop to a component, which returns a React element that the component renders.
  </li><br />
  <li>
    <strong>Dynamic Rendering</strong>: The function passed as a render prop allows a child component to dynamically render content based on the logic provided by the parent.
  </li><br />
  <li>
    <strong>Reusability</strong>: By using render props, you can share logic across multiple components without the need for inheritance or wrapping components.
  </li>
</ul><br />

<h3 style={{paddingBottom:"6px"}}>Why Use Render Props:</h3>
<ul>
  <li><strong>Sharing logic:</strong> It allows for sharing logic between components without using higher-order components (HOCs).</li><br />
  <li><strong>Dynamic rendering:</strong> Enables the ability to pass render logic down to children components, making them more flexible.</li><br />
  <li><strong>Component Composition:</strong> Allows components to be more composable by exposing the internal logic to child components.</li>
</ul><br />

<h3 style={{paddingBottom:"6px"}}>Example:</h3>

<h4>1. Create a Component with a Render Prop:</h4>
<pre>
  {`import React, { useState, useEffect } from 'react';

const MouseTracker = ({ render }) => {
const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

const handleMouseMove = (event) => {
setMousePosition({ x: event.clientX, y: event.clientY });
};

useEffect(() => {
window.addEventListener('mousemove', handleMouseMove);
return () => {
window.removeEventListener('mousemove', handleMouseMove);
};
}, []);

return render(mousePosition);
};

export default MouseTracker;`}
</pre>

<p>
  In this example, <code>MouseTracker</code> is a component that tracks the mouse position and accepts a <code>render</code> function as a prop. The <code>render</code> function receives the <code>mousePosition</code> as an argument, which allows the parent component to decide how to render the information.
</p><br />

<h4>2. Using the Render Prop in a Parent Component:</h4>
<pre>
  {`import React from 'react';
import MouseTracker from './MouseTracker';

const App = () => {
return (
<div>
<h1>Move your mouse around!</h1>
<MouseTracker
render={({ x, y }) => (
<p>
  Mouse Position: x: {x}, y: {y}
</p>
)}
/>
</div>
);
};

export default App;`}
</pre>

<p>
  In the <code>App</code> component, we pass a render function to <code>MouseTracker</code>. This render function takes the <code>mousePosition</code> (which contains <code>x</code> and <code>y</code>) and renders a <code>&lt;p&gt;</code> tag with the current mouse position.
</p><br />

<h3 style={{paddingBottom:"6px"}}>Advantages of Render Props:</h3>
<ul>
  <li><strong>Flexibility:</strong> Render props provide a flexible way for a component to pass dynamic content to its children.</li><br />
  <li><strong>Reusability:</strong> Allows you to reuse logic across multiple components without changing their structure.</li><br />
  <li><strong>Composability:</strong> You can compose multiple render props to share logic between components.</li>
</ul><br />

<h3 style={{paddingBottom:"6px"}}>When to Use Render Props:</h3>
<ul>
  <li><strong>Sharing stateful logic:</strong> When you have stateful logic that needs to be shared across different components (e.g., mouse position, API calls, etc.).</li><br />
  <li><strong>Dynamic rendering:</strong> When the component’s content changes based on the logic of another component.</li><br />
  <li><strong>Reusable component behavior:</strong> When you want to encapsulate complex behavior in a component and make it reusable by passing in the render logic as a prop.</li>
</ul><br />

<h3>Comparison with Higher-Order Components (HOCs):</h3>
<p style={{paddingBottom:"6px"}}>
  Render props and HOCs can sometimes achieve the same result, but they have different approaches:
</p>
<ul>
  <li><strong>HOCs:</strong> Wrap a component to add functionality, while <strong>render props</strong> allow for sharing functionality by passing a function.</li><br />
  <li>Render props are generally considered more flexible and can avoid some issues with HOCs, like props name collisions.</li>
</ul><br />

<h3>Conclusion:</h3>
<p>
  Render Props is a powerful pattern that allows components to share logic and provide dynamic rendering capabilities. It promotes better component composition, reusability, and flexibility in React applications. By using render props, you can separate the logic and the presentation, which enhances the maintainability of your components.
</p>
</div>
)}




{selectedChapter === 'chapter17' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>React Portals</h1>
    
    <p><strong>React Portals</strong> are a powerful feature in React that allows you to render a component outside its parent component's DOM hierarchy. This is useful when you need to render a child component in a different part of the DOM, often when dealing with things like modals, tooltips, popups, or any UI elements that should visually be placed outside their normal parent container.</p><br />

    <h2 style={{paddingBottom:"6px"}}>Key Concepts of React Portals:</h2>
    <ol>
      <li><strong>Portal</strong>: A mechanism that allows rendering a child component into a different part of the DOM tree than its parent. This allows components to visually break out of their parent container without losing their place in the component hierarchy.</li><br />
      <li><strong>`ReactDOM.createPortal()`</strong>: The method used to create a portal. It takes two arguments:
        <ul>
          <li>The first argument is the React component or JSX that you want to render.</li><br />
          <li>The second argument is the DOM node where you want the component to be rendered.</li>
        </ul>
      </li>
    </ol><br />

    <h3>Syntax:</h3>
    <pre>
      <code>
        {`ReactDOM.createPortal(child, container)`}
      </code>
    </pre>
    <ul>
      <li><strong>child</strong>: The JSX or React element that you want to render.</li><br />
      <li><strong>container</strong>: The DOM node where you want to render the child component.</li>
    </ul><br />

    <h2 style={{paddingBottom:"6px"}}>Why Use React Portals?</h2>
    <ul>
      <li><strong>DOM Structure Flexibility</strong>: Render a component outside its natural DOM hierarchy. Useful for things like modals, tooltips, or any UI element that needs to be rendered at a different location but is still part of the React component tree.</li><br />
      <li><strong>Bypassing Overflow/Positioning Issues</strong>: If a parent container has `overflow: hidden` or positioning issues that interfere with child elements, portals help render components outside of that container while maintaining the component's logical structure.</li><br />
      <li><strong>Improved Component Composition</strong>: React Portals provide a clean way to compose your application without requiring complex state management to control where content is rendered.</li>
    </ul><br />

    <h2 style={{paddingBottom:"6px"}}>Example: Using React Portals to Render a Modal</h2>

    <h3>Step 1: Create the `Modal` Component</h3>
    <pre>
      <code>
        {`import React from 'react';\nimport ReactDOM from 'react-dom';\nimport './Modal.css';\n\nconst Modal = ({ isOpen, onClose }) => {\n  if (!isOpen) return null;  // Don't render modal if it's not open\n\n  return ReactDOM.createPortal(\n    <div className="modal-overlay" onClick={onClose}>\n      <div className="modal-content" onClick={(e) => e.stopPropagation()}>\n        <h2>React Portal Modal</h2>\n        <p>This modal is rendered using React Portals.</p>\n        <button onClick={onClose}>Close</button>\n      </div>\n    </div>,\n    document.getElementById('portal-root')  // The DOM node where the modal will be rendered\n  );\n};\n\nexport default Modal;`}
      </code>
    </pre><br />

    <h3>Step 2: Use the `Modal` in a Parent Component</h3>
    <pre>
      <code>
        {`import React, { useState } from 'react';\nimport Modal from './Modal';\n\nconst App = () => {\n  const [isModalOpen, setIsModalOpen] = useState(false);\n\n  const openModal = () => setIsModalOpen(true);\n  const closeModal = () => setIsModalOpen(false);\n\n  return (\n    <div>\n      <h1>Welcome to React Portals!</h1>\n      <button onClick={openModal}>Open Modal</button>\n      <Modal isOpen={isModalOpen} onClose={closeModal} />\n    </div>\n  );\n};\n\nexport default App;`}
      </code>
    </pre><br />

    <h3>Step 3: Modify `index.html` to Add a `portal-root` Container</h3>
    <pre>
      <code>
        {`<!-- public/index.html -->\n<div id="root"></div>\n<div id="portal-root"></div> <!-- The DOM node where the modal will be rendered -->`}
      </code>
    </pre><br />

    <h2>How React Portals Work:</h2>
    <ul>
      <li>In the `Modal` component, `ReactDOM.createPortal()` is used to render the modal content into the DOM node with the ID `portal-root`. This allows the modal to break out of its parent's DOM hierarchy and be rendered directly into the `#portal-root` div.</li><br />
      <li>The modal is still part of the React component tree, and its state and behavior are fully managed by React.</li>
    </ul><br />

    <h2 style={{paddingBottom:"6px"}}>Advantages of React Portals:</h2>
    <ul>
      <li><strong>Flexibility</strong>: Portals allow rendering content outside its parent component’s DOM hierarchy, making them perfect for complex UI patterns like modals, tooltips, and dropdowns.</li><br />
      <li><strong>No CSS Interference</strong>: Portals allow you to avoid layout issues caused by parent containers, such as `overflow` or `position` constraints.</li><br />
      <li><strong>Event Propagation</strong>: Even though portals render outside the DOM hierarchy of their parent, they still participate in the React component tree, including event handling.</li><br />
      <li><strong>Component Composition</strong>: React Portals help keep the component structure clean and modular.</li>
    </ul><br />

    <h2 style={{paddingBottom:"6px"}}>When to Use React Portals:</h2>
    <ul>
      <li><strong>Modals, Tooltips, or Dropdowns</strong>: These UI elements need to break out of their parent’s layout, making portals an ideal solution.</li><br />
      <li><strong>Preventing Overflow Issues</strong>: If a parent container has restricted layout styles like `overflow: hidden` or `position: relative`, portals allow you to render components outside that container.</li><br />
      <li><strong>UI Rendered in a Different DOM Node</strong>: Portals are useful when you need to append UI components to a different section of the DOM, such as root-level UI components.</li>
    </ul><br />

    <h2>Conclusion:</h2>
    <p>React Portals are essential when you need to render components outside their natural DOM hierarchy, offering flexibility and solving common UI problems like modal positioning and escaping layout constraints.</p>
  </div>
)}



{selectedChapter === 'chapter18' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Setting Up React Router </h1>

    <p>
      Setting up React Router in a React project allows you to handle routing in a single-page application (SPA). React Router provides a way to navigate between different views (or pages) in a React app without reloading the entire page. Here's how you can set up and use React Router:
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Steps to Set Up React Router:</h3>

    <h4>1. Install React Router</h4>
    <p>
      You need to install the <code>react-router-dom</code> package to use React Router in your React application. Open your terminal and run:
    </p>
    <pre>
      <code>npm install react-router-dom</code>
    </pre><br />

    <h4 >2. Setting Up Basic Routing</h4>
    <p style={{paddingBottom:"6px"}} >
      React Router provides different components like <code>BrowserRouter</code>, <code>Route</code>, and <code>Routes</code> (replacing <code>Switch</code> in React Router v6) to configure routing in your app.
    </p>
    <p>Example for React Router v6:</p>

    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import About from './About';
import NotFound from './NotFound';

function App() {
  return (
    <Router>
      <Routes>
        {/* Define different routes and their corresponding components */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        {/* A catch-all route for undefined paths */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
`}
      </code>
    </pre>

    <p style={{paddingBottom:"6px"}}>In this example:</p>
    <ul>
      <li><strong>BrowserRouter</strong> is the wrapper component that provides routing functionality.</li><br />
      <li><strong>Routes</strong> is used to define the available routes in the app (replacing <code>Switch</code> in v6).</li><br />
      <li><strong>Route</strong> defines a path and the component that should be displayed when that path is visited.</li><br />
      <li><strong>path="*"</strong> is a catch-all route for undefined paths (404 page).</li>
    </ul><br />

    <h4 style={{paddingBottom:"6px"}}>3. Components:</h4>

    <h5>Home.js</h5>
    <pre>
      <code>
        {`import React from 'react';

function Home() {
  return <h1>Home Page</h1>;
}

export default Home;
`}
      </code>
    </pre><br />

    <h5>About.js</h5>
    <pre>
      <code>
        {`import React from 'react';

function About() {
  return <h1>About Page</h1>;
}

export default About;
`}
      </code>
    </pre><br />

    <h5>NotFound.js (404 Page)</h5>
    <pre>
      <code>
        {`import React from 'react';

function NotFound() {
  return <h1>Page Not Found</h1>;
}

export default NotFound;
`}
      </code>
    </pre><br />

    <h4>4. Navigation Between Pages</h4>
    <p>
      To navigate between different pages, you can use the <code>Link</code> or <code>NavLink</code> components instead of traditional anchor tags. This helps in preventing the full page reload and supports single-page navigation.
    </p>

    <pre>
      <code>
        {`import React from 'react';
import { Link } from 'react-router-dom';

function Navigation() {
  return (
    <nav>
      <ul>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/about">About</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navigation;
`}
      </code>
    </pre><br />

    <h4>5. Programmatic Navigation</h4>
    <p>
      You can also navigate programmatically by using the <code>useNavigate</code> hook, which is useful for navigating after certain events (like form submissions, button clicks, etc.).
    </p>

    <pre>
      <code>
        {`import React from 'react';
import { useNavigate } from 'react-router-dom';

function LoginPage() {
  const navigate = useNavigate();

  const handleLogin = () => {
    // Simulate a login action
    // After login, navigate to the home page
    navigate('/');
  };

  return (
    <div>
      <h1>Login</h1>
      <button onClick={handleLogin}>Login</button>
    </div>
  );
}

export default LoginPage;
`}
      </code>
    </pre><br />

    <h4>6. Nested Routes (Optional)</h4>
    <p>
      React Router allows you to create nested routes by using the <code>Outlet</code> component in the parent component, which renders the nested routes.
    </p>

    <pre>
      <code>
        {`// ParentComponent.js
import React from 'react';
import { Link, Outlet } from 'react-router-dom';

function ParentComponent() {
  return (
    <div>
      <nav>
        <ul>
          <li>
            <Link to="nestedPage1">Nested Page 1</Link>
          </li>
          <li>
            <Link to="nestedPage2">Nested Page 2</Link>
          </li>
        </ul>
      </nav>
      <hr />
      {/* This is where nested routes will be rendered */}
      <Outlet />
    </div>
  );
}

export default ParentComponent;

// App.js (Example of nested routing)
<Routes>
  <Route path="/" element={<Home />} />
  <Route path="parent" element={<ParentComponent />}>
    <Route path="nestedPage1" element={<NestedPage1 />} />
    <Route path="nestedPage2" element={<NestedPage2 />} />
  </Route>
  <Route path="*" element={<NotFound />} />
</Routes>
`}
      </code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Benefits of React Router:</h3>
    <ul>
      <li><strong>Single Page Application (SPA) Navigation:</strong> React Router allows you to build SPAs with navigation without reloading the page.</li><br />
      <li><strong>Declarative Routing:</strong> You can specify routes declaratively using <code>Route</code> components.</li><br />
      <li><strong>Dynamic Routing:</strong> You can define routes based on props, state, or conditions.</li><br />
      <li><strong>Nested Routes:</strong> Organize your application in a nested route structure to handle complex layouts.</li><br />
      <li><strong>Programmatic Navigation:</strong> Control navigation programmatically using hooks like <code>useNavigate</code>.</li>
    </ul><br />

    <h3>Conclusion:</h3>
    <p>
      React Router is an essential tool for handling navigation in React applications, allowing you to build dynamic, scalable, and user-friendly single-page applications. By using the <code>BrowserRouter</code>, <code>Route</code>, <code>Link</code>, and <code>useNavigate</code> components, you can set up and manage routes efficiently in React.
    </p>
  </div>
)}



{selectedChapter === 'chapter19' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Navigating Between Pages </h1>
    <p>
      React Router is a popular library for handling routing in React applications. 
      It allows developers to create dynamic, single-page applications with seamless 
      navigation between different views or pages.
    </p>
  <br />

    <h2 style={{paddingBottom:"6px"}}>Key Features of React Router</h2>
    <ul>
      <li><strong>Declarative Routing</strong>: Routes are defined declaratively using components.</li><br />
      <li><strong>Dynamic Routing</strong>: Easily manage routes based on application state or data.</li><br />
      <li><strong>Nested Routing</strong>: Support for defining routes inside other routes.</li><br />
      <li><strong>URL Parameters</strong>: Access dynamic segments of URLs.</li><br />
      <li><strong>Route Guards</strong>: Secure routes by restricting access based on conditions.</li>
    </ul>
   <br />

    <h2>Setting Up React Router</h2>
    <ol>
      <li>Install React Router using npm or yarn:
        <pre>
          <code>
            npm install react-router-dom
          </code>
        </pre>
        Or with Yarn:
        <pre>
          <code>
            yarn add react-router-dom
          </code>
        </pre>
      </li><br />
      <li>Import necessary components:
        <pre>
          <code>
            {`import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';`}
          </code>
        </pre>
      </li>
    </ol>
    <br />

    <h2>Basic Example of React Router</h2>
    <p>Here’s a simple example of navigating between two pages: Home and About.</p>

    <pre>
      <code>
        {`import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

function Home() {
  return <h2>Home Page</h2>;
}

function About() {
  return <h2>About Page</h2>;
}

function App() {
  return (
    <Router>
      <nav>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
        </ul>
      </nav>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
}

export default App;`}
      </code>
    </pre>

  <br />

    <h2 style={{paddingBottom:"6px"}}>Key Concepts</h2>
    <ul>
      <li><strong>Router</strong>: Wrap your entire application with <code>&lt;Router&gt;</code> to enable routing.</li><br />
      <li><strong>Routes</strong>: Use the <code>&lt;Routes&gt;</code> component to define all available routes.</li><br />
      <li><strong>Route</strong>: Each <code>&lt;Route&gt;</code> maps a URL path to a component.</li><br />
      <li><strong>Link</strong>: Use <code>&lt;Link&gt;</code> to navigate between pages without refreshing the browser.</li>
    </ul>
   <br />

    <h2>Navigating Programmatically</h2>
    <pre>
      <code>
        {`import { useNavigate } from 'react-router-dom';

function NavigateExample() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/about');
  };

  return <button onClick={handleClick}>Go to About Page</button>;
}`}
      </code>
    </pre>
   <br />

    <h2>Handling URL Parameters</h2>
    <pre>
      <code>
        {`import { useParams } from 'react-router-dom';

function UserProfile() {
  const { id } = useParams();
  return <h2>User ID: {id}</h2>;
}

// Usage in Routes
<Route path="/user/:id" element={<UserProfile />} />`}
      </code>
    </pre>
    <br />

    <h2>Nested Routes</h2>
    <pre>
      <code>
        {`function Dashboard() {
  return (
    <Routes>
      <Route path="analytics" element={<h2>Analytics</h2>} />
      <Route path="settings" element={<h2>Settings</h2>} />
    </Routes>
  );
}

<Route path="/dashboard/*" element={<Dashboard />} />`}
      </code>
    </pre>
   <br />

    <h2>Conclusion</h2>
    <p>
      React Router is a powerful tool for building dynamic, single-page React applications with intuitive navigation. 
      By leveraging its declarative components, hooks, and nested routing, you can create user-friendly applications 
      with ease.
    </p>
  </div>
)}


   
    {selectedChapter === 'chapter20' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Route Parameters and Query Strings</h1>
    <p>
      React Router provides powerful tools for handling dynamic segments in URLs through route parameters and query strings. 
      These features enable you to pass data through the URL, making your application more dynamic and interactive.
    </p>
   <br />

    <h2>Understanding Route Parameters</h2>
    <p style={{paddingBottom:"6px"}}>
      Route parameters allow you to define dynamic segments in your route paths. These segments are placeholders for values 
      that can be accessed in the component rendered by the route.
    </p>

    <h3>Defining a Route with Parameters</h3>
    <pre>
      <code>
        {`import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';

function UserProfile() {
  const { id } = useParams();
  return <h2>User ID: {id}</h2>;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/user/:id" element={<UserProfile />} />
      </Routes>
    </Router>
  );
}

export default App;`}
      </code>
    </pre>
    <p>In this example, the <code>:id</code> segment in the route path is replaced by the actual value when navigating.</p><br />

    <h3>Accessing Route Parameters</h3>
    <p>Use the <code>useParams</code> hook to retrieve route parameters in your components.</p>
    <pre>
      <code>
        {`const { id } = useParams();`}
      </code>
    </pre>
   <br />

    <h2>Understanding Query Strings</h2>
    <p style={{paddingBottom:"6px"}}>
      Query strings allow you to pass additional data through the URL using key-value pairs, typically appended with a <code>?</code>.
    </p>

    <h3>Accessing Query Strings</h3>
    <p>React Router provides the <code>useLocation</code> hook to access the current location, including query strings.</p>
    <pre>
      <code>
        {`import { useLocation } from 'react-router-dom';

function SearchPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const searchTerm = queryParams.get('q'); // Get the value of 'q'
  return <h2>Search Term: {searchTerm}</h2>;
}`}
      </code>
    </pre><br />

    <h3>Example: Combining Query Strings and Parameters</h3>
    <p>Here's an example of using both route parameters and query strings:</p>
    <pre>
      <code>
        {`import { BrowserRouter as Router, Routes, Route, useParams, useLocation } from 'react-router-dom';

function UserDetails() {
  const { userId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const filter = queryParams.get('filter');

  return (
    <div>
      <h2>User ID: {userId}</h2>
      <p>Filter: {filter}</p>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/user/:userId" element={<UserDetails />} />
      </Routes>
    </Router>
  );
}

export default App;`}
      </code>
    </pre>
   <br />

    <h2>Key Differences Between Route Parameters and Query Strings</h2>
    <ul>
      <li>
        <strong>Route Parameters</strong>: Part of the route path and typically used for required values 
        (e.g., <code>/user/:id</code>).
      </li><br />
      <li>
        <strong>Query Strings</strong>: Appended to the URL after a <code>?</code> and used for optional values 
        (e.g., <code>/search?q=term</code>).
      </li>
    </ul>
    <br />

    <h2>Conclusion</h2>
    <p>
      By leveraging route parameters and query strings, you can create dynamic and flexible React applications. 
      Whether you need to handle mandatory identifiers or optional filters, React Router provides tools to manage 
      these URL-based inputs seamlessly.
    </p>
  </div>
)}


{selectedChapter === 'chapter21' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Nested Routes </h1>
    <p>
      Nested Routes allow you to define routes inside other routes, enabling the creation of hierarchical and modular UI structures in your React applications.
      This is particularly useful for pages with sub-sections or complex layouts.
    </p>
  <br />

    <h2>What Are Nested Routes?</h2>
    <p>
      In React Router, nested routes let you create child routes that are rendered inside parent routes. This approach allows for better organization and reusability of components.
    </p>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Basic Example of Nested Routes</h2>
    <h3>Folder Structure</h3>
    <pre>
      <code>{`
src/
├── components/
│   ├── Dashboard.js
│   ├── Analytics.js
│   └── Settings.js
├── App.js
`}</code>
    </pre><br />

    <h3>Code Example</h3>
    <pre>
      <code>{`import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

function Dashboard() {
  return (
    <div>
      <h2>Dashboard</h2>
      <nav>
        <ul>
          <li><Link to="analytics">Analytics</Link></li>
          <li><Link to="settings">Settings</Link></li>
        </ul>
      </nav>
      <Routes>
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<Settings />} />
      </Routes>
    </div>
  );
}

function Analytics() {
  return <h3>Analytics Page</h3>;
}

function Settings() {
  return <h3>Settings Page</h3>;
}

function App() {
  return (
    <Router>
      <nav>
        <ul>
          <li><Link to="/dashboard">Dashboard</Link></li>
        </ul>
      </nav>
      <Routes>
        <Route path="/dashboard/*" element={<Dashboard />} />
      </Routes>
    </Router>
  );
}

export default App;`}</code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Explanation:</h3>
    <ul>
      <li>The <code>{ `<Dashboard />` }</code>component contains links to its child routes (`/dashboard/analytics` and `/dashboard/settings`).</li><br />
      <li>The <code>{`<Routes>`}</code> inside the <code>{ `<Dashboard />` }</code> component handle rendering child components based on the current path.</li>
    </ul>

   <br />

    <h2>Programmatically Navigating Nested Routes</h2>
    <p>Use the `useNavigate` hook to programmatically navigate within nested routes.</p>
    <pre>
      <code>{`import { useNavigate } from 'react-router-dom';

function NavigationExample() {
  const navigate = useNavigate();

  const goToSettings = () => {
    navigate('/dashboard/settings');
  };

  return <button onClick={goToSettings}>Go to Settings</button>;
}`}</code>
    </pre>

    <br />
    <h2>Example: Nested Routes with Outlet</h2>
    <p>
      The `Outlet` component acts as a placeholder for rendering child routes. This is useful when the parent route has a shared layout.
    </p>
    <pre>
      <code>{`import { Outlet, Link } from 'react-router-dom';

function Dashboard() {
  return (
    <div>
      <h2>Dashboard</h2>
      <nav>
        <ul>
          <li><Link to="analytics">Analytics</Link></li>
          <li><Link to="settings">Settings</Link></li>
        </ul>
      </nav>
      <Outlet />
    </div>
  );
}`}</code>
    </pre>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for Nested Routes</h2>
    <ul>
      <li>Keep routes modular by defining them close to their respective components.</li><br />
      <li>Use relative paths to define child routes for better readability and maintainability.</li><br />
      <li>Combine nested routing with layouts to avoid repetitive code.</li>
    </ul>

   <br />

    <h2>Conclusion</h2>
    <p>
      Nested routes in React Router are a powerful way to organize and structure your application. By defining routes hierarchically and using tools like the `Outlet` component, you can create dynamic and scalable applications with ease.
    </p>
  </div>
)}



{selectedChapter === 'chapter22' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Redirects and Navigation Guards</h1>

    <section>
      <p>
        <strong>Redirects</strong> and <strong>Navigation Guards</strong> are essential for controlling user navigation in a React application. They enable redirection to appropriate routes and restrict access to specific parts of the application based on conditions such as authentication or permissions.
      </p>
    </section>

   <br />

    <section>
      <h2>What Are Redirects?</h2>
      <p>
        Redirects automatically send users from one route to another. In React Router v6, redirects are implemented using the <code>{'<Navigate>'}</code> component.
      </p>
      <h3>Basic Example of Redirects</h3>
      <pre>
        <code>
{`import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

function App() {
  const isLoggedIn = false;

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/dashboard"
          element={isLoggedIn ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route path="/login" element={<Login />} />
      </Routes>
    </Router>
  );
}

function Home() {
  return <h2>Home Page</h2>;
}

function Dashboard() {
  return <h2>Dashboard</h2>;
}

function Login() {
  return <h2>Login Page</h2>;
}

export default App;`}
        </code>
      </pre>
      <p>
        <strong>Explanation:</strong>
        <ol>
          <li>If the user is not logged in (<code>isLoggedIn === false</code>), navigating to <code>/dashboard</code> redirects them to the <code>/login</code> route.</li><br />
          <li>The <code>{'<Navigate>'}</code> component replaces the old <code>{'<Redirect>'}</code> from React Router v5.</li>
        </ol>
      </p>
    </section>

  <br />

    <section>
      <h2>What Are Navigation Guards?</h2>
      <p>
        Navigation Guards restrict or control access to specific routes based on conditions like:
      </p>
      <ul>
        <li>Authentication state</li><br />
        <li>User roles or permissions</li><br />
        <li>Any other custom logic</li>
      </ul><br />
      <h3>Using Custom Navigation Guards</h3>
      <pre>
        <code>
{`import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

function ProtectedRoute({ element: Component, isAuthenticated, ...rest }) {
  return isAuthenticated ? <Component {...rest} /> : <Navigate to="/login" />;
}

function App() {
  const isLoggedIn = false;

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/dashboard"
          element={<ProtectedRoute element={Dashboard} isAuthenticated={isLoggedIn} />}
        />
        <Route path="/login" element={<Login />} />
      </Routes>
    </Router>
  );
}

function Home() {
  return <h2>Home Page</h2>;
}

function Dashboard() {
  return <h2>Dashboard</h2>;
}

function Login() {
  return <h2>Login Page</h2>;
}

export default App;`}
        </code>
      </pre>
      <p>
        <strong style={{paddingBottom:"6px"}}>Explanation:</strong>
        <ol>
          <li>The <code>ProtectedRoute</code> component checks whether the user is authenticated.</li><br />
          <li>If <code>isAuthenticated</code> is <code>false</code>, the user is redirected to <code>/login</code>.</li><br />
          <li>Otherwise, the protected component (e.g., <code>Dashboard</code>) is rendered.</li>
        </ol>
      </p>
    </section>

   <br />

    <section>
      <h2>Programmatic Navigation</h2>
      <p>
        React Router provides the <code>useNavigate</code> hook for programmatically navigating between routes.
      </p>
      <pre>
        <code>
{`import { useNavigate } from 'react-router-dom';

function Login() {
  const navigate = useNavigate();

  const handleLogin = () => {
    // Simulate login logic
    const isAuthenticated = true;

    if (isAuthenticated) {
      navigate('/dashboard');
    }
  };

  return (
    <div>
      <h2>Login Page</h2>
      <button onClick={handleLogin}>Login</button>
    </div>
  );
}`}
        </code>
      </pre>
      <p>
        <strong>Explanation:</strong> After logging in, the user is navigated to the <code>/dashboard</code> route using the <code>navigate</code> function.
      </p>
    </section>

  <br />

    <section>
      <h2 style={{paddingBottom:"6px"}}>Best Practices for Redirects and Navigation Guards</h2>
      <ul>
        <li><strong>Centralize Authentication Logic:</strong> Store authentication state in a global context or state management library (e.g., Redux).</li><br />
        <li><strong>Minimize Redundancy:</strong> Use reusable components like <code>ProtectedRoute</code> to simplify code.</li><br />
        <li><strong>Graceful Redirects:</strong> Preserve the destination route (e.g., redirect to <code>/dashboard</code> after logging in).</li><br />
        <li><strong>Handle Edge Cases:</strong> Test for invalid paths, expired sessions, and unauthorized access.</li>
      </ul><br />
    </section>

    

    <section>
      <h2>Conclusion</h2>
      <p>
        Redirects and navigation guards are fundamental tools for creating secure and user-friendly React applications. They ensure users are guided to the correct pages while protecting sensitive areas of your app. By combining <code>{'<Navigate>'}</code>, <code>useNavigate</code>, and custom guard components, you can achieve seamless and secure navigation in your React applications.
      </p>
    </section>
  </div>
)}




{selectedChapter === 'chapter23' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>
      Context API: Creating and Using Context, Updating Context Values
    </h1>

    <p>
      The <strong>Context API</strong> is a powerful feature in React for managing state
      globally, allowing data to be shared across components without explicitly
      passing props. It’s an excellent solution for prop-drilling problems in
      medium to large applications.
    </p>

 <br />

    <h2>1. What is Context API?</h2>
    <p style={{paddingBottom:"6px"}}>
      The Context API provides a way to share values (state or data) between
      components without passing props explicitly down the component tree.
    </p>
    <ul>
      <li>
        It creates a <strong>context object</strong> using <code>React.createContext()</code>.
      </li><br />
      <li>This object provides two components:</li>
      <ul>
        <li>
          <strong>Provider:</strong> Supplies the context value to child components.
        </li><br />
        <li>
          <strong>Consumer:</strong> Accesses the context value from the nearest Provider.
        </li>
      </ul>
    </ul>
<br />

    <h2 style={{paddingBottom:"6px"}}>2. Creating and Using Context</h2>
    <h3>Basic Example: Creating Context</h3>
    <pre>
      <code>
        {`
import React, { createContext, useContext } from 'react';

// Step 1: Create the context
const UserContext = createContext();

// Step 2: Create a provider component
function UserProvider({ children }) {
  const user = { name: 'John Doe', age: 30 };
  return (
    <UserContext.Provider value={user}>
      {children}
    </UserContext.Provider>
  );
}

// Step 3: Consume the context in a child component
function UserProfile() {
  const user = useContext(UserContext);
  return (
    <div>
      <h2>User Profile</h2>
      <p>Name: {user.name}</p>
      <p>Age: {user.age}</p>
    </div>
  );
}

// Step 4: Use the provider in the app
function App() {
  return (
    <UserProvider>
      <UserProfile />
    </UserProvider>
  );
}

export default App;
        `}
      </code>
    </pre><br />

    <h3>Explanation</h3>
    <ol>
      <li>
        <code>createContext</code> initializes the context object.
      </li><br />
      <li>
        <code>UserProvider</code> wraps its children in the context's
        <code>Provider</code> and supplies a <code>value</code>.
      </li><br />
      <li>
        <code>useContext</code> hook retrieves the context value in
        <code>UserProfile</code>.
      </li>
    </ol>

 <br />

    <h2>3. Updating Context Values</h2>
    <p style={{paddingBottom:"6px"}}>
      To update the context, you typically manage state inside the Provider and
      expose a function to update the state.
    </p>

    <h3>Example: Updating Context Values</h3>
    <pre>
      <code>
        {`
import React, { createContext, useContext, useState } from 'react';

// Step 1: Create the context
const ThemeContext = createContext();

// Step 2: Create a provider component
function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('light');

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

// Step 3: Consume the context in a child component
function ThemeSwitcher() {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <div>
      <h2>Current Theme: {theme}</h2>
      <button onClick={toggleTheme}>Toggle Theme</button>
    </div>
  );
}

// Step 4: Use the provider in the app
function App() {
  return (
    <ThemeProvider>
      <ThemeSwitcher />
    </ThemeProvider>
  );
}

export default App;
        `}
      </code>
    </pre>

    <h3 style={{paddingBottom:"6px"}}>Explanation</h3>
    <ol>
      <li>
        <code>useState</code> manages the context's state (<code>theme</code>).
      </li><br />
      <li>
        <code>toggleTheme</code> is a function to update the context value.
      </li><br />
      <li>
        <code>ThemeSwitcher</code> uses <code>useContext</code> to access and
        interact with the context.
      </li>
    </ol>

  <br />

    <h2 style={{paddingBottom:"6px"}}>4. Best Practices for Using Context API</h2>
    <ul>
      <li>
        <strong>Avoid Overusing Context:</strong> Use it sparingly for state truly
        shared globally. For local state, stick to <code>useState</code> or
        <code>useReducer</code>.
      </li><br />
      <li>
        <strong>Combine with Reducers:</strong> For complex state logic, integrate
        the Context API with <code>useReducer</code>.
      </li><br />
      <li>
        <strong>Split Contexts:</strong> Create separate contexts for different
        types of data to avoid unnecessary re-renders.
      </li><br />
      <li>
        <strong>Default Values:</strong> Always define meaningful default values
        when creating a context.
      </li>
    </ul>

   <br />

    <h2>5. Common Use Cases</h2>
    <ul>
      <li>Managing <strong>themes</strong> (light/dark mode).</li><br />
      <li>
        User authentication (sharing user info across the app).
      </li><br />
      <li>Global language or localization settings.</li>
    </ul>

    <br />

    <h2>Conclusion</h2>
    <p>
      The Context API is a powerful and flexible way to manage global state in
      React applications. By combining it with React hooks like <code>useState</code>,
      <code>useContext</code>, and <code>useReducer</code>, you can efficiently
      handle state, avoid prop drilling, and create a seamless user experience.
    </p>
  </div>
)}







{selectedChapter === 'chapter24' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>     
      Redux
    </h1>

    <p>
      <strong>Redux</strong> is a predictable state management library for JavaScript applications. It is commonly used with React for managing application-level state in a more structured and scalable way.
    </p>

    <br />

    <h2 style={{paddingBottom:"6px"}}>1. Key Concepts in Redux</h2>
    <ul>
      <li>
        <strong>Actions:</strong> Plain JavaScript objects that describe what you want to do. Each action must have a <code>type</code> property.
      </li><br />
      <li>
        <strong>Reducers:</strong> Functions that specify how the state changes in response to actions.
      </li><br />
      <li>
        <strong>Store:</strong> A single source of truth that holds the entire state of the application.
      </li>
    </ul>

   <br />

    <h2 style={{paddingBottom:"6px"}}>2. Creating a Basic Redux Setup</h2>

    <h3>Step 1: Install Redux</h3>
    <pre>
      <code>npm install redux react-redux</code>
    </pre><br />

    <h3>Step 2: Define Actions</h3>
    <pre>
      <code>
{`
// actions.js
export const increment = () => ({
  type: 'INCREMENT',
});

export const decrement = () => ({
  type: 'DECREMENT',
});
`}
      </code>
    </pre><br />

    <h3>Step 3: Create Reducers</h3>
    <pre>
      <code>
{`
// reducers.js
const initialState = { count: 0 };

const counterReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INCREMENT':
      return { ...state, count: state.count + 1 };
    case 'DECREMENT':
      return { ...state, count: state.count - 1 };
    default:
      return state;
  }
};

export default counterReducer;
`}
      </code>
    </pre><br />

    <h3>Step 4: Create the Redux Store</h3>
    <pre>
      <code>
{`
// store.js
import { createStore } from 'redux';
import counterReducer from './reducers';

const store = createStore(counterReducer);

export default store;
`}
      </code>
    </pre>

   <br />

    <h2 style={{paddingBottom:"6px"}}>3. Connecting React with Redux</h2>

    <h3>Using <code>react-redux</code></h3>
    <p style={{paddingBottom:"6px"}}>
      The <strong>react-redux</strong> library provides a way to connect Redux with React components using the <code>Provider</code> and <code>useSelector</code>, <code>useDispatch</code> hooks.
    </p>

    <h3>Step 1: Provide the Store</h3>
    <pre>
      <code>
{`
// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
`}
      </code>
    </pre><br />

    <h3>Step 2: Access State and Dispatch Actions</h3>
    <pre>
      <code>
{`
// Counter.js
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { increment, decrement } from './actions';

function Counter() {
  const count = useSelector((state) => state.count);
  const dispatch = useDispatch();

  return (
    <div>
      <h1>Counter: {count}</h1>
      <button onClick={() => dispatch(increment())}>Increment</button>
      <button onClick={() => dispatch(decrement())}>Decrement</button>
    </div>
  );
}

export default Counter;
`}
      </code>
    </pre>

  <br />

    <h2>4. Redux Middleware</h2>
    <p style={{paddingBottom:"6px"}}>
      Middleware in Redux allows you to perform side effects such as asynchronous tasks. Two popular middlewares are <strong>Thunk</strong> and <strong>Saga</strong>.
    </p>

    <h3>Using Redux Thunk</h3>
    <pre>
      <code>
{`
// store.js
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import counterReducer from './reducers';

const store = createStore(counterReducer, applyMiddleware(thunk));
export default store;

// actions.js
export const fetchData = () => {
  return async (dispatch) => {
    const response = await fetch('https://api.example.com/data');
    const data = await response.json();
    dispatch({ type: 'SET_DATA', payload: data });
  };
};
`}
      </code>
    </pre><br />

    <h3>Using Redux Saga</h3>
    <pre>
      <code>
{`
// store.js
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import counterReducer from './reducers';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();
const store = createStore(counterReducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);
export default store;

// sagas.js
import { call, put, takeEvery } from 'redux-saga/effects';

function* fetchDataSaga() {
  try {
    const response = yield call(fetch, 'https://api.example.com/data');
    const data = yield response.json();
    yield put({ type: 'SET_DATA', payload: data });
  } catch (error) {
    console.error(error);
  }
}

export default function* rootSaga() {
  yield takeEvery('FETCH_DATA', fetchDataSaga);
}
`}
      </code>
    </pre>

   <br />

    <h2 style={{paddingBottom:"6px"}}>5. Best Practices</h2>
    <ul>
      <li>Keep actions and reducers modular and reusable.</li><br />
      <li>Use middleware for asynchronous tasks and side effects.</li><br />
      <li>Structure your application for scalability by splitting logic into small files.</li>
    </ul><br />

    

    <h2>Conclusion</h2>
    <p>
      Redux is a robust state management library that, when combined with middleware like Thunk or Saga, allows developers to handle complex state logic and side effects efficiently in React applications.
    </p>
  </div>
)}




{selectedChapter === 'chapter25' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>State Management Libraries: Zustand MobX Recoil</h1>

    <p>
      State management in React is crucial for managing application data, especially as apps grow in complexity. While React provides its own built-in state management with hooks like `useState` and `useReducer`, many developers turn to state management libraries to handle global state more efficiently. Let's explore three popular libraries for state management in React: <strong>Zustand</strong>, <strong>MobX</strong>, and <strong>Recoil</strong>.
    </p>

   <br />

    <h2>1. Zustand</h2>
    <p style={{paddingBottom:"6px"}}><strong>Overview:</strong> Zustand is a small, fast, and scalable state management library for React. It offers a simple API for managing state and does not require context providers or React hooks, making it easy to integrate.</p>
    <ul>
      <li><strong>Minimal API:</strong> Provides simple and direct access to the state.</li><br />
      <li><strong>No Provider Required:</strong> Unlike Context API-based solutions, Zustand works without wrapping components in providers.</li><br />
      <li><strong>Asynchronous State Updates:</strong> Zustand supports async actions out of the box, making it easier to manage side effects.</li><br />
      <li><strong>Efficient Updates:</strong> Zustand relies on a subscription-based model for efficient re-renders, meaning only components that depend on specific state slices re-render.</li>
    </ul><br />

    <p><strong>Example Usage:</strong></p>
    <pre>
      <code>
        {`import create from 'zustand';

const useStore = create((set) => ({
  count: 0,
  increase: () => set((state) => ({ count: state.count + 1 })),
}));

const Counter = () => {
  const { count, increase } = useStore();
  return (
    <div>
      <p>{count}</p>
      <button onClick={increase}>Increment</button>
    </div>
  );
};`}
      </code>
    </pre>

    <br />

    <h2>2. MobX</h2>
    <p style={{paddingBottom:"6px"}}><strong>Overview:</strong> MobX is a state management library that leverages reactive programming concepts to manage the state in React. It automatically tracks dependencies and re-renders components when the state changes.</p>
    <ul>
      <li><strong>Automatic Reactions:</strong> MobX tracks which components depend on which pieces of state, reducing the need for manual state updates.</li><br />
      <li><strong>Mutable State:</strong> Unlike some state management libraries that enforce immutability, MobX allows state mutations directly.</li><br />
      <li><strong>Computed Values:</strong> You can define computed values that automatically update based on reactive state changes.</li><br />
      <li><strong>Ease of Integration:</strong> MobX integrates easily into React and offers decorators for cleaner syntax (though it is optional).</li>
    </ul><br />

    <p><strong>Example Usage:</strong></p>
    <pre>
      <code>
        {`import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';

class Counter {
  count = 0;
  constructor() {
    makeAutoObservable(this);
  }
  increase() {
    this.count += 1;
  }
}

const counter = new Counter();

const CounterComponent = observer(() => (
  <div>
    <p>{counter.count}</p>
    <button onClick={() => counter.increase()}>Increment</button>
  </div>
));`}
      </code>
    </pre>

   <br />
    <h2>3. Recoil</h2>
    <p style={{paddingBottom:"6px"}}><strong>Overview:</strong> Recoil is a state management library developed by Facebook to provide a more flexible and scalable solution for managing global state in React. It focuses on providing fine-grained control over state and allows for better concurrency handling.</p>
    <ul>
      <li><strong>Atoms and Selectors:</strong> Atoms represent units of state, and selectors are derived values that can compute new state based on existing atoms.</li><br />
      <li><strong>Concurrent Mode Support:</strong> Recoil integrates well with React's Concurrent Mode, ensuring non-blocking UI updates.</li><br />
      <li><strong>Global and Local State Management:</strong> You can manage both global state and local component-level state with Recoil.</li><br />
      <li><strong>Persistence:</strong> It allows state persistence across reloads, providing an easy way to keep the app state intact.</li>
    </ul><br />

    <p><strong>Example Usage:</strong></p>
    <pre>
      <code>
        {`import { atom, useRecoilState } from 'recoil';

const countState = atom({
  key: 'countState',
  default: 0,
});

const Counter = () => {
  const [count, setCount] = useRecoilState(countState);
  return (
    <div>
      <p>{count}</p>
      <button onClick={() => setCount(count + 1)}>Increment</button>
    </div>
  );
};`}
      </code>
    </pre>

    <br />

    <h2>Choosing the Right State Management Library</h2>
    <p>
      <strong>Zustand</strong> is a great option if you prefer a minimalistic and flexible API with high performance and no need for a React provider. It's ideal for smaller applications or when you want direct access to state management without additional boilerplate.
    </p><br />
    <p>
      <strong>MobX</strong> is suitable for developers looking for a highly reactive state management solution with automatic state tracking and mutation. It is particularly useful for large applications where you want state changes to propagate automatically without excessive re-renders.
    </p><br />
    <p>
      <strong>Recoil</strong> shines when you need fine-grained control over state, including complex derived state and async interactions. It works well in larger applications, especially with React's concurrent rendering features.
    </p><br />

    <p>Each library has its strengths, and the choice depends on your app's complexity, performance needs, and the development experience you're aiming for.</p>
  </div>
)}




{selectedChapter === 'chapter26' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>CSS Modules</h1>

    <p>
      In React.js, styling is a crucial aspect of creating an engaging user interface. While there are various methods for styling React components, one of the most effective and scoped approaches is using **CSS Modules**. This method provides a way to write CSS that is scoped locally to a component, helping avoid global namespace collisions and improving maintainability.
    </p>

 <br />

    <h2>What are CSS Modules?</h2>
    <p style={{paddingBottom:"6px"}}>
      CSS Modules allow you to write CSS that is scoped only to the component where it's used. Each class name is automatically scoped to the local component, ensuring styles are not accidentally applied to other components. This approach solves the problem of global namespace conflicts that often arise when using traditional CSS.
    </p>

    <p>
      Unlike traditional CSS where class names are global, CSS Modules generate unique class names, so you don't have to worry about conflicting styles between components.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Key Features of CSS Modules</h3>
    <ul>
      <li><strong>Local Scoping:</strong> Each CSS class is scoped locally to the component where it is imported.</li><br />
      <li><strong>Unique Class Names:</strong> Automatically generates unique class names to avoid conflicts.</li><br />
      <li><strong>No Global Styles:</strong> Styles are confined to the component and do not leak globally.</li><br />
      <li><strong>Automatic Hashing:</strong> Class names are automatically hashed to ensure uniqueness.</li>
    </ul>

   <br />

    <h2>Setting Up CSS Modules in React</h2>
    <p style={{paddingBottom:"6px"}}>
      To use CSS Modules in a React project, ensure you're using a bundler like Webpack, which supports the CSS Modules syntax. If you're using Create React App (CRA), CSS Modules are supported out of the box.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Steps for Using CSS Modules</h3>
    <ol>
      <li>Create a CSS file with the `.module.css` extension (e.g., <code>Button.module.css</code>).</li><br />
      <li>Import the CSS file into your React component.</li><br />
      <li>Use the imported styles object to apply classes to your JSX elements.</li>
    </ol><br />

    <h4>Example: Using CSS Modules</h4>
    <pre>
      <code>
        {`// Button.module.css
.button {
  background-color: blue;
  color: white;
  padding: 10px;
  border-radius: 5px;
}

// Button.js (React component)
import React from 'react';
import styles from './Button.module.css';

const Button = () => {
  return (
    <button className={styles.button}>Click Me</button>
  );
};

export default Button;`}
      </code>
    </pre>

    <p>
      In the example above, the class name `.button` in the CSS file is automatically scoped to the Button component, so it won't interfere with other components.
    </p>

    <br />

    <h2 style={{paddingBottom:"6px"}}>Advantages of Using CSS Modules</h2>
    <ul>
      <li><strong>Encapsulation:</strong> Styles are encapsulated at the component level, reducing the chance of style leakage.</li><br />
      <li><strong>Maintainability:</strong> Easier to maintain styles for individual components without affecting the global styles.</li><br />
      <li><strong>Readability:</strong> Clear separation of concerns between JSX and styles, leading to more readable and modular code.</li>
    </ul>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Limitations of CSS Modules</h2>
    <ul>
      <li><strong>Global Styles:</strong> You still need to rely on global styles for things like resets or shared utility classes.</li><br />
      <li><strong>Learning Curve:</strong> For developers new to CSS Modules, there may be a slight learning curve when it comes to organizing styles across large projects.</li>
    </ul>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for Using CSS Modules</h2>
    <ul>
      <li><strong>Consistent Naming:</strong> Use consistent naming conventions to make it easy to organize and understand the styles (e.g., <code>ComponentName.module.css</code>).</li><br />
      <li><strong>Separate Styles by Component:</strong> Store the CSS for each component in its own CSS Module file to keep it modular.</li><br />
      <li><strong>Reusability:</strong> While CSS Modules are scoped, you can still reuse styles by creating shared utility classes or design tokens.</li>
    </ul><br />

    <p>
      CSS Modules provide a robust solution for writing scoped, maintainable, and modular CSS in React components. By using this technique, you can prevent many common styling issues and improve the development process, especially in larger applications.
    </p>
  </div>
)}



{selectedChapter === 'chapter27' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Styled Components</h1>

    <p>
      Styled Components is a popular library for styling React applications using tagged template literals and CSS-in-JS. It allows you to write traditional CSS, but scoped directly to components, resulting in a more modular and maintainable codebase. This approach is ideal for styling React components without worrying about class name collisions or managing global styles.
    </p>

   <br />

    <h2>What are Styled Components?</h2>
    <p>
      Styled Components allows you to write CSS styles directly within your JavaScript files, defining styles as JavaScript objects. These styles are then automatically scoped to the component in which they are defined, making it easy to manage component-specific styles without worrying about global CSS conflicts.
    </p>

    <p>
      One of the key benefits is that you can take advantage of JavaScript’s dynamic nature within your styles, such as using props to control style values, making your components more flexible and reusable.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Key Features of Styled Components</h3>
    <ul>
      <li><strong>CSS-in-JS:</strong> Write traditional CSS syntax in JavaScript, enhancing the developer experience.</li><br />
      <li><strong>Scoped Styles:</strong> Styles are scoped to the component, preventing conflicts between components.</li><br />
      <li><strong>Dynamic Styles:</strong> Use props and JavaScript variables to dynamically change styles.</li><br />
      <li><strong>Theming:</strong> Easily define a global theme and apply it across your application.</li><br />
      <li><strong>Automatic Vendor Prefixing:</strong> Styled Components automatically adds vendor prefixes to CSS properties when necessary.</li>
    </ul><br />

   

    <h2>Setting Up Styled Components</h2>
    <p style={{paddingBottom:"6px"}}>
      To start using Styled Components in your React project, you first need to install the library. You can do this via npm or yarn.
    </p>

    <h3>Installation</h3>
    <pre>
      <code>
        {`npm install styled-components`}
      </code>
    </pre>
    <p>
      Once installed, you can start using Styled Components by importing the library into your React component files.
    </p><br />

    <h3>Example Usage</h3>
    <pre>
      <code>
        {`import styled from 'styled-components';

// Create a styled button
const Button = styled.button\`
  background-color: blue;
  color: white;
  padding: 10px;
  border-radius: 5px;
  &:hover {
    background-color: darkblue;
  }
\`;

// Using the styled button in a component
const MyComponent = () => {
  return <Button>Click Me</Button>;
};`}
      </code>
    </pre>

    <p>
      In the example above, we created a styled button using the `styled.button` function. The styles are written in regular CSS syntax, and the button is used as a React component.
    </p>

   <br />

    <h2>Dynamic Styling with Props</h2>
    <p style={{paddingBottom:"6px"}}>
      Styled Components allows you to change styles dynamically by passing props to your styled component. This enables more flexible and reusable components, as you can adjust their appearance based on the props received.
    </p>

    <h3>Example of Dynamic Styling</h3>
    <pre>
      <code>
        {`const Button = styled.button\`
  background-color: \${props => props.primary ? 'blue' : 'gray'};
  color: white;
  padding: 10px;
  border-radius: 5px;
  &:hover {
    background-color: \${props => props.primary ? 'darkblue' : 'darkgray'};
  }
\`;

// Usage with different props
const MyComponent = () => {
  return (
    <div>
      <Button primary>Primary Button</Button>
      <Button>Secondary Button</Button>
    </div>
  );
};`}
      </code>
    </pre>

    <p>
      In this example, we conditionally change the background color of the button based on whether the `primary` prop is passed. This makes the component more flexible and reusable in different contexts.
    </p>

   <br />

    <h2>Theming with Styled Components</h2>
    <p style={{paddingBottom:"6px"}}>
      Styled Components supports theming out of the box, which allows you to define a set of styles that can be reused throughout your application. Theming helps create consistent UI across your app and makes it easier to manage global styles like colors and fonts.
    </p>

    <h3>Example of Theming</h3>
    <pre>
      <code>
        {`import { ThemeProvider } from 'styled-components';

// Define a theme
const theme = {
  primaryColor: 'blue',
  secondaryColor: 'gray',
};

// Create a styled component that uses the theme
const Button = styled.button\`
  background-color: \${props => props.theme.primaryColor};
  color: white;
  padding: 10px;
  border-radius: 5px;
\`;

// App component with ThemeProvider
const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Button>Click Me</Button>
    </ThemeProvider>
  );
};`}
      </code>
    </pre>

    <p>
      In this example, we used the `ThemeProvider` to inject a theme into the app. The `Button` component uses the `primaryColor` defined in the theme to style the button.
    </p>

    <br />

    <h2 style={{paddingBottom:"6px"}}>Advantages of Using Styled Components</h2>
    <ul>
      <li><strong>Component-Level Styles:</strong> Styles are scoped to components, preventing style conflicts and making components more modular.</li><br />
      <li><strong>Dynamic Styling:</strong> Easily pass props to control styles, enabling reusable components with different appearances.</li><br />
      <li><strong>Theming Support:</strong> Use global themes to maintain consistent design across the app.</li><br />
      <li><strong>Maintainability:</strong> Writing CSS in JavaScript helps keep styles closely tied to the components, making it easier to refactor and maintain.</li>
    </ul>

    <br />

    <h2 style={{paddingBottom:"6px"}}>Limitations of Styled Components</h2>
    <ul>
      <li><strong>Performance Concerns:</strong> Styled Components introduces runtime overhead due to the dynamic nature of CSS-in-JS. For small applications, this may not be noticeable, but for large apps, it could impact performance.</li><br />
      <li><strong>Learning Curve:</strong> For developers unfamiliar with CSS-in-JS or tagged template literals, there may be a learning curve involved.</li>
    </ul>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for Using Styled Components</h2>
    <ul>
      <li><strong>Keep Components Small:</strong> Styled Components work best when each component is small and self-contained. Avoid putting too much logic or too many styles into a single component.</li><br />
      <li><strong>Use Theming:</strong> Define and use a consistent theme to ensure uniformity across your application.</li><br />
      <li><strong>Reuse Styled Components:</strong> Create reusable styled components to maintain consistency and reduce code duplication.</li>
    </ul><br />

    <p>
      Styled Components provides a powerful, flexible way to style React applications with the benefits of scoped styles, dynamic properties, and easy theming. By using this approach, you can build maintainable, reusable, and dynamic user interfaces.
    </p>
  </div>
)}



   
    {selectedChapter === 'chapter28' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}> Emotion.js</h1>

    <p>
      Emotion.js is a performant and flexible CSS-in-JS library for styling React applications. Like Styled Components, Emotion allows you to write CSS styles inside JavaScript, but it offers a different approach with a focus on performance and developer experience. Emotion provides both styled components and a utility function for writing CSS, making it a versatile choice for React developers.
    </p>

   <br />

    <h2>What is Emotion.js?</h2>
    <p style={{paddingBottom:"6px"}}>
      Emotion.js is a library designed for styling applications using JavaScript. It enables developers to write CSS directly within their JavaScript files, which allows for dynamic and scoped styling. Emotion is fast, efficient, and provides a simple API, offering both `styled` components and the `css` function to write and apply styles.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Emotion.js</h3>
    <ul>
      <li><strong>CSS-in-JS:</strong> Write traditional CSS syntax in JavaScript, enhancing the developer experience.</li><br />
      <li><strong>Fast and Optimized:</strong> Emotion is optimized for performance with low runtime overhead and minimal CSS injection.</li><br />
      <li><strong>Scoped Styles:</strong> Styles are scoped to components, ensuring no conflicts in global styles.</li><br />
      <li><strong>Dynamic Styles:</strong> Easily apply dynamic styles using props and theme variables.</li><br />
      <li><strong>Theming:</strong> Emotion supports theming, allowing global design properties to be applied throughout the app.</li>
    </ul>

    <br />

    <h2>Setting Up Emotion.js</h2>
    <p style={{paddingBottom:"6px"}}>
      To get started with Emotion, you need to install the Emotion library in your React project. You can do this using npm or yarn.
    </p>

    <h3>Installation</h3>
    <pre>
      <code>
        {`npm install @emotion/react @emotion/styled`}
      </code>
    </pre>
    <p>
      The two main packages to install are `@emotion/react` (for core functionality) and `@emotion/styled` (for styled components). Once installed, you can begin using Emotion in your React components.
    </p><br />

    <h3>Example Usage</h3>
    <pre>
      <code>
        {`/** Importing Emotion */
import styled from '@emotion/styled';

// Create a styled button component
const Button = styled.button\`
  background-color: blue;
  color: white;
  padding: 10px;
  border-radius: 5px;
  &:hover {
    background-color: darkblue;
  }
\`;

// Using the styled button in a component
const MyComponent = () => {
  return <Button>Click Me</Button>;
};`}
      </code>
    </pre>

    <p>
      In the example above, we create a styled button component using the `styled.button` function from Emotion. The styles are written in normal CSS syntax, and the button is used as a React component.
    </p>

   <br />

    <h2>Dynamic Styling with Props</h2>
    <p style={{paddingBottom:"6px"}}>
      Emotion allows you to easily adjust styles based on component props, making your components more flexible and reusable. You can change styles dynamically, similar to how you would in regular CSS, but using JavaScript variables and props.
    </p>

    <h3>Example of Dynamic Styling</h3>
    <pre>
      <code>
        {`const Button = styled.button\`
  background-color: \${props => props.primary ? 'blue' : 'gray'};
  color: white;
  padding: 10px;
  border-radius: 5px;
  &:hover {
    background-color: \${props => props.primary ? 'darkblue' : 'darkgray'};
  }
\`;

// Usage with different props
const MyComponent = () => {
  return (
    <div>
      <Button primary>Primary Button</Button>
      <Button>Secondary Button</Button>
    </div>
  );
};`}
      </code>
    </pre>

    <p>
      This example demonstrates how to dynamically change the button's background color based on whether the `primary` prop is passed. This makes the component more flexible and reusable.
    </p>

  <br />

    <h2>Theming with Emotion.js</h2>
    <p style={{paddingBottom:"6px"}}>
      Emotion provides built-in support for theming, allowing you to define global design variables such as colors, fonts, and spacing. You can then access these theme properties within your styled components, ensuring consistent styling across the application.
    </p>

    <h3>Example of Theming</h3>
    <pre>
      <code>
        {`import { ThemeProvider } from '@emotion/react';

// Define a theme
const theme = {
  primaryColor: 'blue',
  secondaryColor: 'gray',
};

// Create a styled component that uses the theme
const Button = styled.button\`
  background-color: \${props => props.theme.primaryColor};
  color: white;
  padding: 10px;
  border-radius: 5px;
\`;

// App component with ThemeProvider
const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Button>Click Me</Button>
    </ThemeProvider>
  );
};`}
      </code>
    </pre>

    <p>
      In this example, the `ThemeProvider` component injects the theme into the app, and the `Button` component uses the `primaryColor` from the theme to style itself.
    </p>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Advantages of Using Emotion.js</h2>
    <ul>
      <li><strong>Performance:</strong> Emotion is optimized for performance, making it a good choice for large applications.</li><br />
      <li><strong>Flexibility:</strong> With support for both styled components and utility functions, Emotion provides flexibility in how you write your styles.</li><br />
      <li><strong>Scoped Styles:</strong> Prevents global CSS conflicts by scoping styles to components.</li><br />
      <li><strong>Theming:</strong> Supports theming out of the box, making it easy to apply global design properties.</li>
    </ul>

    <br />

    <h2 style={{paddingBottom:"6px"}}>Limitations of Emotion.js</h2>
    <ul>
      <li><strong>Bundle Size:</strong> Although Emotion is optimized, the bundle size may still increase due to its dynamic nature, especially in larger projects.</li><br />
      <li><strong>Learning Curve:</strong> Some developers may face a learning curve with CSS-in-JS libraries, especially when transitioning from traditional CSS methods.</li>
    </ul>

    <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for Using Emotion.js</h2>
    <ul>
      <li><strong>Use ThemeProvider:</strong> Always use the `ThemeProvider` to inject global themes and avoid hardcoding style values.</li><br />
      <li><strong>Keep Components Simple:</strong> Try to keep each component focused on a single task, and avoid excessive styling logic within each one.</li><br />
      <li><strong>Use Utility Functions:</strong> Take advantage of the `css` function when you need to apply multiple styles conditionally or dynamically.</li>
    </ul><br />

    <p>
      Emotion.js offers a fast and flexible way to style React components, with powerful features like dynamic styling, scoped styles, and built-in theming. It’s a great choice for developers who want the power of CSS-in-JS with a focus on performance and scalability.
    </p>
  </div>
)}



    {selectedChapter === 'chapter29' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}> Inline Styles in React</h1>

    <p>
      Inline styles in React allow you to style your components directly within your JSX code. React provides a straightforward way to apply styles through the `style` attribute, which expects an object where the keys are camelCased CSS properties and the values are the corresponding CSS values as strings or numbers.
    </p>

   <br />

    <h2>What Are Inline Styles in React?</h2>
    <p style={{paddingBottom:"6px"}}>
      Inline styles in React are applied directly to an element using the `style` attribute. Instead of using separate CSS files or CSS-in-JS libraries, the styles are written inside JavaScript objects. These objects are then passed as the value of the `style` attribute of the JSX element.
    </p>

    <h3>Syntax for Inline Styles</h3>
    <p style={{paddingBottom:"6px"}}>
      In React, inline styles are specified using an object where the CSS property names are written in camelCase (instead of hyphenated lowercase) and the values are provided as strings or numbers.
    </p>

    <h4>Example:</h4>
    <pre>
      <code>
        {`const myStyle = {
  backgroundColor: 'blue',
  color: 'white',
  padding: '10px',
  borderRadius: '5px',
};

const MyComponent = () => {
  return <div style={myStyle}>Hello, World!</div>;
};`}
      </code>
    </pre>

    <p>
      In this example, `myStyle` is an object that contains the styles, and it's passed directly to the `style` attribute of the `div` element.
    </p>

   <br />

    <h2>Dynamic Inline Styles in React</h2>
    <p style={{paddingBottom:"6px"}}>
      One of the advantages of using inline styles in React is that they can be dynamic. You can change the styles based on component state or props, which makes inline styles a powerful tool for conditional styling.
    </p>

    <h3>Example of Dynamic Inline Styles</h3>
    <pre>
      <code>
        {`const MyComponent = () => {
  const [isActive, setIsActive] = useState(false);

  const buttonStyle = {
    backgroundColor: isActive ? 'green' : 'red',
    color: 'white',
    padding: '10px',
    borderRadius: '5px',
  };

  return (
    <div>
      <button style={buttonStyle} onClick={() => setIsActive(!isActive)}>
        {isActive ? 'Active' : 'Inactive'}
      </button>
    </div>
  );
};`}
      </code>
    </pre>

    <p>
      In this example, the button's background color changes based on the `isActive` state, demonstrating how you can conditionally change styles with inline styling.
    </p>

   <br />
    <h2>Inline Styles and Media Queries</h2>
    <p style={{paddingBottom:"6px"}}>
      Inline styles in React do not support traditional media queries directly. However, you can implement responsive styles by using JavaScript to check the window size and apply the corresponding styles dynamically.
    </p>

    <h3>Example of Responsive Inline Styles</h3>
    <pre>
      <code>
        {`const MyComponent = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const divStyle = {
    width: windowWidth > 600 ? '500px' : '100%',
    backgroundColor: 'lightblue',
    padding: '20px',
    borderRadius: '5px',
  };

  return <div style={divStyle}>Responsive Div</div>;
};`}
      </code>
    </pre>

    <p>
      This example uses the `window.innerWidth` to check the screen size and adjusts the `div` element's width based on the window size, mimicking the effect of media queries.
    </p>

  <br />

    <h2 style={{paddingBottom:"6px"}}>Advantages of Using Inline Styles</h2>
    <ul>
      <li><strong>Scoped Styling:</strong> Inline styles are scoped to the component, preventing any global style conflicts.</li><br />
      <li><strong>Dynamic Styles:</strong> Inline styles allow you to easily apply dynamic styles based on props or state, making them highly flexible.</li><br />
      <li><strong>No Need for CSS Files:</strong> Inline styles do not require separate CSS files, which can simplify the project structure for smaller projects.</li><br />
      <li><strong>Style Overriding:</strong> Inline styles take precedence over styles defined in external or global CSS, allowing for more control over specific elements.</li>
    </ul>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Limitations of Inline Styles</h2>
    <ul>
      <li><strong>No Pseudo-Classes/Elements:</strong> Inline styles do not support pseudo-classes like `:hover`, `:focus`, or `:active` directly.</li><br />
      <li><strong>No Media Queries:</strong> Inline styles do not directly support media queries, though you can implement responsive behavior with JavaScript.</li><br />
      <li><strong>Limited CSS Features:</strong> Some advanced CSS features, such as animations and transitions, are not easily implemented with inline styles.</li>
    </ul>
<br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for Using Inline Styles</h2>
    <ul>
      <li><strong>Use for Simple Styling:</strong> Inline styles are best suited for simple, dynamic styles. For more complex styles, consider using external CSS or CSS-in-JS libraries.</li><br />
      <li><strong>Keep Styles Concise:</strong> Avoid adding too many styles to a single element. For larger styles, it's better to use separate CSS classes or styled components.</li><br />
      <li><strong>Leverage State for Dynamic Styles:</strong> Use React's state or props to modify inline styles based on user interactions or component state.</li>
    </ul>

  <br />

    <h2>Conclusion</h2>
    <p>
      Inline styles in React provide a quick and easy way to apply styles to components, especially for simple, dynamic, or conditional styling. While they have some limitations compared to traditional CSS or CSS-in-JS solutions, they can be a powerful tool when used appropriately in React applications.
    </p>
  </div>
)}



 
    {selectedChapter === 'chapter30' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Tailwind CSS Integration</h1>

    <p>
      Tailwind CSS is a utility-first CSS framework that provides a set of predefined classes to build custom designs directly in your markup. Unlike traditional CSS frameworks that define predefined components, Tailwind focuses on providing low-level utility classes that you can combine to create custom designs. Integrating Tailwind CSS into a React application can help you streamline your styling process with minimal effort and maximum flexibility.
    </p>

   <br />

    <h2>What is Tailwind CSS?</h2>
    <p >
      Tailwind CSS is a highly customizable and efficient utility-first CSS framework. It doesn't come with predefined components like buttons or navigation bars. Instead, it offers a collection of utility classes (e.g., `text-center`, `p-4`, `bg-blue-500`) that you apply directly to elements in your JSX. This results in cleaner HTML, faster development time, and the ability to create unique designs without leaving your JSX code.
    </p>

    <br />

    <h2 style={{paddingBottom:"6px"}}>Why Use Tailwind CSS in React?</h2>
    <ul>
      <li><strong>Utility-first approach:</strong> Tailwind allows you to apply multiple utility classes directly to HTML elements, reducing the need for custom CSS files or class names.</li><br />
      <li><strong>Faster development:</strong> With a set of predefined classes, developers can quickly prototype and implement designs without worrying about writing custom CSS.</li><br />
      <li><strong>Customizable:</strong> Tailwind can be customized easily to match your project's specific design system by modifying the `tailwind.config.js` file.</li><br />
      <li><strong>No opinionated styles:</strong> Unlike traditional CSS frameworks, Tailwind doesn’t impose any specific styles, giving you full control over your design.</li>
    </ul>

   <br />

    <h2>Installing Tailwind CSS in a React Application</h2>
    <p style={{paddingBottom:"6px"}}>
      To use Tailwind CSS in your React project, you'll need to install it and configure it in your project. Follow these steps:
    </p>

    <h3>Step 1: Install Tailwind CSS</h3>
    <p>
      You can install Tailwind CSS using npm or yarn. Run one of the following commands in your project directory:
    </p>
    <pre>
      <code>npm install -D tailwindcss postcss autoprefixer</code>
      <code>yarn add tailwindcss postcss autoprefixer --dev</code>
    </pre><br />

    <h3>Step 2: Initialize Tailwind</h3>
    <p>
      After installation, initialize Tailwind by creating the configuration files. Run the following command:
    </p>
    <pre>
      <code>npx tailwindcss init</code>
    </pre>

    <p>
      This will generate a `tailwind.config.js` file in your project root, where you can configure Tailwind’s theme, extend it, or enable/disable features.
    </p><br />

    <h3>Step 3: Configure PostCSS</h3>
    <p>
      Create a `postcss.config.js` file in your project root and add the following code:
    </p>
    <pre>
      <code>
        {`module.exports = {
          plugins: {
            tailwindcss: {},
            autoprefixer: {},
          },
        };`}
      </code>
    </pre><br />

    <h3>Step 4: Add Tailwind Directives to Your CSS</h3>
    <p>
      Create a CSS file (e.g., `src/index.css`) and add the following Tailwind directives:
    </p>
    <pre>
      <code>
        {`@tailwind base;
@tailwind components;
@tailwind utilities;`}
      </code>
    </pre>

    <p>
      These directives instruct Tailwind to include its base styles, components, and utility classes.
    </p><br />

    <h3>Step 5: Import the CSS File</h3>
    <p>
      Import the CSS file you created (e.g., `index.css`) into your `src/index.js` or `src/index.tsx`:
    </p>
    <pre>
      <code>
        {`import './index.css';`}
      </code>
    </pre>

    <br />

    <h2>Using Tailwind CSS in React</h2>
    <p style={{paddingBottom:"6px"}}>
      Once Tailwind CSS is set up, you can start using its utility classes to style your components. Below is an example of how you can use Tailwind's utilities to style a button and a container:
    </p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`const Button = () => {
  return (
    <button className="bg-blue-500 text-white p-2 rounded hover:bg-blue-700">
      Click Me
    </button>
  );
};

const App = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-200">
      <Button />
    </div>
  );
};`}
      </code>
    </pre>

    <p>
      In this example, the `Button` component is styled using Tailwind's utility classes such as `bg-blue-500`, `text-white`, `p-2`, and `rounded`. The `App` component uses flexbox utilities like `flex`, `items-center`, and `justify-center` to center the button on the screen.
    </p>

   <br />

    <h2>Customizing Tailwind CSS</h2>
    <p style={{paddingBottom:"6px"}}>
      Tailwind CSS is highly customizable. You can modify the default configuration by editing the `tailwind.config.js` file. For example, you can change colors, fonts, spacing, and more. Here’s how you can extend the default configuration:
    </p>

    <h3>Example of Customizing Tailwind Config</h3>
    <pre>
      <code>
        {`module.exports = {
  theme: {
    extend: {
      colors: {
        customColor: '#FF6347',
      },
    },
  },
};`}
      </code>
    </pre>

    <p>
      In this example, we've added a custom color `customColor` to the Tailwind theme, which you can use in your components like this:
    </p>
    <pre>
      <code>className="bg-customColor"</code>
    </pre>

    <br />

    <h2 style={{paddingBottom:"6px"}}>Benefits of Tailwind CSS in React</h2>
    <ul>
      <li><strong>Efficiency:</strong> Tailwind’s utility-first approach allows for faster development by eliminating the need for writing custom CSS for each element.</li><br />
      <li><strong>Customizability:</strong> Tailwind can be fully customized to fit your design system with minimal effort.</li><br />
      <li><strong>Consistent Design:</strong> By using Tailwind’s predefined utilities, you ensure a consistent design across your app without worrying about naming conventions or class conflicts.</li><br />
      <li><strong>Scalability:</strong> Tailwind makes it easy to scale your project with reusable utilities, reducing the need for custom CSS as the application grows.</li>
    </ul>

    <br />

    <h2>Conclusion</h2>
    <p>
      Tailwind CSS offers a simple, efficient, and customizable approach to styling in React applications. By using its utility classes, you can quickly build beautiful and responsive UI components without writing extensive custom CSS. With its customizable configuration, Tailwind can easily be tailored to fit your project’s design needs.
    </p>
  </div>
)}




    {selectedChapter === 'chapter31' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Theming in React.js</h1>

    <p>
      Theming in React allows you to customize the appearance of your application by defining a set of styles, colors, and fonts that can be applied consistently across your components. React makes it easy to implement dynamic theming, enabling users to switch between different themes (e.g., light and dark modes) without reloading the page. This guide will explore how to implement theming in a React application, including using context, CSS-in-JS libraries, and popular theming libraries.
    </p>

    <br />

    <h2>Why Theming Matters in React?</h2>
    <p>
      Theming is essential for creating an engaging and cohesive user interface (UI) that aligns with your brand or design system. It allows you to separate concerns by keeping the logic of your app and its appearance independent. In addition, theming enables flexibility in terms of user preferences (e.g., dark mode), accessibility, and consistent styling throughout your application.
    </p>

   <br />

    <h2>Implementing Basic Theming in React</h2>
    <p style={{paddingBottom:"6px"}}>
      One of the simplest ways to implement theming in React is by using React's Context API to manage global state, such as the current theme. Here's how to set up basic theming using Context:
    </p>

    <h3>Step 1: Set Up the Theme Context</h3>
    <p>
      Create a context that holds the theme value and provides it throughout your app.
    </p>
    <pre>
      <code>
        {`import React, { createContext, useState } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light'); // Default theme

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;`}
      </code>
    </pre>

    <p>
      In this example, we use the `useState` hook to manage the current theme, which can be toggled between `light` and `dark` modes.
    </p><br />

    <h3>Step 2: Apply the Theme in Your Application</h3>
    <p>
      To apply the theme to the application, you can wrap your app in the `ThemeProvider` component and use the `useContext` hook to access the theme value wherever needed.
    </p>
    <pre>
      <code>
        {`import React, { useContext } from 'react';
import ThemeContext from './ThemeContext';

const App = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <div className={theme}>
      <h1>Hello, React!</h1>
      <button onClick={toggleTheme}>Toggle Theme</button>
    </div>
  );
};

export default App;`}
      </code>
    </pre>

    <p>
      In this example, the `App` component is wrapped with the `ThemeProvider`, and the `theme` state is used to dynamically apply the theme to the root `div`. Clicking the button will toggle the theme.
    </p><br />

    <h3>Step 3: Style Based on the Theme</h3>
    <p>
      You can now apply conditional styles based on the theme. Here's an example of how you can style components based on the current theme:
    </p>
    <pre>
      <code>
        {`/* App.css */
        .light {
          background-color: white;
          color: black;
        }

        .dark {
          background-color: black;
          color: white;
        }`}
      </code>
    </pre>

    <br />

    <h2>Advanced Theming with CSS-in-JS</h2>
    <p style={{paddingBottom:"6px"}}>
      For more advanced theming capabilities, you can use CSS-in-JS libraries like `styled-components` or `emotion.js` to dynamically apply styles based on the theme. These libraries allow you to define your styles directly inside your JavaScript code and conditionally apply them based on theme values.
    </p>

    <h3>Using `styled-components` for Theming</h3>
    <p>
      `styled-components` is a popular CSS-in-JS library that allows you to define styled components with dynamic properties like themes. Here's how you can implement theming using `styled-components`:
    </p>

    <pre>
      <code>
        {`import React, { useContext } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import ThemeContext from './ThemeContext';

const lightTheme = {
  background: 'white',
  color: 'black',
};

const darkTheme = {
  background: 'black',
  color: 'white',
};

const Container = styled.div\`
  background-color: \${props => props.theme.background};
  color: \${props => props.theme.color};
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
\`;

const App = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <ThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
      <Container>
        <h1>Hello, Theming in React!</h1>
        <button onClick={toggleTheme}>Toggle Theme</button>
      </Container>
    </ThemeProvider>
  );
};

export default App;`}
      </code>
    </pre>

    <p>
      In this example, we use `styled-components` to define a `Container` component that changes its background and text color based on the theme. The `ThemeProvider` from `styled-components` provides the current theme to the component tree.
    </p>

  <br />

    <h2>Using Material-UI for Theming</h2>
    <p style={{paddingBottom:"6px"}}>
      Material-UI is a popular React UI library that provides built-in theming support. You can easily customize the theme of your application using the `ThemeProvider` component from Material-UI.
    </p>

    <h3>Example of Material-UI Theming</h3>
    <pre>
      <code>
        {`import React, { useContext } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import ThemeContext from './ThemeContext';

const App = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  const currentTheme = createTheme({
    palette: {
      mode: theme,
    },
  });

  return (
    <ThemeProvider theme={currentTheme}>
      <div>
        <h1>Hello, Material-UI Theming!</h1>
        <Button variant="contained" onClick={toggleTheme}>Toggle Theme</Button>
      </div>
    </ThemeProvider>
  );
};

export default App;`}
      </code>
    </pre>

    <p>
      In this example, Material-UI's `createTheme` function is used to create a custom theme based on the current `theme` (light or dark). The `ThemeProvider` component applies this theme to the application.
    </p>

   <br />

    <h2>Conclusion</h2>
    <p>
      Theming in React allows you to create a consistent and dynamic design system that can adapt to user preferences (e.g., dark mode). By using React’s Context API or CSS-in-JS libraries like `styled-components`, `emotion.js`, or UI libraries like Material-UI, you can easily implement flexible theming solutions that enhance user experience.
    </p>
  </div>
)}





  
    {selectedChapter === 'chapter32' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}> Fetching Data with fetch API and Axios</h1>

    <p>
      In modern web applications, fetching data from external APIs is an essential part of dynamic content rendering. React makes it easy to handle asynchronous operations, such as API requests, using various tools. In this section, we will explore two commonly used methods for fetching data in React: the native `fetch` API and the popular third-party library `Axios`.
    </p>

   <br />

    <h2>Why Handle Asynchronous Operations?</h2>
    <p>
      Handling asynchronous operations in React is crucial because fetching data from APIs involves waiting for a response from the server. By managing these operations correctly, you ensure that your app doesn't freeze or become unresponsive while waiting for the server's response. React provides several ways to handle these asynchronous operations effectively, with `fetch` and `Axios` being two popular methods.
    </p>

    <br />

    <h2>Using the `fetch` API in React</h2>
    <p style={{paddingBottom:"6px"}}>
      The `fetch` API is a built-in JavaScript function that allows you to make HTTP requests to a server. It returns a Promise, making it a great fit for handling asynchronous operations in React.
    </p>

    <h3>Step 1: Basic `fetch` Usage</h3>
    <p>
      Here's a simple example of how to fetch data from an API using the `fetch` API in a React component:
    </p>
    <pre>
      <code>
        {`import React, { useState, useEffect } from 'react';

const App = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('https://jsonplaceholder.typicode.com/posts')
      .then(response => response.json())
      .then(data => {
        setData(data);
        setLoading(false);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>Fetched Data</h1>
      <ul>
        {data.map(item => (
          <li key={item.id}>{item.title}</li>
        ))}
      </ul>
    </div>
  );
};

export default App;`}
      </code>
    </pre>

    <p>
      In this example, the `useEffect` hook is used to trigger the `fetch` call when the component mounts. The `fetch` API fetches data from a sample API (JSONPlaceholder), and the response is parsed as JSON. The fetched data is stored in the `data` state, and `loading` state is used to display a loading message while the request is pending.
    </p>

   <br />

    <h2>Using `Axios` in React</h2>
    <p style={{paddingBottom:"6px"}}>
      `Axios` is a popular JavaScript library for making HTTP requests. It provides a simpler and more feature-rich API compared to the `fetch` API, with automatic JSON parsing, request and response interceptors, and more.
    </p>

    <h3>Step 1: Installing Axios</h3>
    <p>
      First, you need to install Axios in your React project using npm or yarn:
    </p>
    <pre>
      <code>
        {`npm install axios`}
      </code>
    </pre><br />

    <h3>Step 2: Basic `Axios` Usage</h3>
    <p>
      Here's an example of how to use Axios to fetch data in a React component:
    </p>
    <pre>
      <code>
        {`import React, { useState, useEffect } from 'react';
import axios from 'axios';

const App = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('https://jsonplaceholder.typicode.com/posts')
      .then(response => {
        setData(response.data);
        setLoading(false);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>Fetched Data</h1>
      <ul>
        {data.map(item => (
          <li key={item.id}>{item.title}</li>
        ))}
      </ul>
    </div>
  );
};

export default App;`}
      </code>
    </pre>

    <p>
      In this example, Axios is used to fetch data from the same API. The `axios.get` method is used to make a GET request to the endpoint, and the response data is accessed via `response.data`. The loading state is updated in a similar manner to the `fetch` example.
    </p>

    <br />

    <h2>Handling Errors and Loading States</h2>
    <p style={{paddingBottom:"6px"}}>
      In both `fetch` and `Axios`, it's important to handle errors and manage loading states effectively to enhance the user experience. Here are some common patterns to handle errors and loading states:
    </p>

    <h3>Handling Errors with `fetch`</h3>
    <pre>
      <code>
        {`fetch('https://jsonplaceholder.typicode.com/posts')
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => setData(data))
          .catch(error => console.error('There was a problem with the fetch operation:', error));`}
      </code>
    </pre><br />

    <h3>Handling Errors with `Axios`</h3>
    <pre>
      <code>
        {`axios.get('https://jsonplaceholder.typicode.com/posts')
          .then(response => setData(response.data))
          .catch(error => console.error('Error fetching data:', error));`}
      </code>
    </pre>

    <br />

    <h2>Comparing `fetch` vs. `Axios`</h2>
    <p style={{paddingBottom:"6px"}}>
      While both `fetch` and `Axios` serve the same purpose (making HTTP requests), they have some differences:
    </p>

    <ul>
      <li><strong>Syntax:</strong> `Axios` has a simpler API with automatic JSON parsing, whereas `fetch` requires explicit parsing.</li><br />
      <li><strong>Error Handling:</strong> `Axios` automatically rejects the Promise on error status codes, while `fetch` only rejects on network errors.</li><br />
      <li><strong>Features:</strong> `Axios` provides additional features like request/response interceptors, while `fetch` is more basic.</li>
    </ul><br />

    <p>
      Depending on the complexity of your project, you may choose `fetch` for simpler use cases or `Axios` if you need more advanced features like interceptors and default headers.
    </p>

<br />

    <h2>Conclusion</h2>
    <p>
      Both the `fetch` API and `Axios` provide effective solutions for fetching data in React applications. The choice between the two largely depends on your project’s needs and your preference for a simpler or more feature-rich approach. By handling asynchronous operations effectively, you can build dynamic, data-driven React applications with seamless user experiences.
    </p>
  </div>
)}





{selectedChapter === 'chapter33' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>React Query (for Data Fetching and Caching)</h1>

    <p>
      React Query is a powerful data-fetching and state management library for React applications. It simplifies the process of managing server state, handling caching, synchronization, and background updates. In this section, we will explore how to use React Query for efficient data fetching, caching, and state management in your React applications.
    </p>

   <br />

    <h2>What is React Query?</h2>
    <p style={{paddingBottom:"6px"}}>
      React Query is a library that provides hooks for fetching, caching, and synchronizing data in React applications. It abstracts away many of the complexities of managing asynchronous operations, making it easier to work with APIs and server data. React Query automates tasks like caching, background data fetching, and refetching, so you can focus more on building your application.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of React Query</h3>
    <ul>
      <li><strong>Data Fetching:</strong> Fetch data from APIs or other sources in a declarative way using React Query hooks.</li><br />
      <li><strong>Caching:</strong> React Query automatically caches data to avoid unnecessary API calls, improving performance.</li><br />
      <li><strong>Background Updates:</strong> Keep your data up-to-date by automatically refetching it in the background.</li><br />
      <li><strong>Automatic Retries:</strong> React Query can automatically retry failed requests with exponential backoff.</li><br />
      <li><strong>Pagination and Infinite Query Support:</strong> Manage large data sets efficiently with built-in pagination and infinite scrolling support.</li>
    </ul>

   <br />

    <h2>Setting Up React Query</h2>
    <p>
      To start using React Query in your React application, you'll need to install it first. You can do so using npm or yarn:
    </p>
    <pre>
      <code>
        {`npm install react-query`}
      </code>
    </pre>

    <p>
      After installation, you need to wrap your app with the <code>QueryClientProvider</code> and provide a <code>QueryClient</code> instance at the root level of your application. This setup is necessary to initialize React Query and manage the cache.
    </p>
    <pre>
      <code>
        {`import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';

const queryClient = new QueryClient();

const Root = () => (
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

export default Root;`}
      </code>
    </pre>

   <br />

    <h2>Fetching Data with React Query</h2>
    <p>
      Once React Query is set up, you can start fetching data using the <code>useQuery</code> hook. Here's an example of how to fetch data from an API using React Query:
    </p>
    <pre>
      <code>
        {`import React from 'react';
import { useQuery } from 'react-query';

const fetchPosts = async () => {
  const response = await fetch('https://jsonplaceholder.typicode.com/posts');
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
};

const Posts = () => {
  const { data, error, isLoading } = useQuery('posts', fetchPosts);

  if (isLoading) return <div>Loading...</div>;
  if (error instanceof Error) return <div>Error: {error.message}</div>;

  return (
    <div>
      <h1>Posts</h1>
      <ul>
        {data.map((post) => (
          <li key={post.id}>{post.title}</li>
        ))}
      </ul>
    </div>
  );
};

export default Posts;`}
      </code>
    </pre>

    <p>
      In this example, we define a function <code>fetchPosts</code> to fetch data from the API. The <code>useQuery</code> hook is used to call this function, passing in a unique query key ('posts') and the fetch function. The hook returns an object containing the fetched data, loading state, and any error encountered during the fetch.
    </p>

    <br />

    <h2>Caching Data with React Query</h2>
    <p>
      One of the primary benefits of React Query is its automatic caching. Once data is fetched, React Query caches it, so subsequent requests to the same endpoint will return the cached data instead of making a new request. This improves performance and reduces the number of unnecessary API calls.
    </p>
    <p style={{paddingBottom:"6px"}}>
      React Query automatically refetches data when certain conditions are met, such as when the component is refocused or when a new request is made. This ensures that your data is always fresh.
    </p>

    <h3>Customizing Cache Time</h3>
    <p>
      You can customize how long React Query caches data before it considers it stale by adjusting the <code>staleTime</code> option:
    </p>
    <pre>
      <code>
        {`const { data } = useQuery('posts', fetchPosts, {
          staleTime: 10000, // Cache data for 10 seconds
        });`}
      </code>
    </pre>

   <br />

    <h2>Mutations with React Query</h2>
    <p>
      React Query also supports mutations, which are used for modifying data (e.g., creating, updating, or deleting resources on the server). You can use the <code>useMutation</code> hook to handle mutations.
    </p>
    <pre>
      <code>
        {`import { useMutation } from 'react-query';

const createPost = async (newPost) => {
  const response = await fetch('https://jsonplaceholder.typicode.com/posts', {
    method: 'POST',
    body: JSON.stringify(newPost),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) {
    throw new Error('Error creating post');
  }
  return response.json();
};

const NewPost = () => {
  const mutation = useMutation(createPost);

  const handleCreatePost = () => {
    mutation.mutate({
      title: 'New Post',
      body: 'This is a new post created with React Query',
    });
  };

  return (
    <div>
      <button onClick={handleCreatePost} disabled={mutation.isLoading}>
        {mutation.isLoading ? 'Creating Post...' : 'Create Post'}
      </button>
      {mutation.isError && <div>Error creating post: {mutation.error.message}</div>}
      {mutation.isSuccess && <div>Post created successfully!</div>}
    </div>
  );
};

export default NewPost;`}
      </code>
    </pre>

    <p>
      In this example, the <code>useMutation</code> hook is used to handle the creation of a new post. You pass a mutation function (e.g., <code>createPost</code>) to the hook, and then call <code>mutation.mutate</code> when the user interacts with the UI.
    </p>

    <br />

    <h2>Background Data Fetching and Refetching</h2>
    <p style={{paddingBottom:"6px"}}>
      React Query allows you to keep your data fresh by automatically refetching it in the background when certain conditions occur. This is especially useful when you need to ensure that the data shown in your UI is always up-to-date.
    </p>

    <h3>Auto Refetch on Window Focus</h3>
    <p>
      React Query will automatically refetch data when the window is refocused. This behavior can be customized using the <code>refetchOnWindowFocus</code> option.
    </p>
    <pre>
      <code>
        {`const { data } = useQuery('posts', fetchPosts, {
          refetchOnWindowFocus: true, // Enable auto-refetch on window focus
        });`}
      </code>
    </pre>

    <br />

    <h2>Conclusion</h2>
    <p>
      React Query is a powerful tool that simplifies data fetching, caching, and state management in React applications. By using React Query, you can reduce the complexity of dealing with server data, automate background updates, and improve the performance of your React apps. Whether you're working with REST APIs, GraphQL, or other data sources, React Query can help streamline your data-fetching logic and make your applications more efficient.
    </p>
  </div>
)}



{selectedChapter === 'chapter34' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Handling Loading States</h1>

    <p>
      Managing loading states in React is crucial when you're working with asynchronous data or operations, such as fetching data from APIs, performing calculations, or waiting for a response from the server. In this section, we will explore how to effectively handle loading states in React applications to ensure a smooth and user-friendly experience.
    </p>

   <br />

    <h2>What is a Loading State?</h2>
    <p>
      A loading state is a visual indicator that informs users that an operation is currently in progress, such as data fetching, file uploads, or any task that takes time to complete. It helps improve the user experience by signaling that something is happening in the background and that the app hasn't frozen or crashed.
    </p>
    <p>
      In React, handling loading states is typically done by conditionally rendering different UI elements based on whether the data is still being fetched or whether the operation is completed.
    </p>

   <br /> 

    <h2>Using State to Manage Loading</h2>
    <p style={{paddingBottom:"6px"}}>
      In React, loading states are often managed using the <code>useState</code> hook. You can track whether the app is in a loading state and update the UI accordingly.
    </p>

    <h3>Basic Example: Fetching Data with Loading State</h3>
    <p>
      Here's an example of how to handle a simple loading state while fetching data from an API:
    </p>
    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`import React, { useState, useEffect } from 'react';

const Posts = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://jsonplaceholder.typicode.com/posts')
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <h1>Posts</h1>
      <ul>
        {data.map((post) => (
          <li key={post.id}>{post.title}</li>
        ))}
      </ul>
    </div>
  );
};

export default Posts;`}
      </code>
    </pre>

    <p>
      In this example:
      <ul>
        <li><code>isLoading</code>: A state that tracks whether data is being fetched.</li><br />
        <li><code>setIsLoading(false)</code>: Updates the loading state to <code>false</code> once the data is successfully fetched.</li><br />
        <li><code>error</code>: Stores any error encountered during the data-fetching process.</li>
      </ul><br />
      The UI conditionally renders either a loading message, an error message, or the actual data based on the loading state.
    </p>

   <br />

    <h2>Handling Loading States with Async Functions</h2>
    <p>
      When dealing with asynchronous operations such as API calls, it's often easier to use async/await syntax. This can help clean up the logic for managing loading states and error handling.
    </p>
    <pre>
      <code>
        {`import React, { useState, useEffect } from 'react';

const Posts = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://jsonplaceholder.typicode.com/posts');
        const data = await response.json();
        setData(data);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchData();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <h1>Posts</h1>
      <ul>
        {data.map((post) => (
          <li key={post.id}>{post.title}</li>
        ))}
      </ul>
    </div>
  );
};

export default Posts;`}
      </code>
    </pre>

    <p>
      The example above demonstrates how the async/await syntax is used to fetch data inside the <code>useEffect</code> hook. The <code>finally</code> block ensures that the loading state is updated regardless of whether the operation is successful or not.
    </p>

   <br />

    <h2>Using a Loading Spinner or Animation</h2>
    <p style={{paddingBottom:"6px"}}>
      For a better user experience, you may want to display a loading spinner or animation instead of just the text "Loading...". This can be done by using a library like <a href="https://www.npmjs.com/package/react-spinners">react-spinners</a> or by creating a custom spinner.
    </p>

    <h3>Example with a Custom Spinner</h3>
    <pre>
      <code>
        {`import React, { useState, useEffect } from 'react';
import './Spinner.css'; // Add custom spinner CSS

const Posts = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://jsonplaceholder.typicode.com/posts')
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <div className="spinner">Loading...</div>; // Custom spinner CSS class
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <h1>Posts</h1>
      <ul>
        {data.map((post) => (
          <li key={post.id}>{post.title}</li>
        ))}
      </ul>
    </div>
  );
};

export default Posts;`}
      </code>
    </pre>

    <p>
      In this example, the spinner is styled using custom CSS, and the "Loading..." message is replaced with the spinner during the loading state. You can customize the spinner's appearance by creating a simple animation in CSS.
    </p>

   <br />

    <h2>Using External Libraries for Loading States</h2>
    <p style={{paddingBottom:"6px"}}>
      Several libraries can help manage and display loading states in a more sophisticated way. For example, <a href="https://www.npmjs.com/package/react-loading">react-loading</a> offers a set of loading indicators that can be easily integrated into your app.
    </p>

    <h3>Example with react-loading</h3>
    <pre>
      <code>
        {`import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';

const Posts = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://jsonplaceholder.typicode.com/posts')
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <ReactLoading type="spin" color="#000" />;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <h1>Posts</h1>
      <ul>
        {data.map((post) => (
          <li key={post.id}>{post.title}</li>
        ))}
      </ul>
    </div>
  );
};

export default Posts;`}
      </code>
    </pre>

    <p>
      The <code>react-loading</code> library provides various types of loading spinners that you can use to give your app a more polished look during data fetching.
    </p>

   <br />

    <h2>Conclusion</h2>
    <p>
      Handling loading states in React is essential to providing a smooth and responsive user experience. Whether you're using a simple loading message, a custom spinner, or an external library, it's important to manage the loading state properly to keep users informed and engaged during long-running operations. With React's <code>useState</code> and <code>useEffect</code> hooks, you can easily handle loading states and display relevant information to users while data is being fetched or a process is in progress.
    </p>
  </div>
)}



{selectedChapter === 'chapter35' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Error Handling in React.js</h1>

    <p>
      Error handling in React is a critical part of building robust and resilient applications. It ensures that when something goes wrong, the app doesn't break completely, providing users with a smoother and more predictable experience. In this chapter, we will explore various strategies for handling errors in React applications, including the use of error boundaries, try-catch blocks, and error state management.
    </p>

    <br />

    <h2>What is Error Handling in React?</h2>
    <p>
      Error handling refers to the process of catching and managing errors that occur during the execution of your application. React provides several tools and strategies to manage errors effectively:
      <ul>
        <li>Displaying fallback UI when errors occur</li> <br />
        <li>Logging errors for debugging</li> <br />
        <li>Preventing application crashes due to unhandled errors</li>
      </ul> <br />
      In React, errors can occur in various places, such as during rendering, in lifecycle methods, or in event handlers.
    </p>

   <br />

    <h2>Using Error Boundaries</h2>
    <p>
      One of the most powerful error-handling features in React is the concept of **error boundaries**. An error boundary is a React component that catches JavaScript errors in its child components and displays a fallback UI instead of crashing the entire component tree.
    </p> <br />
    <h3>Creating an Error Boundary</h3>
    <p>
      To create an error boundary, you need to define a component that implements the <code>componentDidCatch</code> lifecycle method (or use <code>static getDerivedStateFromError</code>), which will catch errors during rendering or lifecycle methods of any of its child components.
    </p>
    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`import React, { Component } from 'react';

class ErrorBoundary extends Component {
  state = { hasError: false, errorMessage: '' };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    this.setState({ errorMessage: error.toString() });
    console.error('Error caught by Error Boundary: ', error, info);
  }

  render() {
    if (this.state.hasError) {
      return <h1>{this.state.errorMessage}</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;`}
      </code>
    </pre>
    <p>
      In this example:
      <ul>
        <li><code>getDerivedStateFromError</code>: This method is called when an error occurs in any of the child components. It updates the state to indicate that an error has occurred.</li><br />
        <li><code>componentDidCatch</code>: This lifecycle method logs the error and error information, allowing you to capture and log the error for debugging purposes.</li><br />
        <li><code>{`this.props.children`}</code>: The error boundary wraps its children, so it catches errors from any of the child components.</li>
      </ul>
    </p><br />

    <h3>Using Error Boundary in Your App</h3>
    <p>
      Once the error boundary component is created, it can be used to wrap parts of your app where you want to catch potential errors:
    </p>
    <pre>
      <code>
        {`import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import SomeComponent from './SomeComponent';

const App = () => {
  return (
    <ErrorBoundary>
      <SomeComponent />
    </ErrorBoundary>
  );
};

export default App;`}
      </code>
    </pre>
    <p>
      Now, if an error occurs in <code>SomeComponent</code>, the error boundary will catch it, and the fallback UI (like an error message) will be shown.
    </p>

   <br />

    <h2>Try-Catch in Event Handlers</h2>
    <p style={{paddingBottom:"6px"}}>
      While error boundaries are great for handling rendering errors, they don’t catch errors in event handlers. For handling errors in event handlers, you can use a standard <code>try-catch</code> block.
    </p>
    <h3>Example: Error Handling in an Event Handler</h3>
    <pre>
      <code>
        {`import React, { useState } from 'react';

const ErrorHandlerExample = () => {
  const [hasError, setHasError] = useState(false);

  const handleClick = () => {
    try {
      // Simulate an error
      throw new Error('Something went wrong!');
    } catch (error) {
      setHasError(true);
      console.error(error);
    }
  };

  return (
    <div>
      <button onClick={handleClick}>Click me</button>
      {hasError && <p>Error occurred during the event!</p>}
    </div>
  );
};

export default ErrorHandlerExample;`}
      </code>
    </pre>
    <p>
      In this example, if an error occurs inside the <code>handleClick</code> function, the error is caught, and a state variable <code>hasError</code> is set to <code>true</code>. This allows you to display an error message to the user while logging the error for debugging.
    </p>

   <br />

    <h2>Handling Errors in API Calls</h2>
    <p style={{paddingBottom:"6px"}}>
      API calls often fail due to various reasons like network issues or server errors. You should always handle errors when making API requests to ensure that your app behaves gracefully, even when data fetching fails.
    </p>
    <h3>Example: Handling API Errors</h3>
    <pre>
      <code>
        {`import React, { useState, useEffect } from 'react';

const FetchData = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://api.example.com/data');
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const result = await response.json();
        setData(result);
      } catch (error) {
        setError(error.message);
      }
    };

    fetchData();
  }, []);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!data) {
    return <div>Loading...</div>;
  }

  return <div>Data: {JSON.stringify(data)}</div>;
};

export default FetchData;`}
      </code>
    </pre>
    <p>
      In this example, an error is thrown if the response from the API is not OK. The error message is then set in the state, and an error message is shown to the user.
    </p>

    <br />

    <h2>Logging Errors for Debugging</h2>
    <p style={{paddingBottom:"6px"}}>
      It's important to log errors for debugging purposes. This can help you understand what went wrong in your application. React provides a <code>componentDidCatch</code> lifecycle method for class components, and you can use other tools like <code>console.error</code> to log errors to the console.
    </p>
    <h3>Example: Logging Errors</h3>
    <pre>
      <code>
        {`class MyComponent extends React.Component {
  componentDidCatch(error, info) {
    console.error('Error caught: ', error);
    console.error('Error info: ', info);
  }

  render() {
    return <div>My component</div>;
  }
}`}
      </code>
    </pre>
    <p>
      In the above example, the error is logged to the console when an error is caught in the component, providing valuable debugging information.
    </p>

   <br />

    <h2>Conclusion</h2>
    <p>
      Error handling is essential in any React application to ensure stability and improve user experience. By using error boundaries, try-catch blocks in event handlers, handling errors in API calls, and logging errors, you can create a robust React application that gracefully handles unexpected issues and provides users with helpful feedback when something goes wrong.
    </p>
  </div>
)}



{selectedChapter === 'chapter36' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Memoization with React.memo</h1>

    <p>
      In React, performance optimization plays a critical role in ensuring that the application remains fast and responsive, even as the complexity grows. Memoization is a technique that helps optimize the performance of React components by preventing unnecessary re-renders. In this section, we will explore how to use <code>React.memo</code> to optimize functional components and avoid redundant renders.
    </p>

    <br />

    <h2>What is Memoization?</h2>
    <p>
      Memoization is a performance optimization technique used to cache the results of expensive function calls and reuse the cached result when the same inputs occur again. In React, this technique can be applied to components to prevent them from re-rendering unless necessary.
    </p>
    <p>
      The <code>React.memo</code> higher-order component is one way to implement memoization in React. It wraps a component and ensures that it only re-renders when its props have changed.
    </p>

   <br />

    <h2>Introduction to React.memo</h2>
    <p style={{paddingBottom:"6px"}}>
      <code>React.memo</code> is a higher-order component that helps to optimize the performance of functional components by preventing unnecessary re-renders. It works by shallowly comparing the props of the component. If the props have not changed, React will skip rendering the component and reuse the previous render.
    </p>
    <h3>Basic Usage of React.memo</h3>
    <p>
      To use <code>React.memo</code>, simply wrap the functional component with it:
    </p>
    <pre>
      <code>
        {`import React from 'react';

const MyComponent = ({ name }) => {
  console.log('Rendering: ', name);
  return <div>{name}</div>;
};

export default React.memo(MyComponent);`}
      </code>
    </pre>
    <p>
      In this example, the component <code>MyComponent</code> will only re-render when the <code>name</code> prop changes. If the prop stays the same, React will skip the re-render and use the cached version of the component.
    </p><br />

    <h3>How React.memo Works</h3>
    <p style={{paddingBottom:"6px"}}>
      <code>React.memo</code> performs a shallow comparison of the props passed to the component. If the previous props are the same as the next props (shallow comparison), the component will not re-render. If the props change, React will re-render the component.
    </p>
    <h4>Example: Shallow Comparison</h4>
    <pre>
      <code>
        {`const MyComponent = React.memo(({ user }) => {
  console.log('Rendering: ', user.name);
  return <div>{user.name}</div>;
});

const App = () => {
  const [user, setUser] = useState({ name: 'John' });

  return (
    <div>
      <MyComponent user={user} />
      <button onClick={() => setUser({ name: 'Jane' })}>Change Name</button>
    </div>
  );
};`}
      </code>
    </pre>
    <p>
      Here, when the button is clicked and the <code>name</code> changes from "John" to "Jane", <code>MyComponent</code> will re-render. If the object reference for the <code>user</code> prop does not change (i.e., if it's the same object), React will not re-render the component even if the data inside the object changes.
    </p>

   <br />

    <h2>Custom Comparison Function with React.memo</h2>
    <p style={{paddingBottom:"6px"}}>
      By default, <code>React.memo</code> does a shallow comparison of props. However, you can pass a custom comparison function to <code>React.memo</code> to perform a deeper comparison or more complex checks.
    </p>
    <h3>Example: Custom Comparison Function</h3>
    <pre>
      <code>
        {`const MyComponent = React.memo(
  ({ user }) => {
    console.log('Rendering: ', user.name);
    return <div>{user.name}</div>;
  },
  (prevProps, nextProps) => {
    // Custom comparison function
    return prevProps.user.name === nextProps.user.name;
  }
);`}
      </code>
    </pre>
    <p>
      In this example, the custom comparison function checks if the <code>name</code> property of the <code>user</code> object is the same between the previous and next props. If it’s the same, the component will not re-render, even if the object reference changes.
    </p>

   <br />

    <h2>When to Use React.memo</h2>
    <p style={{paddingBottom:"6px"}}>
      While <code>React.memo</code> can significantly improve performance, it is not always necessary. Here are some guidelines to help you decide when to use it: <br />
      <ul>
        <li>Use <code>React.memo</code> when a component receives props that don’t change often, or when its re-rendering is expensive.</li> <br />
        <li>Don't use <code>React.memo</code> for components that render frequently or have complex logic, as the performance gains might not be significant.</li> <br />
        <li>It's particularly useful for optimizing components that render lists or heavy UI elements.</li>
      </ul> <br />
    </p>

    <h3>When Not to Use React.memo</h3>
    <p>
      While <code>React.memo</code> can be beneficial for performance optimization, it might add unnecessary complexity in some situations. Avoid using it if: <br />
      <ul>
        <li>You're optimizing a component that doesn't have any performance issues.</li> <br />
        <li>You're dealing with objects or arrays that change frequently, leading to more renders than necessary.</li>
      </ul>
    </p>

   <br />

    <h2>Combining React.memo with Other Optimization Techniques</h2>
    <p style={{paddingBottom:"6px"}}>
      <code>React.memo</code> works well with other performance optimization techniques in React, such as <code>useMemo</code>, <code>useCallback</code>, and lazy loading components. These techniques can help you fine-tune your app's performance even further.
    </p>
    <h3>Example: Combining React.memo with useMemo</h3>
    <pre>
      <code>
        {`const MyComponent = React.memo(({ list }) => {
  const processedList = useMemo(() => {
    return list.map(item => item.toUpperCase());
  }, [list]);

  return (
    <ul>
      {processedList.map(item => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
});`}
      </code>
    </pre>
    <p>
      In this example, <code>useMemo</code> is used to optimize the list processing, and <code>React.memo</code> ensures that the component does not re-render unless the <code>list</code> prop changes.
    </p>

    <br />

    <h2>Conclusion</h2>
    <p>
      Memoization using <code>React.memo</code> is a powerful optimization tool in React. By preventing unnecessary re-renders of functional components, you can improve the performance of your app, particularly in large and complex applications. However, it's essential to use <code>React.memo</code> judiciously, as overuse or misuse may lead to unnecessary complexity without significant performance gains.
    </p>
  </div>
)}





{selectedChapter === 'chapter37' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Lazy Loading Components with React.lazy and Suspense</h1>

    <p>
      As React applications grow larger and more complex, performance optimization becomes increasingly important. One powerful performance optimization technique in React is lazy loading, which allows you to load components only when they are needed, rather than all at once. In this section, we will explore how to use <code>React.lazy</code> and <code>Suspense</code> to implement lazy loading in React.
    </p>

   <br />

    <h2>What is Lazy Loading?</h2>
    <p>
      Lazy loading is the practice of deferring the loading of a resource until it is actually needed. In the context of React, lazy loading means loading components only when they are required for rendering. This helps reduce the initial loading time of your application and improves the user experience by allowing users to interact with the app sooner.
    </p>
    <p>
      React provides a built-in mechanism for lazy loading components using the <code>React.lazy</code> function and <code>Suspense</code> component.
    </p>

    <br />

    <h2>Using React.lazy for Component Lazy Loading</h2>
    <p style={{paddingBottom:"6px"}}>
      <code>React.lazy</code> is a function that allows you to dynamically import components. It works similarly to the <code>import()</code> function in JavaScript but is specifically designed for React components. When you use <code>React.lazy</code>, React will automatically load the component only when it is rendered.
    </p>
    <h3>Basic Usage of React.lazy</h3>
    <p>
      Here’s how you can use <code>React.lazy</code> to lazy load a component:
    </p>
    <pre>
      <code>
        {`import React, { Suspense } from 'react';

const MyComponent = React.lazy(() => import('./MyComponent'));

const App = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <MyComponent />
    </Suspense>
  );
};`}
      </code>
    </pre>
    <p>
      In this example:
      <ul>
        <li><code>React.lazy</code> is used to dynamically import the <code>MyComponent</code> component.</li><br />
        <li>The <code>Suspense</code> component is used to wrap the lazily loaded component and handle the loading state while the component is being fetched.</li><br />
        <li>The <code>fallback</code> prop of <code>Suspense</code> specifies what to render while the component is being loaded (e.g., a loading spinner or text).</li>
      </ul>
    </p>
<br />

    <h2>Understanding Suspense</h2>
    <p style={{paddingBottom:"6px"}}>
      <code>Suspense</code> is a React component that allows you to handle asynchronous rendering. It is used in combination with lazy loading to display a fallback UI while the component is being loaded.
    </p>
    <h3>How Suspense Works</h3>
    <p>
      When you use <code>Suspense</code>, React will pause the rendering of the child components until the lazy-loaded component has been fetched. During this time, the <code>fallback</code> UI is shown to the user. Once the component is loaded, the normal rendering resumes.
    </p><br />
    <p>
      You can use <code>Suspense</code> for multiple lazy-loaded components in your app:
    </p>
    <pre>
      <code>
        {`import React, { Suspense } from 'react';

const FirstComponent = React.lazy(() => import('./FirstComponent'));
const SecondComponent = React.lazy(() => import('./SecondComponent'));

const App = () => {
  return (
    <Suspense fallback={<div>Loading components...</div>}>
      <FirstComponent />
      <SecondComponent />
    </Suspense>
  );
};`}
      </code>
    </pre>
    <p>
      In this example, both <code>FirstComponent</code> and <code>SecondComponent</code> are lazily loaded, and while they are loading, the fallback UI will be displayed.
    </p>

   <br />

    <h2>Chunking and Code Splitting</h2>
    <p style={{paddingBottom:"6px"}}>
      When you use <code>React.lazy</code> to lazy load a component, React automatically splits the code into separate chunks. These chunks are loaded only when the component is rendered, thus improving the performance by not loading unnecessary code upfront.
    </p>
    <h3>Code Splitting Example</h3>
    <pre>
      <code>
        {`const AnotherComponent = React.lazy(() => import('./AnotherComponent'));`}
      </code>
    </pre>
    <p>
      In this case, <code>AnotherComponent</code> will be loaded on-demand, as needed, without loading it initially with the main bundle.
    </p>

    <br />

    <h2>Handling Multiple Suspense Components</h2>
    <p style={{paddingBottom:"6px"}}>
      You can use multiple <code>Suspense</code> components to wrap different parts of your app. Each <code>Suspense</code> can manage the loading state of specific components independently.
    </p>
    <h3>Example: Multiple Suspense Components</h3>
    <pre>
      <code>
        {`import React, { Suspense } from 'react';

const FirstComponent = React.lazy(() => import('./FirstComponent'));
const SecondComponent = React.lazy(() => import('./SecondComponent'));
const ThirdComponent = React.lazy(() => import('./ThirdComponent'));

const App = () => {
  return (
    <div>
      <Suspense fallback={<div>Loading first component...</div>}>
        <FirstComponent />
      </Suspense>
      <Suspense fallback={<div>Loading second component...</div>}>
        <SecondComponent />
      </Suspense>
      <Suspense fallback={<div>Loading third component...</div>}>
        <ThirdComponent />
      </Suspense>
    </div>
  );
};`}
      </code>
    </pre>
    <p>
      Each component is wrapped in its own <code>Suspense</code> component, with different fallback UI for each. This ensures that while one component is loading, others can render or display their own fallback UI.
    </p>

    <br />

    <h2>Optimizing User Experience with Suspense</h2>
    <p style={{paddingBottom:"6px"}}>
      While <code>Suspense</code> is used for lazy loading, it's essential to design your fallback UI to keep users informed about the loading process. You can use loading spinners, skeleton screens, or progress bars as part of your fallback UI to improve the overall user experience.
    </p>
    <h3>Example: Skeleton Loader</h3>
    <pre>
      <code>
        {`const LoadingSkeleton = () => (
  <div style={{ width: '100px', height: '20px', background: '#ccc' }} />
);

const App = () => {
  return (
    <Suspense fallback={<LoadingSkeleton />}>
      <LazyLoadedComponent />
    </Suspense>
  );
};`}
      </code>
    </pre>
    <p>
      In this example, instead of just displaying text like "Loading...", a skeleton loader is shown while the component is being fetched, providing a better user experience.
    </p>

    <br />

    <h2>Best Practices for Lazy Loading in React</h2>
    <p>
      Here are some best practices to consider when using <code>React.lazy</code> and <code>Suspense</code> for lazy loading:
      <ul>
        <li>Lazy load large, infrequently used components that are not required for the initial render.</li><br />
        <li>Use multiple <code>Suspense</code> components for finer control over different parts of your app.</li><br />
        <li>Design thoughtful fallback UIs to keep users engaged during loading times.</li><br />
        <li>Combine lazy loading with code splitting to further optimize the performance of your app.</li>
      </ul>
    </p>

   <br />

    <h2>Conclusion</h2>
    <p>
      Lazy loading is an essential optimization technique in React that allows you to reduce the initial loading time of your application by deferring the loading of components until they are needed. By using <code>React.lazy</code> and <code>Suspense</code>, you can easily implement lazy loading in your app and improve performance. However, it’s important to use it wisely and ensure a seamless user experience with appropriate fallback UIs.
    </p>
  </div>
)}



{selectedChapter === 'chapter38' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Code Splitting</h1>

    <p>
      As React applications grow, the initial bundle size can become quite large, leading to slower load times and poorer user experiences. Code splitting is a technique that allows you to split your application code into smaller chunks that can be loaded on demand, rather than loading the entire application at once. In this section, we will explore how to implement code splitting in React to optimize performance.
    </p>

    <br />

    <h2>What is Code Splitting?</h2>
    <p style={{paddingBottom:"6px"}}>
      Code splitting is the process of breaking your JavaScript code into smaller bundles or chunks that are only loaded when they are needed. Instead of loading the entire application at once, code splitting ensures that only the required parts are loaded as the user interacts with the app. This technique helps reduce the initial load time and improves overall performance.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Benefits of Code Splitting</h3>
    <ul>
      <li>Faster initial load time.</li><br />
      <li>Reduced bundle size by loading only what's necessary.</li><br />
      <li>Improved performance by loading code asynchronously.</li>
    </ul>

  <br />

    <h2>How Code Splitting Works in React</h2>
    <p style={{paddingBottom:"6px"}}>
      React uses <code>React.lazy</code> and the <code>Suspense</code> component to handle code splitting. By leveraging dynamic imports, you can tell React to load a component only when it's required.
    </p>

    <h3>Using React.lazy for Code Splitting</h3>
    <p style={{paddingBottom:"6px"}}>
      <code>React.lazy</code> allows you to define a component that should be loaded dynamically when it’s needed. When combined with <code>Suspense</code>, you can display a fallback UI while the component is loading.
    </p>
    <h4>Basic Code Splitting Example</h4>
    <pre>
      <code>
        {`import React, { Suspense } from 'react';

const MyComponent = React.lazy(() => import('./MyComponent'));

const App = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <MyComponent />
    </Suspense>
  );
};`}
      </code>
    </pre>
    <p>
      In this example:
      <ul>
        <li><code>MyComponent</code> is lazily loaded when it is rendered.</li><br />
        <li>The <code>Suspense</code> component shows a loading indicator until the component is ready.</li>
      </ul>
    </p>

   <br />

    <h2>Dynamic Imports and Code Splitting</h2>
    <p style={{paddingBottom:"6px"}}>
      In addition to <code>React.lazy</code>, you can also use dynamic imports to split larger files, modules, or libraries into separate bundles. Dynamic imports work with the <code>import()</code> function, which returns a promise that resolves to the module you want to load.
    </p>

    <h3>Dynamic Import Example</h3>
    <pre>
      <code>
        {`const OtherComponent = React.lazy(() => import('./OtherComponent'));`}
      </code>
    </pre>
    <p>
      This example dynamically imports <code>OtherComponent</code> when it’s needed, which helps reduce the initial JavaScript bundle size.
    </p>

   <br />

    <h2>Code Splitting with React Router</h2>
    <p style={{paddingBottom:"6px"}}>
      When building a single-page application (SPA) with React, you can also use code splitting in combination with React Router. This allows you to load different components or pages only when the user navigates to them, further optimizing your app's performance.
    </p>
    <h3>Code Splitting with React Router Example</h3>
    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

const HomePage = React.lazy(() => import('./HomePage'));
const AboutPage = React.lazy(() => import('./AboutPage'));

const App = () => {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route path="/" exact component={HomePage} />
          <Route path="/about" component={AboutPage} />
        </Switch>
      </Suspense>
    </Router>
  );
};`}
      </code>
    </pre>
    <p>
      In this example:
      <ul>
        <li><code>HomePage</code> and <code>AboutPage</code> are lazily loaded when the user navigates to them.</li><br />
        <li>The <code>Suspense</code> component shows a loading indicator while the components are being fetched.</li>
      </ul>
    </p>

   <br />

    <h2>Preloading Code for Faster Navigation</h2>
    <p style={{paddingBottom:"6px"}}>
      While code splitting helps load components on demand, you can also preload certain code chunks to improve navigation speed. React offers a mechanism to preload chunks using the <code>import()</code> function or <code>React.lazy</code> combined with <code>useEffect</code>.
    </p>
    <h3>Preloading with useEffect</h3>
    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`import React, { useEffect, Suspense } from 'react';

const AboutPage = React.lazy(() => import('./AboutPage'));

const App = () => {
  useEffect(() => {
    import('./AboutPage'); // Preload AboutPage before the user navigates
  }, []);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <AboutPage />
    </Suspense>
  );
};`}
      </code>
    </pre>
    <p>
      This example preloads the <code>AboutPage</code> component as soon as the component is mounted, so it's ready when the user navigates to it.
    </p>

   <br />

    <h2>Code Splitting with Webpack</h2>
    <p style={{paddingBottom:"6px"}} >
      If you're using Webpack to bundle your React application, it will automatically support code splitting through dynamic imports. Webpack splits your code into separate bundles based on the import statements in your code. By using <code>React.lazy</code> or dynamic imports, you instruct Webpack to create separate chunks for these components.
    </p>
    <h3>Code Splitting in Webpack</h3>
    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`import React from 'react';

const LazyComponent = React.lazy(() => import('./LazyComponent'));

const App = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <LazyComponent />
    </Suspense>
  );
};`}
      </code>
    </pre>
    <p>
      In this example, Webpack will create a separate bundle for <code>LazyComponent</code>, which is loaded only when needed.
    </p>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for Code Splitting in React</h2>
    <p>
      Here are some best practices for implementing code splitting in your React applications:
      <ul>
        <li>Lazy load larger, less frequently used components, such as those in settings or admin pages.</li><br />
        <li>Combine lazy loading with routing to load components only when a user navigates to a specific route.</li><br />
        <li>Use preloading for faster transitions between pages.</li><br />
        <li>Group related components together to avoid excessive chunks and reduce the number of requests.</li>
      </ul>
    </p>

<br />

    <h2>Conclusion</h2>
    <p>
      Code splitting is an essential technique in optimizing large React applications. By dynamically importing components and leveraging <code>React.lazy</code> and <code>Suspense</code>, you can load only the necessary code, improving initial load time and overall performance. When combined with routing and preloading, code splitting provides a seamless experience for users, even in large-scale applications.
    </p>
  </div>
)}





{selectedChapter === 'chapter39' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Avoiding Re-renders with useCallback and useMemo</h1>

    <p>
      Re-renders in React can cause performance issues, especially when dealing with complex components or large applications. The React rendering process is optimized, but unnecessary re-renders can still occur, especially when props or state change frequently. To avoid excessive re-renders, React provides hooks like `useCallback` and `useMemo` that help memoize functions and values, preventing unnecessary recalculations. In this section, we will explore how to use these hooks to optimize performance and avoid unnecessary re-renders.
    </p>

  <br />

    <h2>Understanding Re-renders in React</h2>
    <p>
      A re-render in React occurs when a component's state or props change. While React tries to optimize rendering by only updating the DOM when necessary, components may still re-render if functions or objects passed as props change on every render.
    </p>
    <p>
      Re-renders are especially problematic when they involve expensive computations or large components. This is where `useCallback` and `useMemo` can make a difference, as they allow you to control when these functions or values should be recalculated.
    </p>

   <br />

    <h2>Using `useCallback` to Prevent Function Re-creation</h2>
    <p style={{paddingBottom:"6px"}}>
      The `useCallback` hook is used to memoize functions, ensuring that a function is only re-created when its dependencies change. By using `useCallback`, you can prevent unnecessary re-creations of the same function on each render.
    </p>
    <h3>Basic Usage of `useCallback`</h3>
    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`import React, { useState, useCallback } from 'react';

const ExpensiveComponent = ({ onButtonClick }) => {
  console.log('Rendering ExpensiveComponent');
  return <button onClick={onButtonClick}>Click Me</button>;
};

const ParentComponent = () => {
  const [count, setCount] = useState(0);

  // useCallback ensures that this function is not recreated on every render
  const handleClick = useCallback(() => {
    console.log('Button Clicked');
  }, []);

  return (
    <div>
      <p>Count: {count}</p>
      <ExpensiveComponent onButtonClick={handleClick} />
      <button onClick={() => setCount(count + 1)}>Increment Count</button>
    </div>
  );
};`}
      </code>
    </pre>
    <p>
      In this example:
      <ul>
        <li>The `handleClick` function is wrapped with `useCallback`, so it only changes if its dependencies (in this case, none) change.</li> <br />
        <li>Without `useCallback`, `handleClick` would be re-created on each render, causing `ExpensiveComponent` to re-render unnecessarily.</li>
      </ul>
    </p>

    <br />

    <h2>When to Use `useCallback`</h2>
    <p>
      While `useCallback` can be helpful in preventing unnecessary re-renders, it should be used judiciously. Memoizing functions that are passed as props to child components can be particularly beneficial when those components are heavy or have costly re-renders.
    </p>
    <ul>
      <li>Use `useCallback` when passing functions as props to prevent child components from re-rendering unless the function itself changes.</li><br />
      <li>Avoid using `useCallback` on every function—only memoize functions that are likely to cause unnecessary renders or are expensive.</li>
    </ul>

   <br />

    <h2>Using `useMemo` to Prevent Expensive Calculations</h2>
    <p style={{paddingBottom:"6px"}}>
      Similar to `useCallback`, the `useMemo` hook is used to memoize computed values, preventing expensive recalculations unless the dependencies change. This is particularly useful for expensive operations such as filtering or sorting large datasets.
    </p>
    <h3>Basic Usage of `useMemo`</h3>
    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`import React, { useMemo } from 'react';

const ExpensiveCalculationComponent = ({ data }) => {
  const filteredData = useMemo(() => {
    console.log('Filtering data...');
    return data.filter(item => item.value > 10);
  }, [data]);

  return <div>{filteredData.length} items</div>;
};`}
      </code>
    </pre>
    <p>
      In this example:
      <ul>
        <li>The filtering operation is wrapped with `useMemo`, so it is only re-executed when the `data` array changes.</li><br />
        <li>Without `useMemo`, the `filter` function would run on every render, which could lead to unnecessary calculations if the data hasn't changed.</li>
      </ul>
    </p>

    <br />

    <h2>When to Use `useMemo`</h2>
    <p style={{paddingBottom:"6px"}}>
      While `useMemo` can prevent unnecessary recalculations of expensive values, it should only be used when the computation is costly enough to warrant memoization. Overusing `useMemo` can lead to unnecessary complexity and might actually hurt performance.
    </p>
    <ul>
      <li>Use `useMemo` when performing expensive operations, such as complex calculations, filtering, or sorting, on large datasets.</li><br />
      <li>Don’t use `useMemo` for simple operations, as it can add overhead that may not be necessary.</li>
    </ul>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for `useCallback` and `useMemo`</h2>
    <ul>
      <li><strong>Use only when necessary:</strong> Memoization adds a layer of complexity. Avoid using `useMemo` and `useCallback` unless you notice performance issues caused by unnecessary re-renders or recalculations.</li><br />
      <li><strong>Understand dependencies:</strong> Always provide the correct dependencies for `useCallback` and `useMemo` to ensure that they behave as expected. Failing to do so can lead to stale values or unnecessary recalculations.</li><br />
      <li><strong>Use in conjunction with React DevTools:</strong> Leverage React's built-in performance profiling tools to identify when re-renders are happening and whether memoization is needed.</li>
    </ul>

    <br />

    <h2>Conclusion</h2>
    <p>
      React's `useCallback` and `useMemo` hooks provide powerful tools for optimizing performance by preventing unnecessary re-renders and recalculations. By memoizing functions and values, you can reduce the load on the browser and ensure your application remains fast, even as it grows. However, it’s essential to use these hooks judiciously and only when necessary to avoid over-complicating your code.
    </p>
  </div>
)}



{selectedChapter === 'chapter40' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Introduction to Testing in React.js</h1>

    <p>
      Testing is an essential part of the development process, ensuring that your code behaves as expected and reducing the chances of bugs in production. In React.js, testing helps validate the functionality of components, hooks, and user interactions, making it easier to maintain and scale applications. This chapter introduces the importance of testing in React and provides an overview of the testing tools and techniques commonly used in the React ecosystem.
    </p>

  <br />

    <h2>Why Testing is Important in React</h2>
    <p style={{paddingBottom:"6px"}}>
      Testing plays a vital role in maintaining code quality, especially in large applications. In React, testing allows you to:
    </p>
    <ul>
      <li><strong>Ensure reliability:</strong> Automated tests can catch bugs early, preventing unexpected issues in production.</li><br />
      <li><strong>Refactor confidently:</strong> Tests act as a safety net, allowing developers to refactor code without fear of breaking functionality.</li><br />
      <li><strong>Improve code maintainability:</strong> Well-written tests improve code readability and encourage better design decisions.</li>
    </ul>

   <br />

    <h2>Types of Tests in React</h2>
    <p style={{paddingBottom:"6px"}}>
      In React, you can perform different types of tests at various levels, such as unit testing, integration testing, and end-to-end testing. Let’s break them down:
    </p>
    <ul>
      <li><strong>Unit Tests:</strong> Test individual components or functions in isolation. Unit tests focus on the smallest parts of the application.</li><br />
      <li><strong>Integration Tests:</strong> Ensure that different parts of the application work together correctly, for example, testing how components interact with APIs or other components.</li><br />
      <li><strong>End-to-End (E2E) Tests:</strong> Simulate real user interactions and test the entire application’s flow, ensuring everything works as expected from the user's perspective.</li>
    </ul>

    <br />

    <h2>Testing Tools for React</h2>
    <p style={{paddingBottom:"6px"}}>
      React has several popular tools for testing, each serving a different purpose. Some of the most commonly used testing libraries in React include:
    </p>

    <h3>1. Jest</h3>
    <p>
      Jest is a testing framework developed by Facebook and is the most commonly used tool for testing in React applications. It provides a rich set of utilities for writing and running tests, including assertions, mocks, and snapshots.
    </p>
    <p>
      Key features of Jest:
      <ul>
        <li>Zero configuration for React projects.</li><br />
        <li>Fast test execution with parallel test runners.</li><br />
        <li>Snapshot testing for React components.</li><br />
        <li>Mocking functions, modules, and timers.</li>
      </ul>
    </p><br />

    <h3>2. React Testing Library</h3>
    <p>
      The React Testing Library is focused on testing components from the user's perspective, ensuring that tests are less coupled to the implementation details. It encourages testing the component's behavior rather than its internal structure.
    </p>
    <p>
      Key features of React Testing Library:
      <ul>
        <li>Render components and query DOM elements the way a user would interact with them.</li><br />
        <li>Promotes accessibility by encouraging the use of semantic queries like `getByRole` and `getByLabelText`.</li><br />
        <li>Simple API for querying and interacting with the component tree.</li>
      </ul>
    </p><br />

    <h3>3. Enzyme (Alternative to React Testing Library)</h3>
    <p>
      Enzyme is another popular testing library for React. It was created by Airbnb and allows you to shallow render components, perform unit testing, and simulate user interactions.
    </p>
    <p>
      Key features of Enzyme:
      <ul>
        <li>Shallow rendering for testing components in isolation.</li><br />
        <li>Full rendering for testing components with all child components.</li><br />
        <li>Simulate events like clicks and form submissions.</li>
      </ul>
    </p>

   <br />

    <h2>Basic Example: Setting Up Jest and React Testing Library</h2>
    <p style={{paddingBottom:"6px"}}>
      Let's walk through a basic example of setting up Jest and React Testing Library to test a simple React component.
    </p>

    <h3>1. Setting up the Environment</h3>
    <p>
      If you're using Create React App, Jest and React Testing Library come pre-installed. If not, you can install them with the following commands:
    </p>
    <pre>
      <code>
        {`npm install --save-dev jest @testing-library/react @testing-library/jest-dom`}
      </code>
    </pre><br />

    <h3>2. Writing a Simple Test</h3>
    <p>
      Let's create a simple React component and write a test for it using React Testing Library.
    </p>
    <pre>
      <code>
        {`// Button.js
import React from 'react';

const Button = ({ onClick, label }) => {
  return <button onClick={onClick}>{label}</button>;
};

export default Button;`}
      </code>
    </pre>

    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`// Button.test.js
import { render, screen, fireEvent } from '@testing-library/react';
import Button from './Button';

test('renders button with label', () => {
  render(<Button label="Click me" />);
  const buttonElement = screen.getByText(/Click me/i);
  expect(buttonElement).toBeInTheDocument();
});

test('button click triggers function', () => {
  const mockFn = jest.fn();
  render(<Button label="Click me" onClick={mockFn} />);
  const buttonElement = screen.getByText(/Click me/i);
  fireEvent.click(buttonElement);
  expect(mockFn).toHaveBeenCalledTimes(1);
});`}
      </code>
    </pre>

    <p>
      In this example:
      <ul>
        <li>We rendered the `Button` component using `render()` from React Testing Library.</li><br />
        <li>We queried the button by its text content and checked if it’s present in the document.</li><br />
        <li>We simulated a click event with `fireEvent.click()` and checked if the mock function was called.</li>
      </ul>
    </p>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for Testing in React</h2>
    <ul>
      <li><strong>Write readable tests:</strong> Tests should be easy to read and understand. Focus on testing the behavior of the component, not its implementation details.</li><br />
      <li><strong>Test components in isolation:</strong> When possible, test individual components in isolation before testing their interactions with others.</li><br />
      <li><strong>Use mock functions:</strong> For event handling or external API calls, use Jest's `mock` and `spy` functions to simulate behavior and isolate tests.</li><br />
      <li><strong>Test user interactions:</strong> Test how users interact with the app (e.g., clicks, form submissions, etc.) rather than the internals of components.</li><br />
      <li><strong>Write tests for edge cases:</strong> Test how your component behaves with various inputs, including edge cases like empty values or incorrect data types.</li>
    </ul>

   <br />

    <h2>Conclusion</h2>
    <p>
      Testing in React is crucial for maintaining code quality, preventing bugs, and enabling confident refactoring. By using tools like Jest and React Testing Library, you can ensure that your React components function as expected and that your app behaves correctly under various scenarios. While writing tests can require additional effort, the long-term benefits in terms of reliability and maintainability make it an essential practice for any React developer.
    </p>
  </div>
)}


{selectedChapter === 'chapter41' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Unit Testing with Jest</h1>

    <p>
      Unit testing is a fundamental practice in software development that involves testing individual components or functions to ensure they work as expected. Jest is a powerful testing framework developed by Facebook, which is widely used for unit testing in React applications. This chapter will introduce you to unit testing with Jest, covering key concepts, tools, and practical examples for testing React components.
    </p>

   <br />

    <h2>What is Jest?</h2>
    <p>
      Jest is a JavaScript testing framework that provides an easy-to-use API for writing unit tests, running tests, and asserting expected outcomes. It’s designed to work seamlessly with React and other JavaScript applications.
    </p>
    <p>
      Key features of Jest:
      <ul>
        <li><strong>Zero configuration:</strong> Jest requires minimal setup to get started, especially with Create React App.</li><br />
        <li><strong>Snapshot testing:</strong> Jest allows you to test the structure of components by capturing snapshots of their rendered output.</li><br />
        <li><strong>Mocking and spying:</strong> Jest provides built-in functionality for mocking functions and spying on function calls.</li><br />
        <li><strong>Parallel test running:</strong> Jest runs tests in parallel for faster test execution.</li><br />
        <li><strong>Built-in assertion library:</strong> Jest comes with an assertion library to check test results (e.g., `expect()` statements).</li>
      </ul>
    </p>

    <br />

    <h2>Setting Up Jest in React</h2>
    <p style={{paddingBottom:"6px"}}>
      If you're using Create React App, Jest is already set up for you. However, if you’re starting a new project or need to configure Jest manually, follow these steps:
    </p>

    <h3>1. Installing Jest</h3>
    <p>
      To install Jest in a React project, run the following command:
    </p>
    <pre>
      <code>
        {`npm install --save-dev jest`}
      </code>
    </pre><br />

    <h3>2. Running Tests with Jest</h3>
    <p>
      Once Jest is installed, you can run tests with the following command:
    </p>
    <pre>
      <code>
        {`npm test`}
      </code>
    </pre>
    <p>
      By default, Jest will look for files with the `.test.js` or `.spec.js` extensions and run them.
    </p>

    <br />

    <h2>Writing Unit Tests with Jest</h2>
    <p>
      A unit test in Jest typically involves three steps:
      <ol>
        <li><strong>Arrange:</strong> Set up the initial conditions and inputs for the test.</li><br />
        <li><strong>Act:</strong> Perform the action you want to test (e.g., invoking a function or rendering a component).</li><br />
        <li><strong>Assert:</strong> Check if the expected output or behavior occurred.</li>
      </ol>
    </p><br />

    <h3>Example: Testing a Simple Function</h3>
    <p>
      Let's start with a simple example of testing a function that adds two numbers.
    </p>
    <pre>
      <code>
        {`// add.js
export const add = (a, b) => a + b;`}
      </code>
    </pre>

    <pre>
      <code>
        {`// add.test.js
import { add } from './add';

test('adds 1 + 2 to equal 3', () => {
  expect(add(1, 2)).toBe(3);
});`}
      </code>
    </pre>

    <p>
      In this example:
      <ul>
        <li>We’re testing the `add` function in the `add.js` file.</li><br />
        <li>We use Jest's `test()` function to define the test case.</li><br />
        <li>Inside the test, we use the `expect()` function to make assertions about the result of the `add` function.</li><br />
        <li>The `toBe()` matcher checks if the returned value is equal to the expected result (3 in this case).</li>
      </ul>
    </p>
<br />

    <h2>Unit Testing React Components</h2>
    <p style={{paddingBottom:"6px"}}>
      Jest works well with React components, especially when combined with React Testing Library. Here’s an example of how to test a simple React component with Jest.
    </p>

    <h3>Example: Testing a Button Component</h3>
    <p>
      Let's test a simple `Button` component that takes a label and triggers a click event handler.
    </p>
    <pre>
      <code>
        {`// Button.js
import React from 'react';

const Button = ({ onClick, label }) => {
  return <button onClick={onClick}>{label}</button>;
};

export default Button;`}
      </code>
    </pre>

    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`// Button.test.js
import { render, screen, fireEvent } from '@testing-library/react';
import Button from './Button';

test('renders button with label', () => {
  render(<Button label="Click me" />);
  const buttonElement = screen.getByText(/Click me/i);
  expect(buttonElement).toBeInTheDocument();
});

test('button click triggers function', () => {
  const mockFn = jest.fn();
  render(<Button label="Click me" onClick={mockFn} />);
  const buttonElement = screen.getByText(/Click me/i);
  fireEvent.click(buttonElement);
  expect(mockFn).toHaveBeenCalledTimes(1);
});`}
      </code>
    </pre>

    <p>
      In this example:
      <ul>
        <li>We rendered the `Button` component using React Testing Library’s `render()` function.</li><br />
        <li>We used `screen.getByText()` to find the button by its label and asserted that it was present in the document.</li><br />
        <li>We simulated a click event using `fireEvent.click()` and checked if the mock function was called using `jest.fn()`.</li>
      </ul>
    </p>

    <br />

    <h2>Mocking Functions and Modules with Jest</h2>
    <p style={{paddingBottom:"6px"}}>
      Jest provides powerful tools for mocking functions, modules, and timers. This is useful when testing components that rely on external APIs or complex logic.
    </p>

    <h3>Mocking Functions</h3>
    <p>
      You can mock a function using `jest.fn()`, which allows you to track how many times the function was called and what arguments were passed to it.
    </p>
    <pre>
      <code>
        {`const mockFunction = jest.fn();
mockFunction('Hello');
expect(mockFunction).toHaveBeenCalledWith('Hello');
expect(mockFunction).toHaveBeenCalledTimes(1);`}
      </code>
    </pre><br />

    <h3>Mocking Modules</h3>
    <p>
      Jest also allows you to mock entire modules to isolate the unit you are testing from external dependencies.
    </p>
    <pre>
      <code>
        {`jest.mock('axios');
import axios from 'axios';

test('fetches data from API', async () => {
  axios.get.mockResolvedValue({ data: 'Hello World' });
  const response = await axios.get('https://api.example.com');
  expect(response.data).toBe('Hello World');
});`}
      </code>
    </pre>

    <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for Unit Testing with Jest</h2>
    <ul>
      <li><strong>Write clear and descriptive test names:</strong> The test name should clearly describe the behavior being tested.</li><br />
      <li><strong>Test only one thing at a time:</strong> Focus on a single piece of functionality in each test to keep tests isolated and easier to debug.</li><br />
      <li><strong>Use mocking and stubbing wisely:</strong> Mock external dependencies to avoid making real network calls or interacting with the file system in your tests.</li><br />
      <li><strong>Keep tests fast:</strong> Try to avoid slow tests that could negatively affect the developer experience during test execution.</li><br />
      <li><strong>Ensure tests are deterministic:</strong> Tests should produce the same results each time they are run, regardless of the environment.</li>
    </ul>

    <br />

    <h2>Conclusion</h2>
    <p>
      Unit testing with Jest is a powerful way to ensure that individual pieces of your React application function as expected. By writing unit tests for functions and React components, you can catch bugs early, make your code more maintainable, and build more reliable applications. Jest provides an intuitive and efficient way to write, run, and debug tests in your React projects.
    </p>
  </div>
)}




{selectedChapter === 'chapter42' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Component Testing with React Testing Library</h1>

    <p>
      Component testing is essential in ensuring that individual React components work as expected in isolation. React Testing Library is a popular testing utility that provides a simple and effective way to test React components by simulating user interactions and validating their behavior. This chapter will guide you through the concepts and practical examples of component testing using React Testing Library.
    </p>

   <br />

    <h2>What is React Testing Library?</h2>
    <p>
      React Testing Library (RTL) is a lightweight testing library that encourages testing from the user’s perspective rather than testing implementation details. It is designed to help you write tests that focus on how your components behave, rather than how they are structured.
    </p>
    <p>
      Key features of React Testing Library:
      <ul>
        <li><strong>Queries based on accessibility:</strong> RTL encourages using queries like `getByRole`, `getByText`, and `getByLabelText`, which are more aligned with how users interact with the app.</li><br />
        <li><strong>Focusing on behavior:</strong> RTL helps test how components behave by interacting with them in ways users would, such as clicking buttons, filling out forms, and making API requests.</li><br />
        <li><strong>No reliance on implementation details:</strong> RTL helps you avoid tests that depend on specific internal structure or implementation, making tests more resilient to changes.</li><br />
        <li><strong>Lightweight and easy to use:</strong> React Testing Library integrates well with Jest and other testing utilities, making it easy to start writing tests quickly.</li>
      </ul>
    </p><br />

 

    <h2>Setting Up React Testing Library</h2>
    <p style={{paddingBottom:"6px"}}>
      React Testing Library works seamlessly with Jest, which is the default testing framework when using Create React App. If you're not using Create React App, you'll need to install it manually. Follow these steps to get started with React Testing Library:
    </p>

    <h3>1. Installing React Testing Library</h3>
    <p>
      To install React Testing Library in your project, run the following command:
    </p>
    <pre>
      <code>
        {`npm install --save-dev @testing-library/react @testing-library/jest-dom`}
      </code>
    </pre><br />

    <h3>2. Setting Up Jest</h3>
    <p>
      If Jest isn't already set up in your project, you can install it with the following command:
    </p>
    <pre>
      <code>
        {`npm install --save-dev jest`}
      </code>
    </pre>
    <p>
      Once installed, Jest will run tests in files with the `.test.js` or `.spec.js` extension.
    </p>

    <br />
    <h2>Writing Component Tests with React Testing Library</h2>
    <p>
      To write tests using React Testing Library, follow these general steps:
      <ol>
        <li><strong>Render:</strong> Render the component into a virtual DOM using the `render()` function.</li><br />
        <li><strong>Query:</strong> Find elements within the component using queries like `getByText`, `getByRole`, `getByTestId`, etc.</li><br />
        <li><strong>Interact:</strong> Simulate user interactions like clicks, typing, etc., using utilities like `fireEvent` or `userEvent`.</li><br />
        <li><strong>Assert:</strong> Check if the component behaves as expected using assertions like `expect()` from Jest.</li>
      </ol>
    </p><br />

    <h3>Example 1: Testing a Simple Button Component</h3>
    <p>
      Let’s test a simple `Button` component that shows a label and calls an `onClick` function when clicked.
    </p>
    <pre>
      <code>
        {`// Button.js
import React from 'react';

const Button = ({ label, onClick }) => {
  return <button onClick={onClick}>{label}</button>;
};

export default Button;`}
      </code>
    </pre>

    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`// Button.test.js
import { render, screen, fireEvent } from '@testing-library/react';
import Button from './Button';

test('renders button with label and handles click event', () => {
  const mockFn = jest.fn();
  render(<Button label="Click me" onClick={mockFn} />);
  
  const button = screen.getByText(/Click me/i);
  expect(button).toBeInTheDocument();
  
  fireEvent.click(button);
  expect(mockFn).toHaveBeenCalledTimes(1);
});`}
      </code>
    </pre>

    <p>
      In this example:
      <ul>
        <li>The `render()` function is used to render the `Button` component into a virtual DOM.</li><br />
        <li>The `screen.getByText()` query is used to find the button element by its label text.</li><br />
        <li>We simulate a click using `fireEvent.click()` and check if the `onClick` function was called using `jest.fn()`.</li>
      </ul>
    </p><br />



    <h2>Simulating User Interactions</h2>
    <p style={{paddingBottom:"6px"}}>
      React Testing Library allows you to simulate real user interactions, such as typing in an input field, clicking buttons, or selecting dropdown options. The most commonly used utility for this is `fireEvent`, which triggers events such as `click`, `change`, `submit`, etc.
    </p>

    <h3>Example 2: Testing a Form Submission</h3>
    <p>
      Let's test a `Form` component where a user types into an input field and submits the form.
    </p>
    <pre>
      <code>
        {`// Form.js
import React, { useState } from 'react';

const Form = ({ onSubmit }) => {
  const [input, setInput] = useState('');

  const handleChange = (e) => setInput(e.target.value);
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(input);
  };

  return (
    <form onSubmit={handleSubmit}>
      <input type="text" value={input} onChange={handleChange} />
      <button type="submit">Submit</button>
    </form>
  );
};

export default Form;`}
      </code>
    </pre>

    <pre>
      <code>
        {`// Form.test.js
import { render, screen, fireEvent } from '@testing-library/react';
import Form from './Form';

test('submits form with correct input value', () => {
  const mockSubmit = jest.fn();
  render(<Form onSubmit={mockSubmit} />);
  
  const inputElement = screen.getByRole('textbox');
  fireEvent.change(inputElement, { target: { value: 'Test value' } });
  
  const submitButton = screen.getByRole('button', { name: /submit/i });
  fireEvent.click(submitButton);
  
  expect(mockSubmit).toHaveBeenCalledWith('Test value');
});`}
      </code>
    </pre>

    <p>
      In this example:
      <ul>
        <li>The `fireEvent.change()` is used to simulate typing in the input field.</li><br />
        <li>The `fireEvent.click()` simulates the form submission when the user clicks the submit button.</li><br />
        <li>We assert that the mock `onSubmit` function was called with the correct value (`'Test value'`).</li>
      </ul>
    </p>

    <br />

    <h2>Testing Asynchronous Components</h2>
    <p style={{paddingBottom:"6px"}}>
      Sometimes, components perform asynchronous operations, like fetching data from an API. React Testing Library provides utilities to test these asynchronous behaviors.
    </p>

    <h3>Example 3: Testing an Asynchronous API Call</h3>
    <p>
      Let's test a component that fetches data from an API and displays the result.
    </p>
    <pre>
      <code>
        {`// FetchData.js
import React, { useState, useEffect } from 'react';

const FetchData = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch('https://api.example.com/data')
      .then((response) => response.json())
      .then((data) => setData(data));
  }, []);

  return <div>{data ? data.message : 'Loading...'}</div>;
};

export default FetchData;`}
      </code>
    </pre>

    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`// FetchData.test.js
import { render, screen, waitFor } from '@testing-library/react';
import FetchData from './FetchData';

test('fetches and displays data', async () => {
  global.fetch = jest.fn(() =>
    Promise.resolve({ json: () => Promise.resolve({ message: 'Hello, World!' }) })
  );
  
  render(<FetchData />);
  
  await waitFor(() => screen.getByText(/Hello, World!/i));
  expect(screen.getByText(/Hello, World!/i)).toBeInTheDocument();
});`}
      </code>
    </pre>

    <p>
      In this example:
      <ul>
        <li>We mock the `fetch` API call using `jest.fn()` to simulate fetching data from an API.</li><br />
        <li>The `waitFor()` function waits for the asynchronous content to appear in the DOM.</li><br />
        <li>We assert that the data (`'Hello, World!'`) is displayed in the component once the fetch is complete.</li>
      </ul>
    </p>

  <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for Component Testing with React Testing Library</h2>
    <ul>
      <li><strong>Test components from the user’s perspective:</strong> Focus on how the component behaves, not its internal implementation.</li><br />
      <li><strong>Use queries based on accessibility:</strong> Use `getByRole`, `getByLabelText`, and `getByText` instead of `getById` or `getByClassName` to improve accessibility and ensure tests are aligned with real-world usage.</li><br />
      <li><strong>Test user interactions:</strong> Simulate real user events (e.g., clicking, typing) to validate component behavior.</li><br />
      <li><strong>Avoid testing implementation details:</strong> Test what a component does rather than how it does it, to make tests more robust to changes.</li>
    </ul>

    <br />

    <h2>Conclusion</h2>
    <p>
      React Testing Library is a powerful tool for testing React components by simulating user interactions and validating expected behavior. By focusing on how users interact with your app, RTL helps you write meaningful tests that ensure your components behave correctly. As you build more complex React applications, component testing with React Testing Library will help you catch bugs early and maintain confidence in your app’s functionality.
    </p>
  </div>
)}





{selectedChapter === 'chapter43' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>End-to-End Testing with Cypress or Playwright</h1>

    <p>
      End-to-End (E2E) testing ensures that the entire application works as expected from the user’s perspective. It involves testing the application from start to finish, simulating real-world scenarios to verify that all components function correctly together. In this chapter, we'll explore how to use two powerful tools for E2E testing—Cypress and Playwright—and demonstrate how they can be integrated into a React.js application.
    </p>
<br />

    <h2>What is End-to-End Testing?</h2>
    <p>
      End-to-End testing is a crucial part of the testing pyramid that ensures your application's workflow is working as intended. It validates that your system behaves correctly from the user's point of view, simulating real-world user interactions like filling forms, clicking buttons, navigating between pages, and more.
    </p>
    <p>
      The goal of E2E testing is to identify issues in the entire system, such as broken links, incorrect form submissions, or missing user interface elements, that might not be caught during unit or integration testing.
    </p>

   <br />

    <h2>Cypress Overview</h2>
    <p style={{paddingBottom:"6px"}}>
      Cypress is a popular end-to-end testing framework for web applications that makes it easy to write tests for modern web apps. It is fast, reliable, and easy to set up and integrates well with modern JavaScript frameworks like React.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Cypress:</h3>
    <ul>
      <li><strong>Automatic Waiting:</strong> Cypress automatically waits for elements to appear before interacting with them, reducing the need for manual wait times in tests.</li><br />
      <li><strong>Real-Time Reloads:</strong> Tests are automatically re-run in real-time as you make changes, providing instant feedback.</li><br />
      <li><strong>Easy Debugging:</strong> Cypress provides detailed error messages and an interactive browser, which makes debugging easier.</li><br />
      <li><strong>Network Traffic Control:</strong> Cypress allows you to stub and mock network requests, making it easy to test different scenarios without relying on actual API calls.</li>
    </ul><br />

    <h3>Setting Up Cypress</h3>
    <p>
      To get started with Cypress in a React project, you can install it using npm or yarn:
    </p>
    <pre>
      <code>
        {`npm install cypress --save-dev`}
      </code>
    </pre>
    <p>
      Once installed, you can open the Cypress test runner with:
    </p>
    <pre>
      <code>
        {`npx cypress open`}
      </code>
    </pre>
    <p>
      This will launch the Cypress app, where you can begin writing and running tests for your application.
    </p><br />

    <h3>Writing a Simple Cypress Test</h3>
    <p>
      Below is an example of a simple Cypress test that visits a page and checks if the page contains a specific element.
    </p>
    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`describe('My First Test', () => {
          it('Visits the React app and checks for a heading', () => {
            cy.visit('http://localhost:3000');
            cy.contains('Welcome to React');
          });
        });`}
      </code>
    </pre>
    <p>
      In this example:
      <ul>
        <li><strong>cy.visit()</strong>: Opens the React app in the browser.</li><br />
        <li><strong>cy.contains()</strong>: Checks if the page contains the text "Welcome to React".</li>
      </ul>
    </p>

   <br />

    <h2>Playwright Overview</h2>
    <p style={{paddingBottom:"6px"}}>
      Playwright is another popular end-to-end testing framework for modern web applications. It is built by Microsoft and offers cross-browser testing for Chrome, Firefox, and WebKit. Playwright is a newer tool but is gaining popularity due to its powerful capabilities and ease of use.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Playwright:</h3>
    <ul>
      <li><strong>Cross-Browser Testing:</strong> Playwright supports testing across all major browsers, including Chrome, Firefox, and WebKit, ensuring that your application works across different environments.</li><br />
      <li><strong>Fast and Reliable:</strong> Playwright provides fast execution and reliable results by controlling the browser directly without relying on WebDriver.</li><br />
      <li><strong>Multiple Contexts:</strong> Playwright allows you to simulate different browser contexts, making it easier to test scenarios like multiple users or different device configurations.</li><br />
      <li><strong>Network Interception:</strong> Like Cypress, Playwright supports intercepting network requests, which allows you to test your app with mock data or simulate slow network conditions.</li>
    </ul><br />

    <h3>Setting Up Playwright</h3>
    <p>
      To install Playwright in a React project, you can use the following command:
    </p>
    <pre>
      <code>
        {`npm install playwright --save-dev`}
      </code>
    </pre>
    <p>
      Once installed, you can write and run your tests by creating a test file in the `tests` directory and running it using the Playwright test runner:
    </p>
    <pre>
      <code>
        {`npx playwright test`}
      </code>
    </pre><br />

    <h3>Writing a Simple Playwright Test</h3>
    <p>
      Below is an example of a simple Playwright test that opens a page and checks for the presence of a specific element:
    </p>
    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`const { test, expect } = require('@playwright/test');

        test('Visit the React app and check for a heading', async ({ page }) => {
          await page.goto('http://localhost:3000');
          await expect(page).toHaveText('Welcome to React');
        });`}
      </code>
    </pre>
    <p>
      In this example:
      <ul>
        <li><strong>page.goto()</strong>: Navigates to the React app.</li><br />
        <li><strong>expect(page).toHaveText()</strong>: Verifies that the page contains the text "Welcome to React".</li>
      </ul>
    </p>

   <br />

    <h2>Comparing Cypress and Playwright</h2>
    <p>
      Both Cypress and Playwright offer great capabilities for end-to-end testing, but they have some differences. Here's a comparison to help you choose the best tool for your project:
    </p>
    <h3 style={{paddingBottom:"6px"}}>1. Browser Support</h3>
    <ul>
      <li><strong>Cypress:</strong> Supports Chrome, Edge, and Electron. Other browsers can be tested with workarounds or plugins.</li><br />
      <li><strong>Playwright:</strong> Supports Chrome, Firefox, and WebKit (Safari), which provides broader cross-browser testing.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>2. Test Execution Speed</h3>
    <ul>
      <li><strong>Cypress:</strong> Fast for single browser testing, but can slow down when running tests in multiple parallel instances.</li><br />
      <li><strong>Playwright:</strong> Fast and more efficient, especially for cross-browser testing and multiple browser contexts.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>3. Debugging</h3>
    <ul>
      <li><strong>Cypress:</strong> Offers excellent debugging tools, such as snapshots, time travel, and detailed error messages.</li><br />
      <li><strong>Playwright:</strong> Provides solid debugging tools and can take screenshots and videos for each test step.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>4. API and Setup</h3>
    <ul>
      <li><strong>Cypress:</strong> Simple and easy to set up with a user-friendly interface and built-in features like automatic waiting.</li><br />
      <li><strong>Playwright:</strong> Requires a bit more setup and configuration, but provides greater flexibility for advanced testing scenarios.</li>
    </ul>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for End-to-End Testing</h2>
    <ul>
      <li><strong>Test User Flows:</strong> Focus on testing real user interactions and scenarios rather than implementation details.</li><br />
      <li><strong>Keep Tests Maintainable:</strong> Write clean, reusable tests that can be maintained as your application evolves.</li><br />
      <li><strong>Test Across Different Browsers:</strong> Ensure your app works well on all major browsers, especially if your app has complex UI elements.</li><br />
      <li><strong>Run Tests in Continuous Integration:</strong> Integrate your E2E tests into your CI/CD pipeline to catch issues early in the development process.</li>
    </ul>

    <br />

    <h2>Conclusion</h2>
    <p>
      End-to-End testing with tools like Cypress and Playwright helps ensure that your application behaves as expected across real user scenarios. While both tools offer similar functionality, your choice will depend on your specific testing needs and preferences. Whether you choose Cypress for its simplicity and speed or Playwright for its cross-browser capabilities, both tools are excellent choices for writing comprehensive, reliable E2E tests in your React applications.
    </p>
  </div>
)}





{selectedChapter === 'chapter44' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Using Third-Party Libraries: React Bootstrap, Material-UI (MUI), Ant Design</h1>

    <p>
      The React ecosystem is vast, with many third-party libraries available to help developers quickly build beautiful and responsive UIs. Libraries like React Bootstrap, Material-UI (MUI), and Ant Design offer pre-built components and styles that are customizable, reducing development time and effort. In this chapter, we will explore these three popular UI libraries and demonstrate how to integrate them into a React project.
    </p>

    <br />

    <h2>Why Use Third-Party Libraries in React?</h2>
    <p style={{paddingBottom:"6px"}}>
      Third-party libraries offer several benefits when building React applications:
    </p>
    <ul>
      <li><strong>Faster Development:</strong> With pre-designed components and UI elements, you can avoid building common UI components from scratch.</li><br />
      <li><strong>Responsive Design:</strong> Many libraries come with built-in responsive design principles, ensuring your app looks good on all screen sizes.</li><br />
      <li><strong>Customizability:</strong> Libraries like Material-UI and Ant Design offer theming capabilities to easily adjust the style of components to fit your design requirements.</li><br />
      <li><strong>Consistent UI/UX:</strong> These libraries provide well-designed components that adhere to modern design principles, resulting in a polished user experience.</li>
    </ul>

   <br />
    <h2>React Bootstrap</h2>
    <p style={{paddingBottom:"6px"}}>
      React Bootstrap is a popular library that provides Bootstrap components as React components. It is a great option for developers who want to integrate the familiar Bootstrap framework into their React applications.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of React Bootstrap:</h3>
    <ul>
      <li><strong>Bootstrap Components as React Components:</strong> It offers Bootstrap's grid system, forms, buttons, and modals as React components, making it easy to work with in a React project.</li><br />
      <li><strong>Customizable:</strong> React Bootstrap allows you to customize Bootstrap components, making them more adaptable to your app's needs.</li><br />
      <li><strong>No jQuery Dependency:</strong> Unlike traditional Bootstrap, React Bootstrap does not require jQuery, making it more suitable for React apps.</li>
    </ul>
<br />
    <h3>Installing React Bootstrap</h3>
    <p>
      To get started with React Bootstrap, you need to install it along with Bootstrap:
    </p>
    <pre>
      <code>
        {`npm install react-bootstrap bootstrap`}
      </code>
    </pre>
    <p>
      Once installed, you can start using React Bootstrap components like the following:
    </p>
    <pre>
      <code>
        {`import { Button } from 'react-bootstrap';

        function App() {
          return (
            <Button variant="primary">Primary Button</Button>
          );
        }`}
      </code>
    </pre>

    <br />

    <h2>Material-UI (MUI)</h2>
    <p style={{paddingBottom:"6px"}}>
      Material-UI, now called MUI, is a popular React UI framework that implements Google's Material Design system. It offers a wide range of high-quality, customizable components that follow Material Design principles.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of MUI:</h3>
    <ul>
      <li><strong>Material Design Components:</strong> MUI provides a wide range of pre-designed components such as buttons, grids, text fields, and more, all designed according to Material Design guidelines.</li><br />
      <li><strong>Customizable Themes:</strong> MUI allows you to customize the theme of your application, including colors, typography, and spacing, to match your design vision.</li><br />
      <li><strong>Responsive Layouts:</strong> MUI provides a powerful grid system that helps you build responsive and adaptive layouts effortlessly.</li>
    </ul><br />

    <h3>Installing MUI</h3>
    <p>
      To install MUI, you can use the following npm command:
    </p>
    <pre>
      <code>
        {`npm install @mui/material @emotion/react @emotion/styled`}
      </code>
    </pre>
    <p>
      After installation, you can start using MUI components in your app like this:
    </p>
    <pre>
      <code>
        {`import { Button } from '@mui/material';

        function App() {
          return (
            <Button variant="contained" color="primary">Primary Button</Button>
          );
        }`}
      </code>
    </pre>

  <br />

    <h2>Ant Design</h2>
    <p style={{paddingBottom:"6px"}}>
      Ant Design is another widely used React UI library that provides a comprehensive set of high-quality, customizable components. It is known for its polished, enterprise-grade design and features.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Ant Design:</h3>
    <ul>
      <li><strong>Rich Set of Components:</strong> Ant Design includes a large variety of components, including buttons, cards, tables, forms, and more, making it suitable for building complex enterprise applications.</li><br />
      <li><strong>Internationalization Support:</strong> Ant Design provides built-in internationalization (i18n) support, making it easy to build apps that support multiple languages.</li><br />
      <li><strong>Customizable and Themeable:</strong> Ant Design allows you to customize the theme using less variables, providing a great degree of flexibility in styling your app.</li>
    </ul><br />

    <h3>Installing Ant Design</h3>
    <p>
      To use Ant Design in your React app, install it via npm:
    </p>
    <pre>
      <code>
        {`npm install antd`}
      </code>
    </pre>
    <p>
      You can now use Ant Design components in your app as follows:
    </p>
    <pre>
      <code>
        {`import { Button } from 'antd';

        function App() {
          return (
            <Button type="primary">Primary Button</Button>
          );
        }`}
      </code>
    </pre>
<br />

    <h2>Comparing React Bootstrap, MUI, and Ant Design</h2>
    <p style={{paddingBottom:"6px"}}>
      While all three libraries—React Bootstrap, MUI, and Ant Design—are great for building modern React applications, they have different strengths. Here's a comparison to help you decide which one to use:
    </p>

    <h3 style={{paddingBottom:"6px"}}>1. Design and Style</h3>
    <ul>
      <li><strong>React Bootstrap:</strong> Follows the classic Bootstrap design, which is simple and familiar but less modern compared to Material Design or Ant Design.</li><br />
      <li><strong>MUI:</strong> Implements Google's Material Design, offering a sleek, modern, and widely used design language.</li><br />
      <li><strong>Ant Design:</strong> Known for its enterprise-grade design and highly polished components, making it a great choice for complex applications.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>2. Customization</h3>
    <ul>
      <li><strong>React Bootstrap:</strong> Provides standard Bootstrap customization features, but it's not as flexible as MUI or Ant Design.</li><br />
      <li><strong>MUI:</strong> Highly customizable, with deep theming capabilities that allow you to adjust everything from colors to typography.</li><br />
      <li><strong>Ant Design:</strong> Offers theme customization via Less variables, but it’s not as easy to modify compared to MUI.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>3. Component Variety</h3>
    <ul>
      <li><strong>React Bootstrap:</strong> Offers a core set of components that are commonly used, but lacks some advanced components like data grids or charts.</li><br />
      <li><strong>MUI:</strong> Provides a rich set of components, including advanced ones like data tables, dialogs, and grids.</li><br />
      <li><strong>Ant Design:</strong> Features a comprehensive set of components for enterprise-level applications, including complex tables, charts, and more.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>4. Documentation and Community</h3>
    <ul>
      <li><strong>React Bootstrap:</strong> Has good documentation, but not as extensive as MUI or Ant Design.</li><br />
      <li><strong>MUI:</strong> Has excellent documentation and a large, active community.</li><br />
      <li><strong>Ant Design:</strong> Offers comprehensive documentation and is widely used in enterprise applications.</li>
    </ul>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for Using Third-Party Libraries in React</h2>
    <ul>
      <li><strong>Choose Libraries Based on Your Design Needs:</strong> Select a library that fits the style and complexity of your project (e.g., Material Design for modern, sleek interfaces or Ant Design for enterprise-level applications).</li><br />
      <li><strong>Customizing Components:</strong> Customize the library’s components to match your brand's theme and design guidelines.</li><br />
      <li><strong>Minimize Unnecessary Dependencies:</strong> Only include the components you need to keep your bundle size smaller and your app performance optimal.</li><br />
      <li><strong>Stay Updated:</strong> Regularly check for updates to ensure you're using the latest version of your third-party libraries, especially for security and bug fixes.</li>
    </ul>

  <br />

    <h2>Conclusion</h2>
    <p>
      Third-party libraries like React Bootstrap, MUI, and Ant Design provide powerful, pre-built components that can significantly speed up your development process. By selecting the right library based on your project needs, you can create beautiful, responsive, and user-friendly interfaces with minimal effort.
    </p>
  </div>
)}




{selectedChapter === 'chapter45' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Integrating Charts and Graphs in React</h1>

    <p>
      Data visualization plays a crucial role in modern web applications by helping users understand data trends and patterns. In React, integrating charts and graphs can be done easily with various charting libraries. In this chapter, we will explore how to integrate charts and graphs in React using popular libraries such as Chart.js, Recharts, and Nivo.
    </p>

   <br />

    <h2>Why Use Charts and Graphs in React?</h2>
    <p>
      Visualizing data through charts and graphs offers several benefits:
    </p>
    <ul>
      <li><strong>Better Data Interpretation:</strong> Graphs and charts provide an intuitive way to understand large sets of data, making it easier to interpret patterns, trends, and outliers.</li><br />
      <li><strong>Engaging User Interface:</strong> Interactive and visually appealing charts improve the user experience, especially in dashboards and reporting tools.</li><br />
      <li><strong>Improved Decision Making:</strong> By presenting data visually, charts help stakeholders make informed decisions faster.</li>
    </ul>

 <br />

    <h2>Chart.js with React</h2>
    <p style={{paddingBottom:"6px"}}>
      Chart.js is a powerful and flexible JavaScript charting library that can be easily integrated with React. It supports various chart types such as bar charts, line charts, pie charts, and radar charts.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Chart.js:</h3>
    <ul>
      <li><strong>Wide Variety of Charts:</strong> Chart.js supports line charts, bar charts, radar charts, pie charts, doughnut charts, and more.</li><br />
      <li><strong>Customizable:</strong> You can customize the look and feel of the charts using options for colors, labels, and tooltips.</li><br />
      <li><strong>Responsive:</strong> Chart.js charts are responsive by default, ensuring they look good on all screen sizes.</li>
    </ul><br />

    <h3>Installing Chart.js in React</h3>
    <p>
      To use Chart.js in a React project, install both Chart.js and the React wrapper for Chart.js, `react-chartjs-2`:
    </p>
    <pre>
      <code>
        {`npm install chart.js react-chartjs-2`}
      </code>
    </pre>
    <p>
      Example usage of a simple line chart in React:
    </p>
    <pre>
      <code>
        {`import { Line } from 'react-chartjs-2';
        import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

        ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

        const data = {
          labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
          datasets: [
            {
              label: 'My First Dataset',
              data: [65, 59, 80, 81, 56, 55, 40],
              borderColor: 'rgba(75,192,192,1)',
              tension: 0.1,
            },
          ],
        };

        function MyChart() {
          return <Line data={data} />;
        }

export default MyChart;`}
      </code>
    </pre>

    <br />

    <h2>Recharts with React</h2>
    <p style={{paddingBottom:"6px"}}>
      Recharts is another popular charting library for React that is built using D3.js. It is known for its simplicity and ease of use. Recharts provides a set of components that make it easy to create customizable charts and graphs.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Recharts:</h3>
    <ul>
      <li><strong>Declarative API:</strong> Recharts uses a declarative API, making it easy to define charts and customize them with properties.</li><br />
      <li><strong>Customizable Components:</strong> You can customize chart elements like axes, grids, and legends with ease.</li><br />
      <li><strong>Responsive:</strong> Recharts charts are responsive and adjust automatically to screen sizes.</li>
    </ul><br />

    <h3>Installing Recharts in React</h3>
    <p>
      Install Recharts via npm to get started:
    </p>
    <pre>
      <code>
        {`npm install recharts`}
      </code>
    </pre>
    <p>
      Here's an example of creating a simple bar chart using Recharts:
    </p>
    <pre>
      <code>
        {`import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

        const data = [
          { name: 'Page A', uv: 4000, pv: 2400, amt: 2400 },
          { name: 'Page B', uv: 3000, pv: 1398, amt: 2210 },
          { name: 'Page C', uv: 2000, pv: 9800, amt: 2290 },
          { name: 'Page D', uv: 2780, pv: 3908, amt: 2000 },
          { name: 'Page E', uv: 1890, pv: 4800, amt: 2181 },
        ];

        function MyBarChart() {
          return (
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="pv" fill="#8884d8" />
                <Bar dataKey="uv" fill="#82ca9d" />
              </BarChart>
            </ResponsiveContainer>
          );
        }

export default MyBarChart;`}
      </code>
    </pre>

   <br />

    <h2>Nivo with React</h2>
    <p style={{paddingBottom:"6px"}}>
      Nivo is a highly customizable charting library that provides a rich set of interactive charts. Nivo is built with React and D3.js, offering both server-side and client-side rendering for data visualizations.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Nivo:</h3>
    <ul>
      <li><strong>Wide Variety of Charts:</strong> Nivo provides a wide range of charts, including pie charts, bar charts, line charts, radar charts, and more.</li><br />
      <li><strong>Responsive and Interactive:</strong> Nivo charts are highly interactive and responsive by default, offering smooth animations.</li><br />
      <li><strong>Customizable:</strong> You can customize the look and feel of your charts with Nivo’s rich theming and styling options.</li>
    </ul><br />

    <h3>Installing Nivo in React</h3>
    <p>
      To install Nivo in your React project, use the following command:
    </p>
    <pre>
      <code>
        {`npm install @nivo/core @nivo/bar`}
      </code>
    </pre>
    <p>
      Example of using Nivo’s Bar chart:
    </p>
    <pre>
      <code>
        {`import { ResponsiveBar } from '@nivo/bar';

        const data = [
          { country: 'USA', 'hot dog': 10, 'burger': 20 },
          { country: 'Germany', 'hot dog': 15, 'burger': 25 },
          { country: 'France', 'hot dog': 20, 'burger': 30 },
        ];

        function MyNivoChart() {
          return (
            <ResponsiveBar data={data} keys={['hot dog', 'burger']} indexBy="country" />
          );
        }

export default MyNivoChart;`}
      </code>
    </pre>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for Using Charts in React</h2>
    <ul>
      <li><strong>Choose the Right Library:</strong> Pick a charting library that fits your requirements for customization, ease of use, and performance. For simple charts, Chart.js or Recharts might be a good fit, while Nivo is better for complex, interactive charts.</li><br />
      <li><strong>Optimize for Performance:</strong> Large datasets can slow down rendering. Ensure that your charts are optimized for performance by using lazy loading, memoization, or pagination for data-intensive visualizations.</li><br />
      <li><strong>Responsiveness:</strong> Ensure your charts are responsive, especially for mobile devices. Use libraries that offer responsive charts or implement custom solutions for resizing charts dynamically.</li><br />
      <li><strong>Provide Clear Labels and Legends:</strong> Label your charts clearly and provide legends to ensure that users can understand what the data represents.</li>
    </ul>

    <br />

    <h2>Conclusion</h2>
    <p>
      Integrating charts and graphs in React applications provides an intuitive way to display and analyze data. Libraries like Chart.js, Recharts, and Nivo offer powerful tools to create interactive and responsive charts, with a wide range of customization options to suit your needs.
    </p>
  </div>
)}






{selectedChapter === 'chapter46' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Working with React Native for Mobile Apps</h1>

    <p>
      React Native is a popular framework for building cross-platform mobile applications using JavaScript and React. With React Native, you can write code once and run it on both iOS and Android devices. This chapter explores how to get started with React Native, the core concepts, and building a mobile app.
    </p>

   <br />

    <h2>Why Use React Native?</h2>
    <p style={{paddingBottom:"6px"}}>
      React Native enables developers to build mobile applications that feel native but use a shared codebase for both iOS and Android. The main advantages include:
    </p>
    <ul>
      <li><strong>Cross-Platform Development:</strong> Write once, run on both iOS and Android platforms.</li><br />
      <li><strong>Native-Like Performance:</strong> React Native uses native components, providing a close-to-native performance experience.</li><br />
      <li><strong>Rich Ecosystem:</strong> React Native has a rich ecosystem of libraries, tools, and community support.</li><br />
      <li><strong>Hot Reloading:</strong> Instant feedback on code changes without rebuilding the app from scratch.</li>
    </ul>

   <br />

    <h2>Getting Started with React Native</h2>
    <p style={{paddingBottom:"6px"}}>
      To get started with React Native, you’ll need to set up your development environment. You can use the React Native CLI or Expo to create your first mobile app.
    </p>

    <h3>Setting up the Development Environment</h3>
    <p>
      The first step is to install Node.js and npm (Node package manager). Next, you can choose between React Native CLI or Expo for creating your React Native project.
    </p>
    <ul>
      <li><strong>React Native CLI:</strong> Provides full control over the native code but requires setting up Android Studio and Xcode for iOS development.</li><br />
      <li><strong>Expo:</strong> An easier setup for beginners. Expo manages the native environment and allows you to focus on JavaScript and React code.</li>
    </ul><br />

    <h3>Creating a New React Native Project</h3>
    <p>
      To create a new React Native project using the CLI, run the following command:
    </p>
    <pre>
      <code>
        {`npx react-native init MyNewApp`}
      </code>
    </pre>
    <p>
      For Expo, use the following command:
    </p>
    <pre>
      <code>
        {`npx create-expo-app MyNewApp`}
      </code>
    </pre>
    <p>
      Once the setup is complete, you can run the app on an emulator or physical device using the following:
    </p>
    <pre>
      <code>
        {`npx react-native run-android`} <strong>or</strong> {`npx react-native run-ios`}
      </code>
    </pre>

   <br />

    <h2>Building Your First React Native App</h2>
    <p>
      Let’s create a simple “Hello World” app using React Native. This will include creating a component, styling it, and displaying it on the screen.
    </p>
    <pre>
      <code>
        {`import React from 'react';
        import { View, Text, StyleSheet } from 'react-native';

        const App = () => {
          return (
            <View style={styles.container}>
              <Text style={styles.text}>Hello, React Native!</Text>
            </View>
          );
        };

        const styles = StyleSheet.create({
          container: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#fff',
          },
          text: {
            fontSize: 20,
            color: 'blue',
          },
        });

export default App;`}
      </code>
    </pre>
    <p>
      This simple example demonstrates how to import the necessary components from React Native, structure the layout, and style the app using the `StyleSheet` API.
    </p>

    <br />

    <h2>Core Components of React Native</h2>
    <p>
      React Native provides several core components that allow you to build mobile apps with a native feel. Some of the most commonly used components include:
    </p>
    <ul>
      <li><strong>View:</strong> A container component used for layout and structure.</li><br />
      <li><strong>Text:</strong> Used to display text content.</li><br />
      <li><strong>Image:</strong> Displays images in the app.</li><br />
      <li><strong>TextInput:</strong> Allows users to input text.</li><br />
      <li><strong>Button:</strong> Represents a clickable button for interaction.</li><br />
      <li><strong>ScrollView:</strong> A scrollable container for large lists or content.</li>
    </ul><br />

    <h3>Example: Using Core Components</h3>
    <pre>
      <code>
        {`import React from 'react';
        import { View, Text, Button } from 'react-native';

        const MyApp = () => {
          return (
            <View>
              <Text>Welcome to React Native!</Text>
              <Button title="Click Me" onPress={() => alert('Button Clicked!')} />
            </View>
          );
        };

export default MyApp;`}
      </code>
    </pre>

    <br />

    <h2>Styling in React Native</h2>
    <p style={{paddingBottom:"6px"}}>
      Styling in React Native is similar to CSS in web development, but it uses JavaScript objects. You use the `StyleSheet` API to define styles and apply them to components.
    </p>
    <h3>Example: Styling with StyleSheet</h3>
    <pre>
      <code>
        {`import React from 'react';
        import { View, Text, StyleSheet } from 'react-native';

        const App = () => {
          return (
            <View style={styles.container}>
              <Text style={styles.text}>Styled React Native App</Text>
            </View>
          );
        };

        const styles = StyleSheet.create({
          container: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f0f0f0',
          },
          text: {
            fontSize: 22,
            color: 'darkblue',
          },
        });

export default App;`}
      </code>
    </pre>

    <br />

    <h2>Handling Navigation in React Native</h2>
    <p style={{paddingBottom:"6px"}}>
      React Native doesn’t have built-in navigation. Instead, you can use libraries like React Navigation to implement navigation in your app. React Navigation supports stack navigation, tab navigation, and drawer navigation.
    </p>

    <h3>Installing React Navigation</h3>
    <p>
      First, install the required dependencies:
    </p>
    <pre>
      <code>
        {`npm install @react-navigation/native @react-navigation/stack`}
      </code>
    </pre>
    <p>
      Then, set up navigation in your app:
    </p>
    <pre>
      <code>
        {`import React from 'react';
        import { NavigationContainer } from '@react-navigation/native';
        import { createStackNavigator } from '@react-navigation/stack';
        import HomeScreen from './HomeScreen';

        const Stack = createStackNavigator();

        const App = () => {
          return (
            <NavigationContainer>
              <Stack.Navigator>
                <Stack.Screen name="Home" component={HomeScreen} />
              </Stack.Navigator>
            </NavigationContainer>
          );
        };

export default App;`}
      </code>
    </pre>

  <br />

    <h2>Accessing Device Features</h2>
    <p>
      React Native provides APIs to access native device features like camera, GPS, and storage. You can use libraries like `react-native-camera`, `react-native-geolocation-service`, and others to access these features.
    </p>

    <br />

    <h2 style={{paddingBottom:"6px"}}>Best Practices for React Native Development</h2>
    <ul>
      <li><strong>Optimize for Performance:</strong> Use techniques like lazy loading, avoid unnecessary re-renders, and optimize images.</li><br />
      <li><strong>Leverage Native Modules:</strong> For advanced features, you can create or use native modules to bridge React Native with native code.</li><br />
      <li><strong>Use Expo for Quick Prototyping:</strong> If you are rapidly prototyping, Expo simplifies setup and reduces overhead.</li><br />
      <li><strong>Test on Multiple Devices:</strong> Make sure to test your app on both Android and iOS devices to ensure consistency.</li>
    </ul><br />



    <h2>Conclusion</h2>
    <p>
      React Native is an excellent choice for building cross-platform mobile applications. With its large ecosystem, ease of use, and rich community support, it empowers developers to create high-quality apps for both iOS and Android with a shared codebase.
    </p>
  </div>
)}




  
{selectedChapter === "chapter47" && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>REST API Integration</h1>

    

    <h2>What is REST API Integration in React?</h2>
    <p>
      REST (Representational State Transfer) is a standard architecture for designing networked applications. A REST API allows communication between a client (e.g., a React app) and a server over HTTP. This communication involves sending requests to endpoints and receiving responses, typically in JSON format.
    </p><br/>
    <p>
      In React, REST API integration involves making HTTP requests to interact with a backend service. These interactions are essential for dynamic applications where data needs to be fetched, updated, or deleted. React provides tools like the <code>fetch</code> API and third-party libraries like <code>Axios</code> to perform these operations.
    </p>

    <br/>

    <h2>Key Concepts of REST API Integration</h2>
    <ol>
      <li><strong>Endpoints:</strong> An endpoint is a URL that the client communicates with to interact with the API. Example:
        <ul>
          <li><code>GET /users</code> – Fetch all users.</li><br/>
          <li><code>POST /users</code> – Add a new user.</li>
        </ul>
      </li><br/>
      <li><strong>HTTP Methods:</strong>
        <ul>
          <li><code>GET</code>: Retrieve data.</li><br/>
          <li><code>POST</code>: Send new data to the server.</li><br/>
          <li><code>PUT/PATCH</code>: Update existing data.</li><br/>
          <li><code>DELETE</code>: Remove data from the server.</li>
        </ul><br/>
      </li>
      <li><strong>Request Headers:</strong> Headers contain additional information, such as authentication tokens, content type, etc.</li><br/>
      <li><strong>Request Body:</strong> The body is used in <code>POST</code> or <code>PUT</code> requests to send data to the server.</li><br/>
      <li><strong>Response:</strong> The server responds with data, typically in JSON format, along with a status code (e.g., 200 for success, 404 for not found).</li>
    </ol>

    <br/>

    <h2>Steps to Integrate REST API in React</h2>

    <h4>1. Set Up Your React Project</h4>
    <p>Ensure your React app is set up using tools like <code>create-react-app</code> or <code>Vite</code>.</p><br/>
    <p>Install any necessary dependencies:</p>
    <pre>
      <code>npm install axios</code>
    </pre><br/>

    <h4>2. Understand API Documentation</h4>
    <p>Read the API documentation to understand the available endpoints, required parameters, and expected responses.</p><br/>

    <h4>3. Fetch Data (GET Request)</h4>
    <p>Use the <code>useEffect</code> hook to fetch data when a component loads.</p><br/>

    <h5>Example: Displaying a List of Users</h5>
    <pre>
      <code>
{`import React, { useState, useEffect } from 'react';

function UserList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://jsonplaceholder.typicode.com/users')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        return response.json();
      })
      .then((data) => {
        setUsers(data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div>
      <h2>User List</h2>
      <ul>
        {users.map((user) => (
          <li key={user.id}>{user.name}</li>
        ))}
      </ul>
    </div>
  );
}

export default UserList;`}
      </code>
    </pre><br/>

    <h4>4. Submit Data (POST Request)</h4>
    <p>Use forms to collect user input and send it to the server.</p>

    <h5>Example: Adding a New User</h5>
    <pre>
      <code>
{`import React, { useState } from 'react';

function AddUser() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch('https://jsonplaceholder.typicode.com/users', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name, email }),
    })
      .then((response) => response.json())
      .then((data) => {
        setMessage('User added successfully!');
        console.log(data);
      })
      .catch((error) => {
        setMessage('Failed to add user.');
        console.error(error);
      });
  };

  return (
    <div>
      <h2>Add User</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Name"
          required
        />
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
        />
        <button type="submit">Submit</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
}

export default AddUser;`}
      </code>
    </pre><br/>

    <h4>5. Handle API Errors</h4>
    <p>Always handle errors gracefully to improve the user experience. Display appropriate messages if the API fails or if there’s a network issue.</p>

    <br/>

    <h3>Using Axios for REST API Integration</h3>
    <p>Axios is a library that simplifies HTTP requests and provides better error handling.</p>

    <h5>Axios Example (GET Request)</h5>
    <pre>
      <code>
{`import React, { useState, useEffect } from 'react';
import axios from 'axios';

function UserList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get('https://jsonplaceholder.typicode.com/users')
      .then((response) => {
        setUsers(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;

  return (
    <div>
      <h2>User List</h2>
      <ul>
        {users.map((user) => (
          <li key={user.id}>{user.name}</li>
        ))}
      </ul>
    </div>
  );
}

export default UserList;`}
      </code>
    </pre>

    <br/>

    <h3>key Points</h3>
    <ul>
      <li><strong>Authentication:</strong> Use headers to send authentication tokens with requests (e.g., Bearer tokens in JWT).</li><br/>
      <li><strong>Error Boundaries:</strong> Use React error boundaries to handle unexpected errors.</li><br/>
      <li><strong>State Management:</strong> For larger apps, manage API data using state libraries like Redux or React Query.</li><br/>
      <li><strong>Caching API Responses:</strong> Tools like React Query or SWR make API calls more efficient by caching responses.</li>
    </ul>

    
  </div>
)}




{selectedChapter === 'chapter48' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>GraphQL with Apollo Client</h1>

    <p>
      GraphQL is a query language for APIs that allows clients to request only the data they need. It provides a more efficient, powerful, and flexible alternative to REST APIs. Unlike REST, which requires multiple requests to fetch data from different endpoints, GraphQL allows clients to send a single query to the server, and the server responds with only the requested data.
    </p><br/>

    <p>
      Apollo Client is a popular JavaScript library that provides an easy way to interact with a GraphQL server. It helps manage data and integrates seamlessly with React and other JavaScript libraries.
    </p>

    <h2>Key Concepts of GraphQL</h2>
    <ul>
      <li><strong>Query</strong>: A request for data from the server.</li><br/>
      <li><strong>Mutation</strong>: A request to modify data (e.g., create, update, delete).</li><br/>
      <li><strong>Subscription</strong>: A way to listen to real-time changes from the server.</li><br/>
      <li><strong>Schema</strong>: Defines the types of data that can be queried or mutated, such as `User`, `Post`, etc.</li><br/>
      <li><strong>Resolvers</strong>: Functions that handle the data fetching and returning based on the queries or mutations.</li>
    </ul><br/>

    <h2>Apollo Client Overview</h2>
    <p>
      Apollo Client is a fully-featured GraphQL client that manages data fetching, caching, and synchronization with the server. It helps developers fetch data, handle local state management, and manage errors.
    </p><br/>
    <ul>
      <li><strong>Caching</strong>: Apollo Client caches data to reduce the number of requests to the server, improving performance.</li><br/>
      <li><strong>Declarative Data Fetching</strong>: Fetch data by describing what you need instead of worrying about the underlying network requests.</li><br/>
      <li><strong>Error Handling</strong>: Apollo provides built-in error handling for GraphQL queries and mutations.</li><br/>
      <li><strong>Optimistic UI</strong>: Update the UI immediately while the mutation is in progress.</li><br/>
      <li><strong>Local State Management</strong>: Apollo Client allows managing local state using the same GraphQL queries.</li>
    </ul><br/>

    <h2>Steps to Use Apollo Client with React</h2>
    <ol>
      <li>
        <strong>Install Apollo Client and Dependencies:</strong>
        <pre>
          npm install @apollo/client graphql
        </pre>
      </li><br/>
      <li>
        <strong>Set Up ApolloProvider:</strong>
        <p>Wrap your application in the <code>ApolloProvider</code> component to connect Apollo Client with your React app:</p><br/>
        <pre>
          {`
import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider, InMemoryCache } from '@apollo/client';
import App from './App';

const client = new ApolloClient({
  uri: 'https://your-graphql-endpoint.com/graphql', // Replace with your GraphQL endpoint
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById('root')
);
          `}
        </pre>
      </li><br/>
      <li>
        <strong>Fetching Data Using <code>useQuery</code> Hook:</strong>
        <p>Example of how to fetch data from a GraphQL server:</p>
        <pre>
          {`
import { useQuery, gql } from '@apollo/client';

const GET_USERS = gql\`
  query GetUsers {
    users {
      id
      name
      email
    }
  }
\`;

const UserList = () => {
  const { loading, error, data } = useQuery(GET_USERS);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div>
      <h2>User List</h2>
      <ul>
        {data.users.map((user) => (
          <li key={user.id}>
            {user.name} - {user.email}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UserList;
          `}
        </pre>
      </li><br/>
      <li>
        <strong>Mutating Data Using <code>useMutation</code> Hook:</strong>
        <p>Example of how to mutate data using Apollo Client:</p>
        <pre>
          {`
import React, { useState } from 'react';
import { useMutation, gql } from '@apollo/client';

const ADD_USER = gql\`
  mutation AddUser($name: String!, $email: String!) {
    addUser(name: $name, email: $email) {
      id
      name
      email
    }
  }
\`;

const AddUserForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const [addUser, { loading, error, data }] = useMutation(ADD_USER);

  const handleSubmit = (e) => {
    e.preventDefault();
    addUser({ variables: { name, email } });
  };

  if (loading) return <p>Adding user...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (data) return <p>User added: {data.addUser.name}</p>;

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <button type="submit">Add User</button>
    </form>
  );
};

export default AddUserForm;
          `}
        </pre>
      </li><br/>
      <li>
        <strong>Apollo Client Cache and State Management:</strong>
        <p>Apollo Client automatically caches responses to GraphQL queries. It updates the UI with cached data without needing additional requests. This behavior can be controlled by specifying the fetch policy for each query or mutation:</p>
        <pre>
          {`
const { data, loading, error } = useQuery(GET_USERS, {
  fetchPolicy: 'cache-first', // Use cached data if available
});
          `}
        </pre>
      </li><br/>
      <li>
        <strong>Apollo Client DevTools:</strong>
        <p>To inspect the cache, queries, and mutations, Apollo Client provides Apollo Client DevTools. This is a browser extension that allows you to inspect GraphQL operations, cache data, and analyze performance.</p>
      </li>
    </ol>
  </div>
)}



{selectedChapter === 'chapter49' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>WebSocket and Real-Time Data Updates</h1>

    <h2>What is WebSocket?</h2>
    <p>
      WebSocket is a communication protocol that provides full-duplex communication channels over a single TCP connection.
      It is designed to be used for real-time, two-way interactions between a client (usually a browser) and a server. Unlike traditional HTTP,
      where the client sends a request and waits for a response from the server, WebSocket allows both the client and the server to send and receive messages at any time.
      This makes it ideal for real-time applications such as chat applications, live updates, or stock market feeds.
    </p><br/>

    <h3>How Does WebSocket Work?</h3>
    <ul>
      <li><strong>Initiation:</strong> A WebSocket connection is initiated by the client by sending an HTTP request with an `Upgrade` header to the server, indicating that it wants to switch from HTTP to WebSocket.</li><br/>
      <li><strong>Handshake:</strong> If the server supports WebSocket, it responds with a 101 status code (`Switching Protocols`) and the WebSocket connection is established.</li><br/>
      <li><strong>Data Exchange:</strong> Once the connection is established, both the client and the server can send messages to each other at any time until the connection is closed.</li><br/>
      <li><strong>Closure:</strong> Either the client or the server can close the connection by sending a close frame.</li>
    </ul><br/>

    <p>
      WebSocket provides a low-latency and persistent connection, making it well-suited for use cases where data updates in real-time are crucial.
    </p><br/>

    <h3>Real-Time Data Updates</h3>
    <p>
      Real-time data updates refer to the ability of a system to push updates to the client immediately when data changes, rather than waiting for the client to request the updated data. 
      This is especially useful in scenarios such as live sports scores, social media feeds, or stock prices, where users need the most up-to-date information without refreshing the page.
    </p><br/>

    <p>
      Real-time data updates can be implemented using various technologies, with WebSocket being one of the most common protocols used for this purpose.
    </p><br/>

    <h4>Key Benefits of WebSocket for Real-Time Data:</h4>
    <ul>
      <li><strong>Low Latency:</strong> WebSocket allows messages to be sent in both directions almost instantly, making it suitable for real-time applications.</li><br/>
      <li><strong>Full-Duplex Communication:</strong> Both the client and the server can send messages independently of each other.</li><br/>
      <li><strong>Efficiency:</strong> Unlike HTTP polling, WebSocket maintains a single connection, reducing the need for multiple requests and responses, which can be inefficient for real-time updates.</li>
    </ul><br/>

    <h3>Use Case Example: Chat Application with WebSocket</h3>

    <h4>Client-Side (React)</h4>
    <p>On the client side, a WebSocket connection is created, and messages are sent and received over that connection.</p><br/>

    <h5>Installing Dependencies</h5>
    <pre>
      <code>npm install socket.io-client</code>
    </pre><br/>

    <h5>Connecting to WebSocket Server</h5>
    <p>Create a WebSocket connection and handle sending and receiving messages.</p><br/>

    <div>
      <h6>React Code:</h6>
      <pre>
        <code>
          {`import React, { useState, useEffect } from 'react';`}
          <br />
          {`import io from 'socket.io-client';`}
          <br />
          <br />
          {`const socket = io('http://localhost:4000'); // Connect to the server`}
          <br />
          <br />
          {`const ChatApp = () => {`}
          <br />
          {`  const [message, setMessage] = useState('');`}
          <br />
          {`  const [messages, setMessages] = useState([]);`}
          <br />
          <br />
          {`  useEffect(() => {`}
          <br />
          {`    socket.on('message', (newMessage) => {`}
          <br />
          {`      setMessages((prevMessages) => [...prevMessages, newMessage]);`}
          <br />
          {`    });`}
          <br />
          {`    return () => {`}
          <br />
          {`      socket.off('message'); // Clean up listener on component unmount`}
          <br />
          {`    };`}
          <br />
          {`  }, []);`}
          <br />
          <br />
          {`  const sendMessage = () => {`}
          <br />
          {`    socket.emit('send_message', message); // Send message to server`}
          <br />
          {`    setMessage('');`}
          <br />
          {`  };`}
          <br />
          <br />
          {`  return (`}
          <br />
          {`    <div>`}
          <br />
          {`      <h1>Real-Time Chat</h1>`}
          <br />
          {`      <div>`}
          <br />
          {`        {messages.map((msg, index) => (`}
          <br />
          {`          <p key={index}>{msg}</p>`}
          <br />
          {`        ))}`}
          <br />
          {`      </div>`}
          <br />
          {`      <input`}
          <br />
          {`        type="text"`}
          <br />
          {`        value={message}`}
          <br />
          {`        onChange={(e) => setMessage(e.target.value)}`}
          <br />
          {`        placeholder="Type your message..."`}
          <br />
          {`      />`}
          <br />
          {`      <button onClick={sendMessage}>Send</button>`}
          <br />
          {`    </div>`}
          <br />
          {`  );`}
          <br />
          {`};`}
          <br />
          <br />
          {`export default ChatApp;`}
        </code>
      </pre>
    </div><br/>

    <h4>Server-Side (Node.js with Socket.IO)</h4>
    <p>On the server side, we can use Socket.IO to handle WebSocket connections. Here's an example of a basic server that listens for messages and broadcasts them to all connected clients:</p>
    <br/>
    <h5>Installing Dependencies</h5>
    <pre>
      <code>npm install express socket.io</code>
    </pre><br/>

    <h5>Setting Up the Server</h5>
    <div>
      <h6>Node.js Code:</h6>
      <pre>
        <code>
          {`const express = require('express');`}
          <br />
          {`const http = require('http');`}
          <br />
          {`const socketIo = require('socket.io');`}
          <br />
          <br />
          {`const app = express();`}
          <br />
          {`const server = http.createServer(app);`}
          <br />
          {`const io = socketIo(server);`}
          <br />
          <br />
          {`app.get('/', (req, res) => {`}
          <br />
          {`  res.send('Chat Application Server');`}
          <br />
          {`});`}
          <br />
          <br />
          {`io.on('connection', (socket) => {`}
          <br />
          {`  console.log('New client connected');`}
          <br />
          <br />
          {`  socket.on('send_message', (message) => {`}
          <br />
          {`    io.emit('message', message); // Broadcast message to all clients`}
          <br />
          {`  });`}
          <br />
          <br />
          {`  socket.on('disconnect', () => {`}
          <br />
          {`    console.log('Client disconnected');`}
          <br />
          {`  });`}
          <br />
          {`});`}
          <br />
          <br />
          {`server.listen(4000, () => {`}
          <br />
          {`  console.log('Server running on port 4000');`}
          <br />
          {`});`}
        </code>
      </pre>
    </div><br/>

    <h3>Explanation of the Flow</h3>
    <p><strong>Client-Side:</strong> The React app establishes a WebSocket connection to the server using `io('http://localhost:4000')`. It listens for incoming messages using the `socket.on('message', ...)` listener. When the user types a message and clicks "Send," it sends the message to the server using `socket.emit('send_message', message)`.</p>
    <br/>
    <p><strong>Server-Side:</strong> The server listens for incoming WebSocket connections using `socketIo(server)`. When it receives a message (`socket.on('send_message', ...)`), it broadcasts that message to all connected clients using `io.emit('message', message)`. Every client that has established a WebSocket connection will receive the new message in real-time.</p>
    <br/>
    <h3>Conclusion</h3>
    <p>
      WebSocket is a powerful technology for implementing real-time data updates. It allows bidirectional communication between the client and server, making it an excellent choice for real-time applications like chat apps, live feeds, and gaming. By using WebSocket, we can reduce latency and ensure that clients receive updates instantly when data changes, creating a more engaging user experience.
    </p>

    
  </div>
)}




{selectedChapter === 'chapter50' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>React with Node.js and Express</h1>

    <p>
      <strong>React</strong> is a front-end library used for building user interfaces, while 
      <strong>Node.js</strong> and <strong>Express</strong> are used to build the backend server to handle data and requests. Together, they create a full-stack application where React handles the user interface, and Node.js/Express manages server-side logic and communication with the database.
    </p>
    <br/>
    <h2>Steps to Integrate React with Node.js and Express</h2>
    <ol>
      <li><strong>Frontend (React):</strong> React builds the user interface (UI), such as a form to collect user data.</li><br/>
      <li><strong>Backend (Node.js & Express):</strong> The backend handles API requests, processes data, and interacts with the database. Communication occurs via REST APIs or GraphQL.</li>
    </ol><br/>

    <h2>Example: React + Node.js + Express</h2>

    <h3>1. Backend: Node.js with Express</h3>
    <pre>
      <code>
{`// server.js
const express = require('express');
const cors = require('cors');
const app = express();
const port = 5000;

// Middleware
app.use(cors());
app.use(express.json());

// API endpoint
app.post('/api/data', (req, res) => {
  const { name, email } = req.body;
  if (!name || !email) {
    return res.status(400).json({ message: 'Name and email are required.' });
  }
  console.log(\`Received: Name = \${name}, Email = \${email}\`);
  res.json({ message: 'Data received successfully!' });
});

// Start the server
app.listen(port, () => {
  console.log(\`Server running at http://localhost:\${port}\`);
});`}
      </code>
    </pre><br/>

    <p>To set up the backend:</p>
    <ol>
      <li>Install dependencies:
        <pre><code>npm install express cors</code></pre>
      </li><br/>
      <li>Run the server:
        <pre><code>node server.js</code></pre>
      </li>
    </ol><br/>

    <h3>2. Frontend: React</h3>
    <pre>
      <code>
{`// App.js
import React, { useState } from 'react';

function App() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch('http://localhost:5000/api/data', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email }),
    });
    const data = await response.json();
    alert(data.message);
  };

  return (
    <div>
      <h1>React with Node.js and Express</h1>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button type="submit">Submit</button>
      </form>
    </div>
  );
}

export default App;`}
      </code>
    </pre><br/>

    <p>To set up the frontend:</p>
    <ol>
      <li>Start the React app:
        <pre><code>npm start</code></pre>
      </li>
    </ol>

    <h2>How It Works</h2>
    <ol>
      <li><strong>Frontend (React):</strong> The React app sends user input data to the backend using a POST request.</li><br/>
      <li><strong>Backend (Node.js/Express):</strong> The server processes the data, optionally saves it to a database, and sends a response back to React.</li><br/>
      <li><strong>Response:</strong> The React app displays a confirmation message to the user.</li>
    </ol><br/>

    <p>This integration allows seamless communication between the frontend and backend, creating a full-stack application with efficient data handling.</p>
  </div>
)}



{selectedChapter === 'chapter51' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>React with Firebase</h1>

    <p>
      <strong>React</strong> is a front-end library for building user interfaces, while 
      <strong>Firebase</strong> is a Backend-as-a-Service (BaaS) platform provided by Google. 
      Firebase simplifies backend functionalities such as authentication, database management, 
      and hosting, making it a great choice for React projects.
    </p><br/>

    <h2>Why Use Firebase with React?</h2>
    <ul>
      <li><strong>Ease of Use:</strong> Firebase provides pre-built tools for common backend functionalities.</li><br/>
      <li><strong>Real-time Database:</strong> Firebase’s real-time database syncs data across users instantly.</li><br/>
      <li><strong>Authentication:</strong> Firebase supports email/password, Google, Facebook, and other third-party authentication methods.</li><br/>
      <li><strong>Hosting:</strong> Firebase hosting allows you to deploy your React application with ease.</li>
    </ul><br/>

    <h2>Key Features of Firebase for React</h2>
    <ul>
      <li><strong>Authentication:</strong> User login, signup, and session management.</li><br/>
      <li><strong>Database:</strong> Real-time or Firestore database for storing and retrieving data.</li><br/>
      <li><strong>Storage:</strong> Storing files like images or documents.</li><br/>
      <li><strong>Cloud Functions:</strong> Serverless backend logic.</li><br/>
      <li><strong>Hosting:</strong> Deploying and hosting your React app.</li>
    </ul><br/>

    <h2>Steps to Integrate Firebase with React</h2>

    <h3>1. Set Up Firebase Project</h3>
    <ol>
      <li>Go to the <a href="https://console.firebase.google.com/" target="_blank" rel="noopener noreferrer">Firebase Console</a>.</li><br/>
      <li>Create a new project and configure it.</li><br/>
      <li>Add a web app to your project and copy the Firebase configuration.</li>
    </ol><br/>

    <h3>2. Install Firebase SDK in React Project</h3>
    <p>Run the following command to add Firebase to your React project:</p>
    <pre>
      <code>npm install firebase</code>
    </pre><br/>

    <h3>3. Configure Firebase in React</h3>
    <p>Create a <code>firebase.js</code> file in your React project for Firebase configuration.</p>
    <pre>
      <code>
{`// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "your-api-key",
  authDomain: "your-app.firebaseapp.com",
  projectId: "your-project-id",
  storageBucket: "your-app.appspot.com",
  messagingSenderId: "your-sender-id",
  appId: "your-app-id",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
`}
      </code>
    </pre><br/>

    <h3>4. Example: Authentication with Firebase</h3>

    <h4>Registration Form (React Component)</h4>
    <pre>
      <code>
{`// Register.js
import React, { useState } from 'react';
import { auth } from './firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      setMessage('User registered successfully!');
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div>
      <h2>Register</h2>
      <form onSubmit={handleRegister}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Register</button>
      </form>
      <p>{message}</p>
    </div>
  );
};

export default Register;
`}
      </code>
    </pre><br/>

    <h4>Login Form (React Component)</h4>
    <pre>
      <code>
{`// Login.js
import React, { useState } from 'react';
import { auth } from './firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setMessage('User logged in successfully!');
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div>
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Login</button>
      </form>
      <p>{message}</p>
    </div>
  );
};

export default Login;
`}
      </code>
    </pre><br/>

    <h3>5. Deploy React App with Firebase Hosting</h3>
    <ol>
      <li>Install Firebase CLI globally:
        <pre><code>npm install -g firebase-tools</code></pre>
      </li><br/>
      <li>Login to Firebase:
        <pre><code>firebase login</code></pre>
      </li><br/>
      <li>Initialize Firebase in your project:
        <pre><code>firebase init</code></pre>
        <p>Choose "Hosting" and select your Firebase project.</p>
      </li><br/>
      <li>Build and deploy your React app:
        <pre><code>npm run build</code></pre>
        <pre><code>firebase deploy</code></pre>
      </li>
    </ol><br/>

    <h2>Conclusion</h2>
    <p>
      Using Firebase with React simplifies backend development by providing tools for authentication, 
      database management, and hosting. This integration allows you to focus on building features rather 
      than backend setup. Firebase is a scalable and cost-effective solution, making it ideal for small 
      to medium-sized projects and startups.
    </p>
  </div>
)}


{selectedChapter === 'chapter52' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}> SSR (Server-Side Rendering) With Next.js</h1>

    <p>
      <strong>Next.js</strong> is a React framework that provides built-in features for server-side rendering (SSR), static site generation (SSG), routing, and more. SSR in Next.js allows pages to be rendered on the server before being sent to the client, improving performance, SEO, and load times compared to client-side rendering (CSR).
    </p>

    <br/>

    <h2>Key Concepts of SSR in Next.js</h2>
    <ul>
      <li>
        <strong>Server-Side Rendering (SSR):</strong> The server generates the complete HTML for a page and sends it to the client. The browser receives a fully-rendered HTML page, improving performance and SEO.
      </li><br/>
      <li>
        <strong>Dynamic Data Fetching:</strong> Data is fetched on the server during the request, making SSR suitable for pages requiring up-to-date or personalized data.
      </li><br/>
      <li>
        <strong>SEO Optimization:</strong> Since the HTML is pre-rendered on the server, search engines can crawl the content easily.
      </li>
    </ul>

    <br/>

    <h2>How SSR Works in Next.js</h2>
    <ol>
      <li>The client makes a request to the server.</li><br/>
      <li>The server runs the code to fetch data and render the React components.</li><br/>
      <li>The server sends the fully-rendered HTML page to the client.</li><br/>
      <li>The browser displays the page, and React takes over for interactivity.</li>
    </ol>

    <br/>

    <h2>Setting Up a Next.js Project with SSR</h2>
    <h3>1. Initialize a Next.js Project</h3>
    <pre>
      <code>
        npx create-next-app@latest ssr-example<br />
        cd ssr-example
      </code>
    </pre><br/>

    <h3>2. Structure of the Project</h3>
    <ul>
      <li>
        <code>pages/</code>: Contains React components for routing.
      </li><br/>
      <li>
        <code>pages/api/</code>: Handles backend API routes.
      </li><br/>
      <li>
        <code>public/</code>: Stores static assets like images.
      </li>
    </ul>

    <br/>

    <h2>Example: SSR with Next.js</h2><br/>
    <h3>1. Creating an SSR Page</h3>
    <p>Here’s an example of fetching and rendering data on the server:</p>

    <pre>
      <code>
        {`// pages/index.js
import React from 'react';

const Home = ({ data }) => {
  return (
    <div>
      <h1>Server-Side Rendering with Next.js</h1>
      <ul>
        {data.map((item) => (
          <li key={item.id}>{item.title}</li>
        ))}
      </ul>
    </div>
  );
};

// Fetch data on the server
export async function getServerSideProps() {
  const response = await fetch('https://jsonplaceholder.typicode.com/posts?_limit=5');
  const data = await response.json();

  return {
    props: { data }, // Pass data as props to the component
  };
}

export default Home;`}
      </code>
    </pre><br/>

    <h3>Explanation</h3>
    <ul>
      <li>
        <strong><code>getServerSideProps</code>:</strong> This special function is run on the server for every request. It fetches data from an API and passes it to the <code>Home</code> component as props.
      </li><br/>
      <li>
        <strong>React Component:</strong> Renders the data fetched on the server. The <code>data</code> prop contains the API response.
      </li>
    </ul>

    <br/>

    <h3>2. Adding a Dynamic Route</h3><br/>
    <p>Dynamic routing allows pages to be created based on dynamic data (e.g., blog posts):</p>

    <pre>
      <code>
        {`// pages/post/[id].js
import React from 'react';

const Post = ({ post }) => {
  return (
    <div>
      <h1>{post.title}</h1>
      <p>{post.body}</p>
    </div>
  );
};

// Fetch data for a single post
export async function getServerSideProps(context) {
  const { id } = context.params; // Extract dynamic parameter from URL
  const response = await fetch(\`https://jsonplaceholder.typicode.com/posts/\${id}\`);
  const post = await response.json();

  return {
    props: { post }, // Pass post data to the component
  };
}

export default Post;`}
      </code>
    </pre><br/>

    <h3>Explanation</h3>
    <ul>
      <li>
        <strong>Dynamic Routes:</strong> The file <code>[id].js</code> in the <code>pages/post/</code> folder creates a dynamic route like <code>/post/1</code>, <code>/post/2</code>, etc.
      </li><br/>
      <li>
        <strong><code>context.params</code>:</strong> Extracts the <code>id</code> parameter from the URL.
      </li>
    </ul>

    <br/>

    <h2>Benefits of SSR with Next.js</h2>
    <ul>
      <li>
        <strong>Improved SEO:</strong> HTML content is fully rendered on the server before being sent to the client, making it crawlable by search engines.
      </li><br/>
      <li>
        <strong>Fast Initial Load:</strong> Users see the fully rendered page immediately after the server response.
      </li><br/>
      <li>
        <strong>Dynamic Data Handling:</strong> Suitable for pages requiring up-to-date data on every request.
      </li>
    </ul>
  </div>
)}




{selectedChapter === 'chapter53' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>
       Static Site Generation (SSG) with Next.js
    </h1>

    <p>
      <strong>Static Site Generation (SSG)</strong> in <strong>Next.js</strong> is a method of pre-rendering pages at build time. Unlike Server-Side Rendering (SSR), which generates the page on each request, SSG generates the HTML for your pages once, ahead of time, and serves the pre-built pages to users. This makes it incredibly fast and suitable for static content that doesn’t change often.
    </p>

    <br/>

    <h2>Key Features of SSG in Next.js</h2>
    <ul>
      <li><strong>Pre-rendering at Build Time:</strong> Pages are generated during the build process, not on the server at request time.</li><br/>
      <li><strong>Static Content Delivery:</strong> Pre-rendered pages are served via a Content Delivery Network (CDN), ensuring low latency.</li><br/>
      <li><strong>Supports Data Fetching:</strong> SSG can fetch data from APIs or databases at build time to create static pages with dynamic data.</li><br/>
      <li><strong>Incremental Static Regeneration (ISR):</strong> Allows updating static pages without rebuilding the entire site.</li>
    </ul>

    <br/>

    <h2>Benefits of Using SSG</h2>
    <ul>
      <li><strong>Blazing Fast Performance:</strong> Pre-rendered pages load quickly since they are served as plain HTML.</li><br/>
      <li><strong>SEO-Friendly:</strong> HTML is generated in advance, ensuring search engines can index the content effectively.</li><br/>
      <li><strong>Cost-Effective:</strong> No need for server-side computations at runtime, reducing backend server costs.</li><br/>
      <li><strong>Scalability:</strong> Ideal for websites with high traffic as static pages can be cached globally via CDNs.</li>
    </ul>

    <br/>

    <h2>How SSG Works in Next.js</h2>
    <ol>
      <li>During the build process (<code>npm run build</code>): Pages defined with SSG are pre-rendered and converted into static HTML files.</li><br/>
      <li>These static files are deployed to a hosting service or CDN.</li><br/>
      <li>When a user requests the page: The pre-built HTML is served instantly, without additional server-side rendering.</li>
    </ol>

    <br/>

    <h2>Setting Up a Next.js Project with SSG</h2><br/>

    <h3>1. Initialize a Next.js Project</h3>
    <pre>
      <code>
        npx create-next-app@latest ssg-example<br />
        cd ssg-example
      </code>
    </pre>

    <br/>

    <h3>2. Static Page with SSG</h3>
    <p>
      Next.js uses the special function <code>getStaticProps</code> to fetch data at build time for static generation.
    </p><br/>

    <h4>Example: Simple Blog Page with SSG</h4>
    <pre>
      <code>
        {`// pages/blog.js
import React from 'react';

const Blog = ({ posts }) => {
  return (
    <div>
      <h1>Static Site Generation Example</h1>
      <ul>
        {posts.map((post) => (
          <li key={post.id}>
            <h2>{post.title}</h2>
            <p>{post.body}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

// Fetch data at build time
export async function getStaticProps() {
  const response = await fetch('https://jsonplaceholder.typicode.com/posts?_limit=5');
  const posts = await response.json();

  return {
    props: { posts }, // Pass the fetched data as props
  };
}

export default Blog;
        `}
      </code>
    </pre>

    <br/>

    <h2>Dynamic Routes with SSG</h2>
    <p>
      For dynamic content, you can generate multiple static pages at build time using <code>getStaticPaths</code> along with <code>getStaticProps</code>.
    </p><br/>

    <h4>Example: Dynamic Blog Post Pages</h4>
    <pre>
      <code>
        {`// pages/post/[id].js
import React from 'react';

const Post = ({ post }) => {
  return (
    <div>
      <h1>{post.title}</h1>
      <p>{post.body}</p>
    </div>
  );
};

// Define dynamic routes
export async function getStaticPaths() {
  const response = await fetch('https://jsonplaceholder.typicode.com/posts?_limit=5');
  const posts = await response.json();

  const paths = posts.map((post) => ({
    params: { id: post.id.toString() }, // Create a route for each post ID
  }));

  return { paths, fallback: false }; // Pre-render only specified paths
}

// Fetch data for each page
export async function getStaticProps({ params }) {
  const response = await fetch(\`https://jsonplaceholder.typicode.com/posts/\${params.id}\`);
  const post = await response.json();

  return { props: { post } };
}

export default Post;
        `}
      </code>
    </pre>

    <br/>

    <h2>Incremental Static Regeneration (ISR)</h2>
    <p>
      ISR allows you to update static pages without rebuilding the entire site. It’s ideal for sites where data changes frequently.
    </p><br/>

    <h4>Example: Using ISR</h4>
    <pre>
      <code>
        {`// pages/products.js
import React from 'react';

const Products = ({ products }) => {
  return (
    <div>
      <h1>Product List</h1>
      <ul>
        {products.map((product) => (
          <li key={product.id}>
            {product.name} - {product.price}
          </li>
        ))}
      </ul>
    </div>
  );
};

// Fetch data with ISR
export async function getStaticProps() {
  const response = await fetch('https://api.example.com/products');
  const products = await response.json();

  return {
    props: { products },
    revalidate: 10, // Rebuild the page every 10 seconds
  };
}

export default Products;
        `}
      </code>
    </pre>

    <br/>

    <h2>Deploying an SSG Application</h2>
    <ol>
      <li><strong>Build the Project:</strong> <code>npm run build</code></li><br/>
      <li><strong>Export Static Files:</strong> (optional for fully static sites) <code>next export</code></li><br/>
      <li><strong>Deploy to a Hosting Platform:</strong> Vercel, Netlify, AWS S3, etc.</li>
    </ol>

    <br/>

    <h2>Conclusion</h2>
    <p>
      Static Site Generation with Next.js is a powerful feature that allows you to create high-performance, SEO-friendly websites. By pre-rendering pages at build time and serving them as static files, SSG combines the best of both worlds: the speed of static sites and the flexibility of modern frameworks.
    </p>
  </div>
)}



{selectedChapter === 'chapter54' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Production Builds (npm build)</h1>

    <p>
      When developing a React application, you typically run the app in development mode using <code>npm start</code>. However, for production, you need to optimize the app's performance and ensure it's ready for deployment. This is where <strong>Production Builds</strong> come into play, and the command <code>npm run build</code> is used to create them.
    </p><br/>

    <h3>What Happens During <code>npm run build</code>?</h3>
    <p>
      Running <code>npm run build</code> creates a production-ready version of your React app. This process performs several key optimizations:
    </p><br/>
    <ul>
      <li><strong>Minification</strong>: The JavaScript and CSS files are minified, reducing their size by removing whitespace, shortening variable names, and applying other compression techniques. This helps the app load faster.</li><br/>
      <li><strong>Code Splitting</strong>: React uses <strong>code splitting</strong> to break the bundle into smaller files. Only the necessary code for the initial page load is delivered first, and other parts of the app are loaded on demand (lazy loading).</li><br/>
      <li><strong>Optimizing Assets</strong>: Images, fonts, and other assets are optimized for performance. Large assets might be compressed or processed to reduce their file size.</li><br/>
      <li><strong>Environment Variables</strong>: The build is configured for production, setting <code>process.env.NODE_ENV</code> to <code>production</code>. This optimizes React itself, turning off development-only features such as extra debugging output and enabling performance optimizations.</li><br/>
      <li><strong>Hashed Filenames</strong>: Filenames for JavaScript and CSS files are hashed (e.g., <code>main.ab12cd34.js</code>). This helps with long-term caching and ensures that users always get the latest version of the files after a deployment.</li>
    </ul><br/>

    <h3>Steps to Create a Production Build</h3>
    <ol>
      <li><strong>Run the Build Command</strong>: Execute the following command in the root of your project:
        <pre><code>npm run build</code></pre>
      </li><br/>
      <li><strong>Build Folder</strong>: The build process generates a <code>build/</code> folder containing:
        <ul>
          <li><code>index.html</code>: The entry point for your app.</li><br/>
          <li>Optimized JavaScript files (e.g., <code>main.&lt;hash&gt;.js</code>).</li><br/>
          <li>Optimized CSS files.</li><br/>
          <li>Static assets (images, fonts, etc.).</li>
        </ul>
      </li><br/>
      <li><strong>Deployment</strong>: After the build is created, the contents of the <code>build/</code> folder can be deployed to any static hosting service, such as:
        <ul>
          <li><strong>Vercel</strong></li><br/>
          <li><strong>Netlify</strong></li><br/>
          <li><strong>GitHub Pages</strong></li><br/>
          <li><strong>AWS S3/CloudFront</strong></li><br/>
          <li><strong>Firebase Hosting</strong></li>
        </ul>
      </li>
    </ol><br/>

    <h3>Example: Deploying a Production Build</h3>
    <ol>
      <li>Run the build command:
        <pre><code>npm run build</code></pre>
      </li><br/>
      <li>Deploy the contents of the <code>build/</code> folder to your hosting platform.</li>
    </ol><br/>

    <h3>Why Use <code>npm run build</code>?</h3>
    <ul>
      <li><strong>Performance</strong>: Production builds are optimized for faster load times, smaller bundle sizes, and better resource handling.</li><br/>
      <li><strong>Efficiency</strong>: Helps in reducing unnecessary debugging and logging, improving both app performance and security.</li><br/>
      <li><strong>Reliability</strong>: Ensures that your app works well in a production environment with properly bundled and minimized files.</li>
    </ul><br/>
    <p>
      By creating a production build, you can ensure that your React app is optimized for deployment and provides an efficient user experience.
    </p>
  </div>
)}


{selectedChapter === 'chapter55' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}> Vercel </h1>

    <p>
      Vercel is a platform that provides seamless deployment and hosting solutions for modern web applications, including React apps. It automates the deployment process, making it easy to deploy production-ready applications with a single command or through Git integration. Vercel is particularly popular for its simplicity, fast performance, and integration with front-end frameworks like React.
    </p><br/>
    <p>
      This guide will take you through the process of deploying a React app to Vercel, from preparing the app for production to automating future deployments.
    </p><br/>

    <h3>Prerequisites</h3>
    <ul>
      <li><strong>React App</strong>: You need to have a React app ready for deployment. If you don’t have one, you can create a new React app using <code>create-react-app</code>.</li><br/>
      <li><strong>GitHub/GitLab/Bitbucket Account</strong>: You need a Git repository to host your React app's code. Vercel integrates with GitHub, GitLab, and Bitbucket.</li><br/>
      <li><strong>Vercel Account</strong>: You'll need a Vercel account to deploy your app.</li>
    </ul><br/>

    <h3>Step 1: Prepare Your React App for Production</h3>
    <ol>
      <li>
        <strong>Create a Production Build</strong>: In your project folder, run the following command to build the app for production:
        <pre><code>npm run build</code></pre>
        This command creates a <code>build/</code> folder containing the optimized, minified, and production-ready version of your app.
      </li><br/>
      <li>
        <strong>Check the Build Folder</strong>: After running the build command, you should see the <code>build/</code> folder in your project. It will contain:
        <ul>
          <li><code>index.html</code>: The main entry point of your app.</li><br/>
          <li><code>static/</code>: A folder containing optimized JavaScript, CSS, and media assets.</li><br/>
          <li><code>asset-manifest.json</code>: A JSON file listing all the assets used by the app with hashed filenames for cache optimization.</li>
        </ul>
      </li>
    </ol><br/>

    <h3>Step 2: Set Up a Git Repository (If Not Done Already)</h3>
    <ol>
      <li>
        <strong>Initialize Git</strong>: In your project folder, run:
        <pre><code>git init</code></pre>
        <pre><code>git add .</code></pre>
        <pre><code>git commit -m "Initial commit"</code></pre>
      </li><br/>
      <li>
        <strong>Push to GitHub</strong>: Create a new repository on GitHub (or GitLab/Bitbucket). Link your local project to the GitHub repository:
        <pre><code>git remote add origin https://github.com/yourusername/your-repo.git</code></pre>
        <pre><code>git push -u origin master</code></pre>
      </li>
    </ol><br/>

    <h3>Step 3: Create a Vercel Account and Link Your Git Repository</h3>
    <ol>
      <li>
        <strong>Sign Up or Log In</strong>: Visit <a href="https://vercel.com" target="_blank" rel="noopener noreferrer">Vercel</a> and sign up for a new account or log in with your existing account. You can use your GitHub, GitLab, or Bitbucket credentials to sign up.
      </li><br/>
      <li>
        <strong>Create a New Project</strong>: After logging in, click on the <strong>New Project</strong> button on your Vercel dashboard. Vercel will prompt you to import your project from a Git provider (GitHub, GitLab, or Bitbucket).
      </li><br/>
      <li>
        <strong>Connect to GitHub (or Other Git Providers)</strong>: Choose your Git provider (e.g., GitHub), authenticate Vercel to access your repositories, and select the React app repository you want to deploy.
      </li><br/>
      <li>
        <strong>Configure Build Settings</strong>: Vercel should automatically detect that your app is a React app and pre-fill most of the build settings:
        <ul>
          <li><strong>Framework Preset</strong>: React</li><br/>
          <li><strong>Build Command</strong>: <code>npm run build</code></li><br/>
          <li><strong>Output Directory</strong>: <code>build/</code></li>
        </ul><br/>
        If Vercel doesn't detect the correct settings, you can manually set them.
      </li><br/>
      <li>
        <strong>Deploy Your App</strong>: Once you've confirmed the settings, click <strong>Deploy</strong>. Vercel will start building your React app.
      </li>
    </ol><br/>

    <h3>Step 4: Access Your Deployed App</h3>
    <p>After the build process completes, Vercel will provide a live URL for your deployed app. The URL will look something like this:</p>
    <pre><code>https://your-app-name.vercel.app</code></pre>
    <p>You can access this URL to view your live React app in production.</p>
    <br/>
    <h3>Step 5: Continuous Deployment with Vercel</h3>
    <ol>
      <li>
        <strong>Push Changes to GitHub</strong>: After your initial deployment, whenever you push new commits to your Git repository, Vercel automatically triggers a new build and deployment:
        <pre><code>git add .</code></pre>
        <pre><code>git commit -m "Updated app"</code></pre>
        <pre><code>git push origin master</code></pre>
      </li><br/>
      <li>
        <strong>Automatic Redeployment</strong>: Vercel listens for changes in your Git repository. Once a change is pushed, it rebuilds your app and deploys the latest version.
      </li><br/>
      <li>
        <strong>Preview Deployments</strong>: Vercel automatically creates preview deployments for every pull request or branch, allowing you to review the changes in a live environment before merging them to the main branch.
      </li>
    </ol><br/>

    <h3>Step 6: Optional Configurations</h3>
    <ul>
      <li>
        <strong>Custom Domains</strong>: You can link your own custom domain to the app. Go to your project’s settings in Vercel and add your custom domain. Follow the instructions to configure the DNS settings.
      </li><br/>
      <li>
        <strong>Environment Variables</strong>: If your React app requires environment variables (e.g., API keys or configuration), you can add them to Vercel in the <strong>Environment Variables</strong> section.
      </li><br/>
      <li>
        <strong>Serverless Functions</strong>: If you need backend functionality (e.g., API endpoints), you can add Serverless Functions. Vercel allows you to create API routes in your project, which are deployed as serverless functions.
      </li>
    </ul><br/>

    <h3>Step 7: Monitor and Optimize Your Deployment</h3>
    <ul>
      <li>
        <strong>Analytics</strong>: Vercel offers built-in analytics to monitor the performance of your React app in production. You can track metrics such as page load times and serverless function executions.
      </li><br/>
      <li>
        <strong>Logs</strong>: Vercel provides detailed logs for each deployment. You can access the logs from the Vercel dashboard to debug issues or track deployment progress.
      </li>
    </ul><br/>

    <h3>Example: Full Deployment Walkthrough</h3>
    <ol>
      <li><strong>Create a React App</strong>:
        <pre><code>npx create-react-app my-react-app</code></pre>
        <pre><code>cd my-react-app</code></pre>
      </li><br/>
      <li><strong>Commit the App to GitHub</strong>:
        <pre><code>git init</code></pre>
        <pre><code>git add .</code></pre>
        <pre><code>git commit -m "Initial commit"</code></pre>
        <pre><code>git remote add origin https://github.com/yourusername/my-react-app.git</code></pre>
        <pre><code>git push -u origin master</code></pre>
      </li><br/>
      <li><strong>Deploy to Vercel</strong>: Go to the Vercel dashboard, click <strong>New Project</strong>, and import the GitHub repository. Click <strong>Deploy</strong>.</li><br/>
      <li><strong>Access Your Deployed App</strong>: After deployment, Vercel gives you a URL like <code>https://my-react-app.vercel.app</code>.</li><br/>
      <li><strong>Automatic Redeployments</strong>: Push new changes to GitHub, and Vercel will automatically rebuild and redeploy your app.</li>
    </ol><br/>

    <h3>Conclusion</h3>
    <p>
      Deploying React apps to Vercel is an incredibly simple process. With just a few steps, your React app can be live, and with Vercel’s continuous deployment, managing future updates is effortless. The platform provides excellent scalability, performance optimizations, and integrations, making it an ideal choice for deploying React applications.
    </p>
  </div>
)}



{selectedChapter === 'chapter56' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}> Netlify</h1>

   

    <p>Netlify is a powerful platform that allows for quick and easy deployment of static websites and modern web applications, including React apps. It provides a host of features like continuous deployment, serverless functions, and instant rollbacks, making it one of the most popular choices for deploying React applications. In this guide, we will go through the steps required to deploy a React app to Netlify from start to finish.</p><br />
Deploying React Apps to Netlify<br/>
    <h3>Prerequisites</h3>
    <ul>
      <li><strong>React App</strong>: Ensure you have a React app ready to be deployed. If you don't have one, you can create a new React app using <code>create-react-app</code>.</li><br/>
      <li><strong>GitHub/GitLab/Bitbucket Account</strong>: Your React app needs to be hosted on a Git repository. Netlify supports integrations with GitHub, GitLab, and Bitbucket.</li><br/>
      <li><strong>Netlify Account</strong>: You need a Netlify account to deploy your React app.</li>
    </ul><br/>

    <h3>Step 1: Prepare Your React App for Production</h3>
    <p>Before deploying your React app to Netlify, you need to create a production build. The production build is an optimized version of your app that's ready for deployment.</p>
    <ol>
      <li><strong>Create a Production Build</strong>: In your project directory, run the following command:
        <pre><code>npm run build</code></pre>
        This will generate a <code>build/</code> directory in your project, containing the optimized files that Netlify will serve to users.
      </li><br/>
      <li><strong>Check the Build Folder</strong>: After running the build command, make sure the <code>build/</code> folder contains the production-ready files. You will deploy this folder to Netlify.</li>
    </ol><br/>

    <h3>Step 2: Set Up a Git Repository (If Not Done Already)</h3>
    <p>If your project is not yet connected to a Git repository, you'll need to initialize one and push the app to a Git hosting service like GitHub, GitLab, or Bitbucket.</p>
    <ol>
      <li><strong>Initialize Git</strong>: In your project folder, run the following commands:
        <pre><code>git init</code></pre>
        <pre><code>git add .</code></pre>
        <pre><code>git commit -m "Initial commit"</code></pre>
      </li><br/>
      <li><strong>Push to GitHub</strong>: Go to GitHub and create a new repository. Push your code to GitHub using:
        <pre><code>git remote add origin https://github.com/yourusername/your-repo.git</code></pre>
        <pre><code>git push -u origin master</code></pre>
      </li>
    </ol><br/>

    <h3>Step 3: Create a Netlify Account and Link Your Git Repository</h3>
    <ol>
      <li><strong>Sign Up or Log In</strong>: Go to <a href="https://www.netlify.com">Netlify</a> and sign up for a new account, or log in with your existing account. You can use your GitHub, GitLab, or Bitbucket credentials to sign up or log in.</li><br/>
      <li><strong>Create a New Site</strong>: After logging in, click on <strong>New site from Git</strong> on the Netlify dashboard.</li><br/>
      <li><strong>Connect to Your Git Provider</strong>: Select your Git provider (GitHub, GitLab, or Bitbucket) and authenticate Netlify to access your repositories.</li><br/>
      <li><strong>Select the Repository</strong>: From the list of repositories, select the React app repository you want to deploy.</li>
    </ol><br/>

    <h3>Step 4: Configure Build Settings</h3>
    <ol>
      <li><strong>Set the Build Command</strong>: Netlify will automatically detect that your app is a React app, but if it doesn’t, you can manually set the <strong>Build Command</strong> to:
        <pre><code>npm run build</code></pre>
      </li><br/>
      <li><strong>Set the Publish Directory</strong>: Set the <strong>Publish Directory</strong> to the <code>build/</code> folder. This is the folder containing the optimized, production-ready files from the build process.</li><br/>
      <li><strong>Additional Configuration (Optional)</strong>: If you have environment variables or other configurations, you can add them here under <strong>Environment Variables</strong>.</li>
    </ol><br/>

    <h3>Step 5: Deploy Your App</h3>
    <ol>
      <li><strong>Deploy Site</strong>: Once your repository is connected and your build settings are configured, click the <strong>Deploy Site</strong> button. Netlify will automatically start building and deploying your app.</li><br/>
      <li><strong>Building the App</strong>: Netlify will pull your latest code from GitHub (or another Git provider), install dependencies, run <code>npm run build</code>, and deploy the output to their servers.</li><br/>
      <li><strong>Deployment Process</strong>: You can follow the build logs in real-time on the Netlify dashboard. Once the build is complete, the site will be deployed automatically.</li><br/>
      <li><strong>Live URL</strong>: After the build finishes, Netlify will provide a live URL where your app is hosted. It will look like this:
        <pre><code>https://your-app-name.netlify.app</code></pre>
      </li>
    </ol><br/>

    <h3>Step 6: Continuous Deployment</h3>
    <ol>
      <li><strong>Push Changes to Git</strong>: Once your app is live, you can continue working on your React app. When you make changes and push them to your Git repository:
        <pre><code>git add .</code></pre>
        <pre><code>git commit -m "Updated app"</code></pre>
        <pre><code>git push origin master</code></pre>
      </li><br/>
      <li><strong>Automatic Redeployment</strong>: Netlify will detect the new commit, trigger a build process, and redeploy the app automatically. You don’t need to do anything manually to redeploy your app.</li><br/>
      <li><strong>Preview Deployments</strong>: Netlify also creates <strong>preview deployments</strong> for each pull request or branch. These previews are automatically generated URLs that let you preview your changes before merging them into the main branch.</li>
    </ol><br/>

    <h3>Step 7: Optional Configurations</h3>
    <ol>
      <li><strong>Custom Domains</strong>: Netlify allows you to use your own domain name. To configure a custom domain:
        - Go to your Netlify site dashboard and navigate to the <strong>Domain Settings</strong>.
        - You can either purchase a domain through Netlify or link an existing one. Follow the instructions to configure your DNS settings to point to Netlify’s servers.
      </li><br/>
      <li><strong>Environment Variables</strong>: If your app requires environment variables (for example, API keys or other configurations), you can set them in the <strong>Environment Variables</strong> section of your Netlify site settings.</li><br/>
      <li><strong>Redirects and Rewrites</strong>: You may need to configure redirects or rewrites (e.g., for routing purposes in a React app using React Router). You can do this using a <code>_redirects</code> file or the <strong>Redirects & Rewrites</strong> settings in Netlify.</li>
    </ol><br/>

    <h3>Step 8: Monitor and Optimize Your Deployment</h3>
    <ol>
      <li><strong>Logs and Analytics</strong>: Netlify provides real-time logs of your deployments. You can check for errors or monitor the progress of the deployment. Additionally, Netlify provides <strong>site analytics</strong> that show the performance of your app, such as load times, visitor data, and more.</li><br/>
      <li><strong>Instant Rollbacks</strong>: If you need to rollback to a previous version of your app, Netlify makes it easy to revert to a previous deployment by selecting the version from the <strong>Deployments</strong> tab.</li>
    </ol><br/>

    <h3>Example: Full Deployment Walkthrough</h3>
    <ol>
      <li><strong>Create a React App</strong>: First, create a React app using <code>create-react-app</code>:
        <pre><code>npx create-react-app my-react-app</code></pre>
      </li><br/>
      <li><strong>Build the App for Production</strong>: Run the following command to create the optimized production build:
        <pre><code>npm run build</code></pre>
      </li><br/>
      <li><strong>Push to GitHub</strong>: Initialize a Git repository and push your app to GitHub:
        <pre><code>git init</code></pre>
        <pre><code>git add .</code></pre>
        <pre><code>git commit -m "Initial commit"</code></pre>
        <pre><code>git remote add origin https://github.com/yourusername/my-react-app.git</code></pre>
        <pre><code>git push -u origin master</code></pre>
      </li><br/>
      <li><strong>Deploy to Netlify</strong>: Go to the <a href="https://app.netlify.com">Netlify Dashboard</a> and click <strong>New Site from Git</strong>.
        - Select GitHub and authorize Netlify to access your repository.
        - Configure the build settings:
          <ul>
            <li>Build Command: <code>npm run build</code></li><br/>
            <li>Publish Directory: <code>build/</code></li>
          </ul><br/>
        - Click <strong>Deploy Site</strong>.
      </li><br/>
      <li><strong>Access Your Live App</strong>: After the deployment finishes, Netlify will provide a URL like:
        <pre><code>https://my-react-app.netlify.app</code></pre>
      </li><br/>
      <li><strong>Continuous Deployment</strong>: Make changes to your app, push them to GitHub, and Netlify will automatically redeploy your app.</li>
    </ol><br/>

    <h3>Conclusion</h3>
    <p>Deploying a React app to Netlify is a simple and efficient process. With Netlify’s seamless Git integration, continuous deployment, and optimization features, you can deploy React apps quickly and easily. The platform provides a variety of powerful tools for managing deployments, including serverless functions, preview deployments, and analytics, making it an excellent choice for modern React applications.</p>
  </div>
)}



{selectedChapter === 'chapter57' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>AWS Amplify in React.js</h1>

    <p>
      AWS Amplify is a powerful development framework by Amazon Web Services that helps developers build scalable, full-stack web and mobile applications. It simplifies the integration of backend services such as authentication, storage, APIs, analytics, and more into your React.js applications.
    </p><br />

   

    <h2 style={{paddingBottom:"6px"}}>Key Features of AWS Amplify</h2>
    <ul>
      <li><strong>Authentication:</strong> Easy integration with services like Amazon Cognito for user sign-up, sign-in, and access control.</li><br />
      <li><strong>APIs:</strong> Support for REST and GraphQL APIs using AWS AppSync.</li><br />
      <li><strong>Storage:</strong> Integration with Amazon S3 for file and data storage.</li><br />
      <li><strong>Hosting:</strong> Managed hosting for static websites and single-page applications (SPAs).</li><br />
      <li><strong>Push Notifications:</strong> Support for mobile and web push notifications.</li><br />
      <li><strong>Analytics:</strong> Built-in analytics to track user behavior.</li>
    </ul>

    <br />

    <h2 style={{paddingBottom:"6px"}}>Benefits of Using AWS Amplify</h2>
    <ul>
      <li><strong>Simplified Backend Integration:</strong> Amplify abstracts away the complexity of configuring and managing AWS services.</li><br />
      <li><strong>Scalability:</strong> Automatically scales to meet application needs.</li><br />
      <li><strong>Flexibility:</strong> Modular design allows you to use only the features you need.</li><br />
      <li><strong>Support for Multiple Frameworks:</strong> Works with React, Vue, Angular, React Native, and more.</li>
    </ul>

    <br />

    <h2 style={{paddingBottom:"6px"}}>Getting Started with AWS Amplify in React.js</h2>

    <h3 style={{paddingBottom:"6px"}}>1. Set Up Amplify</h3>
    <h4>Install Amplify CLI</h4>
    <pre>
      <code>npm install -g @aws-amplify/cli</code>
    </pre><br />

    <h4>Configure Amplify</h4>
    <p>Run the following command and follow the prompts to configure Amplify:</p>
    <pre>
      <code>amplify configure</code>
    </pre>
    <p>This will set up AWS credentials and link them to your Amplify projects.</p><br />

    <h3>2. Initialize Amplify in Your React Project</h3>
    <pre>
      <code>npm install aws-amplify @aws-amplify/ui-react</code>
    </pre>
    <p>Then, initialize Amplify:</p>
    <pre>
      <code>amplify init</code>
    </pre>
    <p>Follow the prompts to specify your project details.</p><br />

    <h3>3. Add Amplify Features</h3>
    <p>You can add specific features like authentication, API, or storage:</p>
    <h4>Add Authentication</h4>
    <pre>
      <code>amplify add auth</code>
    </pre>
    <p>This configures Amazon Cognito for user management.</p>
    <h4>Add Storage</h4>
    <pre>
      <code>amplify add storage</code>
    </pre>
    <p>This configures Amazon S3 for file storage.</p>
    <h4>Add APIs</h4>
    <pre>
      <code>amplify add api</code>
    </pre>
    <p>You can choose between REST and GraphQL APIs.</p><br />

    <h3>4. Deploy Backend Services</h3>
    <pre>
      <code>amplify push</code>
    </pre><br />

    <h3>5. Integrate Amplify with React</h3>
    <p>In your <code>src/index.js</code> or <code>src/App.js</code> file, import and configure Amplify:</p>
    <pre>
      <code>
        {`import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Amplify from 'aws-amplify';
import awsExports from './aws-exports';

Amplify.configure(awsExports);

ReactDOM.render(<App />, document.getElementById('root'));`}
      </code>
    </pre>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Example: Authentication with Amplify in React</h2>
    <h4>1. Import the Authentication Components</h4>
    <pre>
      <code>{`import { withAuthenticator } from '@aws-amplify/ui-react';`}</code>
    </pre>
    <h4>2. Wrap Your App Component</h4>
    <pre>
      <code>
        {`function App() {
  return (
    <div>
      <h1>Welcome to My Amplify App</h1>
    </div>
  );
}

export default withAuthenticator(App);`}
      </code>
    </pre>
    <p>Amplify will automatically add a login interface using Amazon Cognito.</p>

   <br />

    <h2>Hosting Your React App with AWS Amplify</h2>
    <ol>
      <li>Push your code to a GitHub repository.</li> <br />
      <li>Log in to the <a href="https://aws.amazon.com/amplify/">AWS Amplify Console</a>.</li> <br />
      <li>Connect your GitHub repository.</li> <br />
      <li>Deploy your app with a custom domain or the default Amplify domain.</li>
    </ol>

   <br />

    <h2>Conclusion</h2>
    <p>
      AWS Amplify provides a robust set of tools to streamline the integration of AWS services with React applications. Whether you need authentication, API support, file storage, or hosting, Amplify offers a seamless experience for building modern, scalable apps.
    </p>
  </div>
)}



{selectedChapter === 'chapter58' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>GitHub Pages</h1>

    <p>GitHub Pages is a free hosting service provided by GitHub to host static websites directly from a repository. In this guide, we will walk you through the steps for deploying your React app to GitHub Pages, ensuring the process is clear and error-free.</p>
    <br/>
    <h3>Prerequisites</h3>
    <ul>
      <li><strong>React App:</strong> Your React app should be ready for deployment. If you haven’t created one yet, you can use <code>create-react-app</code> to create it.</li><br/>
      <li><strong>GitHub Account:</strong> You will need a GitHub account to create a repository and host your React app.</li><br/>
      <li><strong>Git Installed:</strong> Make sure Git is installed on your computer for version control and pushing your code to GitHub.</li>
    </ul><br/>

    <h3>Step 1: Set Up Your React App for Deployment</h3>
    <ol>
      <li><strong>Create Your React App:</strong> Run the following command to generate a new React app:
        <pre><code>npx create-react-app my-react-app</code></pre>
        Then, navigate into the app directory:
        <pre><code>cd my-react-app</code></pre>
      </li><br/>
      <li><strong>Build Your React App:</strong> Before deploying, create a production-ready build by running:
        <pre><code>npm run build</code></pre>
        This will create a <code>build/</code> directory containing optimized static files (HTML, CSS, JS) for production.</li>
    </ol><br/>

    <h3>Step 2: Install `gh-pages` Package</h3>
    <ol>
      <li><strong>Install the `gh-pages` Package:</strong> Run the following command to install the <code>gh-pages</code> package:
        <pre><code>npm install gh-pages --save-dev</code></pre>
      </li><br/>
      <li><strong>Modify `package.json`:</strong> Open your <code>package.json</code> file and make the following changes:
        <ol>
          <li><strong>Add a `homepage` Field:</strong> This field tells React where your app will be hosted. Replace <code>your-username</code> with your GitHub username and <code>repo-name</code> with your repository name:
            <pre><code>"homepage": "https://your-username.github.io/repo-name"</code></pre>
          </li><br/>
          <li><strong>Update the `scripts` Section:</strong> Add the <code>predeploy</code> and <code>deploy</code> scripts under the <code>scripts</code> section:
            <pre><code>{`"scripts": {
  "start": "react-scripts start",
  "build": "react-scripts build",
  "test": "react-scripts test",
  "eject": "react-scripts eject",
  "predeploy": "npm run build",
  "deploy": "gh-pages -d build"
}`} </code></pre>
          </li>
        </ol>
      </li>
    </ol><br/>

    <h3>Step 3: Create a GitHub Repository</h3>
    <p>If you haven't created a GitHub repository for your React app yet, follow these steps:</p>
    <ol>
      <li>Go to <a href="https://github.com">GitHub</a> and log in to your account.</li><br/>
      <li>Create a new repository by clicking on the <strong>+</strong> sign in the top-right corner and selecting <strong>New repository</strong>.</li><br/>
      <li>Name the repository (e.g., <code>my-react-app</code>) and ensure it’s set to <strong>public</strong>.</li><br/>
      <li>Initialize the repository with a README file (optional).</li>
    </ol><br/>
    <p>Once your repository is created, push your React app to GitHub with the following commands:</p>
    <pre><code>{`git init
git add .
git commit -m "Initial commit"
git remote add origin https://github.com/your-username/my-react-app.git
git push -u origin master`}</code></pre>
<br/>
    <h3>Step 4: Deploy Your React App to GitHub Pages</h3>
    <ol>
      <li><strong>Run the Deploy Script:</strong> Run the following command to deploy your app:
        <pre><code>npm run deploy</code></pre>
        This command will:
        <ul>
          <li>Build the React app (<code>npm run build</code>).</li><br/>
          <li>Deploy the app to GitHub Pages using the <code>gh-pages</code> package.</li>
        </ul>
      </li><br/>
      <li><strong>Wait for Deployment:</strong> After running the command, GitHub Pages will deploy your app. You will see the following output in the terminal:
        <pre><code>{`gh-pages@3.2.3
├── index.html -> /index.html
└── build -> /build`}</code></pre>
      </li><br/>
      <li><strong>Visit Your Deployed App:</strong> Once deployment is complete, your app will be available at:
        <pre><code>https://your-username.github.io/repo-name</code></pre>
      </li>
    </ol><br/>

    <h3>Step 5: Continuous Deployment</h3>
    <p>While GitHub Pages doesn’t automatically redeploy your app when changes are made, you can manually trigger a new deployment:</p><br/>
    <ol>
      <li>Make changes to your React app as needed.</li><br/>
      <li>Commit and push the changes to GitHub:
        <pre><code>git add .</code></pre>
        <pre><code>git commit -m "Updated app"</code></pre>
        <pre><code>git push origin master</code></pre>
      </li><br/>
      <li>Deploy the updated app by running:
        <pre><code>npm run deploy</code></pre>
      </li>
    </ol><br/>

    <h3>Example: Full Walkthrough</h3>
    <ol>
      <li><strong>Create the React App:</strong> Run the following command:
        <pre><code>npx create-react-app my-react-app</code></pre>
      </li><br/>
      <li><strong>Install `gh-pages`:</strong> Run:
        <pre><code>npm install gh-pages --save-dev</code></pre>
      </li><br/>
      <li><strong>Update `package.json`:</strong> Add the `homepage` field and update the `scripts` section.</li><br/>
      <li><strong>Create a GitHub Repository:</strong> Push your local React app to the GitHub repository.</li><br/>
      <li><strong>Deploy to GitHub Pages:</strong> Run:
        <pre><code>npm run deploy</code></pre>
      </li><br/>
      <li><strong>Visit Your App:</strong> Visit:
        <pre><code>https://your-username.github.io/my-react-app</code></pre>
      </li>
    </ol><br/>

    <h3>Conclusion</h3>
    <p>Deploying a React app to GitHub Pages is a simple and effective way to share your React projects online for free. With the <code>gh-pages</code> package and the modifications made to <code>package.json</code>, you can easily deploy and update your app with a few commands. GitHub Pages is an excellent platform for hosting static websites, and it’s perfect for showcasing your React projects.</p>
  </div>
)}





{selectedChapter === 'chapter59' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>CI/CD for React Apps </h1>

    <p>
      Continuous Integration and Continuous Deployment (CI/CD) are essential concepts in modern web development, aiming to streamline the process of testing, building, and deploying applications automatically. By implementing CI/CD, developers can ensure that their applications are always up-to-date, tested, and deployed without manual intervention. This guide will walk you through deploying a React app using CI/CD pipelines, with a detailed example of how to set up CI/CD for a React application.
    </p>

    <br/>

    <h2>What is CI/CD?</h2>
    <ul>
      <li><strong>Continuous Integration (CI):</strong> The practice of automatically testing and merging code changes into the main branch regularly. CI aims to prevent integration problems and allows teams to detect issues early.</li><br/>
      <li><strong>Continuous Deployment (CD):</strong> The practice of automatically deploying the latest version of an application to production after successful testing. This reduces manual work and ensures faster delivery.</li>
    </ul>

    <br/>

    <h2>Why Use CI/CD for React Apps?</h2>
    <ol>
      <li><strong>Automation:</strong> Automate the process of building, testing, and deploying React apps, reducing the chances of human errors.</li><br/>
      <li><strong>Consistency:</strong> Ensure consistency between different environments (local, staging, production).</li><br/>
      <li><strong>Faster Delivery:</strong> Reduce the time taken to deliver updates to production, improving developer productivity and user experience.</li><br/>
      <li><strong>Testing:</strong> Automate the testing process to catch bugs early in the development cycle.</li>
    </ol>

    <br/>

    <h2>Tools for CI/CD with React</h2>
    <p>Several popular CI/CD tools integrate seamlessly with React applications. Some commonly used CI/CD services are:</p><br/>
    <ul>
      <li><strong>GitHub Actions:</strong> CI/CD solution directly integrated with GitHub repositories.</li><br/>
      <li><strong>GitLab CI/CD:</strong> Integrated CI/CD in GitLab repositories.</li><br/>
      <li><strong>CircleCI:</strong> Provides easy integration with GitHub and GitLab.</li><br/>
      <li><strong>Travis CI:</strong> A simple and powerful CI service often used with GitHub.</li><br/>
      <li><strong>Jenkins:</strong> A widely used CI tool with broad community support.</li><br/>
      <li><strong>Netlify:</strong> A platform with CI/CD features specifically optimized for deploying static sites, including React apps.</li><br/>
      <li><strong>Vercel:</strong> Similar to Netlify, Vercel also offers CI/CD functionality specifically for React applications.</li>
    </ul>

    <br/>

    <h2>Setting Up CI/CD with GitHub Actions for a React App</h2>
    <p>Let’s go through the steps of setting up a CI/CD pipeline for a React app using <strong>GitHub Actions</strong>.</p>
    <br/>
    <h3>Prerequisites:</h3>
    <ul>
      <li>A <strong>GitHub repository</strong> containing your React app.</li><br/>
      <li>Basic knowledge of GitHub Actions workflows.</li><br/>
      <li>React app ready for production (i.e., built with <code>npm run build</code>).</li>
    </ul>

    <br/>

    <h3>Step 1: Create a GitHub Repository (if not already done)</h3>
    <p>If you don’t already have a repository, you can create one on GitHub:</p><br/>
    <ol>
      <li>Go to GitHub and create a new repository for your React app.</li>
      <li>Push your React app to GitHub by following these commands:
        <pre><code>{`git init
git add .
git commit -m "Initial commit"
git remote add origin https://github.com/your-username/your-repo-name.git
git push -u origin master`} </code></pre>
      </li>
    </ol>

    <br/>

    <h3>Step 2: Set Up GitHub Actions for CI/CD</h3>
    <p>GitHub Actions uses workflow files to define automation processes. These workflow files are placed in the <code>.github/workflows/</code> directory in your repository.</p>
    <ol>
      <li>Create a <code>.github/workflows</code> directory in your project root (if it doesn't exist).</li><br/>
      <li>Create a YAML file (e.g., <code>ci-cd.yml</code>) inside the <code>.github/workflows/</code> directory. This file will define the CI/CD pipeline.</li>
    </ol><br/>

    <p>Here’s an example of a basic GitHub Actions CI/CD pipeline configuration for a React app:</p>

    <pre><code>
      {`name: React App CI/CD

on:
  push:
    branches:
      - master
  pull_request:
    branches:
      - master

jobs:
  build:
    runs-on: ubuntu-latest

    steps:
      - name: Checkout Repository
        uses: actions/checkout@v2

      - name: Set up Node.js
        uses: actions/setup-node@v2
        with:
                node-version: '16'

      - name: Install dependencies
        run: npm install

      - name: Run tests
        run: npm test -- --coverage

      - name: Build React App
        run: npm run build

      - name: Deploy to GitHub Pages
        uses: JamesIves/github-pages-deploy-action@v4
        with:
          branch: gh-pages
          folder: build`}</code></pre>

<br/>

    <h3>Step 3: Add a GitHub Token for Deployment (If Deploying)</h3>
    <p>If you plan to deploy the app to GitHub Pages (or another service), you may need to authenticate using a GitHub token. GitHub provides a <code>GITHUB_TOKEN</code> secret automatically that can be used for this purpose.</p>

    <br/>

    <h3>Step 4: Commit and Push the Workflow File</h3>
    <p>Once the workflow YAML file is created, commit and push the changes to your GitHub repository:</p>
    <pre><code>
{`git add .github/workflows/ci-cd.yml
git commit -m "Add GitHub Actions CI/CD workflow"
git push origin master`}</code></pre>

    <br/>

    <h3>Step 5: Monitor the CI/CD Pipeline</h3>
    <p>Once you push the changes, GitHub Actions will automatically trigger the pipeline based on the workflow configuration. You can view the progress of your CI/CD pipeline under the <strong>Actions</strong> tab of your GitHub repository.</p>

    <br/>
    <h3>Step 6: Deploy the React App</h3>
    <p>Once the pipeline runs successfully, your React app will be deployed automatically. If you're using GitHub Pages, the app will be live at:</p>
    <pre>https://your-username.github.io/your-repo-name</pre>

    <br/>

    <h2>Example: Full Walkthrough</h2>
    <p>Let’s go through a full example where we deploy a React app to GitHub Pages using GitHub Actions.</p> <br/>
    <ol>
      <li>Create the React App:
        <pre>npx create-react-app my-react-app</pre>
      </li> <br/>
      <li>Push the App to GitHub.</li> <br/>
      <li>Add the GitHub Actions Workflow.</li> <br/>
      <li>Add the <code>homepage</code> Field in <code>package.json</code>.</li> <br/>
      <li>Push the Changes.</li> <br/>
      <li>Monitor the CI/CD Pipeline.</li> <br/>
      <li>Access Your Deployed App at:
        <pre>https://your-username.github.io/my-react-app</pre>
      </li>
    </ol>

    <br/>

    <h2>Conclusion</h2>
    <p>CI/CD pipelines are crucial for automating the deployment process, ensuring faster and more reliable releases. In this guide, we set up a CI/CD pipeline using <strong>GitHub Actions</strong> to automatically build, test, and deploy a React app to <strong>GitHub Pages</strong>. By integrating CI/CD, you eliminate manual deployment steps, improve consistency, and deliver updates more frequently.</p>
  </div>
)}


   



{selectedChapter === 'chapter60' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Accessibility in React</h1>

    <section>
    
      <p>
        Accessibility (A11y) refers to the practice of designing and developing websites and applications that can be used by people with disabilities, including visual, auditory, motor, and cognitive impairments. In the context of React, ensuring accessibility means making sure that your React components are usable by all users, regardless of their abilities or disabilities.
      </p> <br/>
      <p>
        Accessibility is essential for building inclusive applications and is also important for complying with web accessibility standards such as WCAG (Web Content Accessibility Guidelines). With the growing use of assistive technologies like screen readers, voice controls, and other devices, ensuring accessibility is a priority.
      </p>
    </section> <br/>

    <section>
      <h2>Why Accessibility is Important in React</h2>
      <ul>
        <li><strong>Inclusivity:</strong> Making sure all users, regardless of disabilities, can access and use your app.</li> <br/>
        <li><strong>Legal Requirements:</strong> Many countries have legal standards that require websites to be accessible.</li> <br/>
        <li><strong>SEO Benefits:</strong> Accessible websites are often better structured and optimized, helping improve search engine rankings.</li> <br/>
        <li><strong>Better User Experience:</strong> An accessible app provides a better experience for all users, including those without disabilities.</li>
      </ul>
    </section> <br/>

    <section>
      <h2>Core Principles of Accessibility in React</h2>
      <ol>
        <li><strong>Semantic HTML:</strong> Using proper HTML tags helps both browsers and assistive technologies to better interpret the content of your page.</li> <br/>
        <li><strong>Keyboard Navigation:</strong> Ensure users can navigate the app without a mouse.</li> <br/>
        <li><strong>Screen Reader Support:</strong> Ensure your app works well with screen readers that convert text and UI elements to speech.</li> <br/>
        <li><strong>Focus Management:</strong> Managing focus states when navigating between elements.</li> <br/>
        <li><strong>Color Contrast:</strong> Ensure text has sufficient contrast with the background for readability.</li> <br/>
        <li><strong>Error Handling:</strong> Properly announce errors, particularly in form validation.</li>
      </ol>
    </section> <br/>

    <section>
      <h2 style={{paddingBottom:"6px"}}>Accessibility in React: Key Concepts and Examples</h2>

      <h3>1. Using Semantic HTML Elements</h3>
      <p>
        Semantic HTML elements are essential for accessibility. They convey meaning to both the browser and assistive technologies.
      </p>
      <pre>
        <code>
          {`function Navigation() {
            return (
              <nav>
                <ul>
                  <li><a href="/home">Home</a></li>
                  <li><a href="/about">About</a></li>
                  <li><a href="/contact">Contact</a></li>
                </ul>
              </nav>
            );
}`}
        </code>
      </pre>
      <br/>
      <h3>2. Making Components Focusable</h3>
      <p>
        Ensure interactive elements (buttons, links, etc.) are focusable and can be navigated using the keyboard.
      </p>
      <pre>
        <code>
          {`function CustomButton() {
            return (
              <button 
                onClick={() => alert('Button clicked!')} 
                onFocus={() => console.log('Button focused!')}
              >
                Click Me
              </button>
            );
}`}
        </code>
      </pre> <br/>

      <h3>3. ARIA (Accessible Rich Internet Applications) Attributes</h3>
      <p>
        ARIA attributes enhance accessibility for dynamic content, particularly when the content changes without a page reload.
      </p>
      <pre>
        <code>
          {`function AlertMessage({ message }) {
            return (
              <div role="alert" aria-live="assertive">
                {message}
              </div>
            );
}`}
        </code>
      </pre> <br/>

      <h3>4. Keyboard Navigation</h3>
      <p>
        Users should be able to navigate your app using just the keyboard. This is essential for those who cannot use a mouse.
      </p>
      <pre>
        <code>
          {`class FocusableList extends React.Component {
            constructor(props) {
              super(props);
              this.state = { focusedIndex: 0 };
            }

            handleKeyDown = (event) => {
              if (event.key === 'ArrowDown') {
                this.setState(prevState => ({
                  focusedIndex: Math.min(prevState.focusedIndex + 1, this.props.items.length - 1),
                }));
              } else if (event.key === 'ArrowUp') {
                this.setState(prevState => ({
                  focusedIndex: Math.max(prevState.focusedIndex - 1, 0),
                }));
              }
            };

            render() {
              const { focusedIndex } = this.state;
              return (
                <ul role="listbox" onKeyDown={this.handleKeyDown} tabIndex={0}>
                  {this.props.items.map((item, index) => (
                    <li 
                      key={index} 
                      style={{
                        backgroundColor: focusedIndex === index ? 'lightblue' : 'transparent',
                      }}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              );
            }
}`}
        </code>
      </pre> <br/>

      <h3>5. Managing Focus with `useEffect`</h3>
      <p>
        Programmatically setting focus to an element is sometimes necessary, especially after dynamic content updates.
      </p>
      <pre>
        <code>
          {`import React, { useEffect, useRef } from 'react';

          function FocusInput() {
            const inputRef = useRef(null);

            useEffect(() => {
              inputRef.current.focus();
            }, []);

            return <input ref={inputRef} type="text" placeholder="Focused on load" />;
}`}
        </code>
      </pre> <br/>

      <h3>6. Color Contrast</h3>
      <p>
        Ensure text has enough contrast against its background to accommodate users with low vision or color blindness.
      </p>
      <pre>
        <code>
          {`function AccessibleText() {
            return (
              <p style={{ color: '#333', backgroundColor: '#fff' }}>
                This is accessible text with good contrast.
              </p>
            );
}`}
        </code>
      </pre> <br/>

      <h3>7. Error Handling and Feedback</h3>
      <p>
        Provide error feedback in forms to help users identify and correct issues.
      </p>
      <pre>
        <code>
          {`function Form() {
            const [email, setEmail] = React.useState('');
            const [error, setError] = React.useState('');

            const handleSubmit = (event) => {
              event.preventDefault();
              if (!email.includes('@')) {
                setError('Please enter a valid email address.');
              } else {
                setError('');
                alert('Form submitted!');
              }
            };

            return (
              <form onSubmit={handleSubmit}>
                <label htmlFor="email">Email:</label>
                <input 
                  type="email" 
                  id="email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  aria-describedby="email-error"
                />
                {error && <span id="email-error" role="alert" style={{ color: 'red' }}>{error}</span>}
                <button type="submit">Submit</button>
              </form>
            );
}`}
        </code>
      </pre>
    </section> <br/>

    <section>
      <h2>Tools for Accessibility Testing in React</h2>
      <ul>
        <li><strong>React Axe:</strong> Integrates accessibility checks into your development workflow. Provides real-time feedback about accessibility issues.</li> <br/>
        <li><strong>Chrome DevTools Accessibility Panel:</strong> Helps identify accessibility issues with an audit and suggests improvements.</li> <br/>
        <li><strong>Lighthouse:</strong> Built into Chrome DevTools for auditing web app accessibility and providing suggestions for improvement.</li>
      </ul>
    </section> <br/>

    <section>
      <h2>Conclusion</h2>
      <p>
        Accessibility in React is about ensuring your app is usable by everyone, including people with disabilities. By implementing semantic HTML, ARIA attributes, focus management, keyboard navigation, and proper error handling, your React apps can be more inclusive and accessible. Tools like React Axe and Lighthouse can assist in identifying accessibility issues and ensuring compliance with standards.
      </p>
    </section>
  </div>
)}

{selectedChapter === 'chapter61' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Internationalization (i18n)</h1>


      <p>
        Internationalization (i18n) in React.js refers to the process of designing your application to support multiple languages, regions, or cultural formats. It ensures that users from different parts of the world can interact with the application in their preferred language and locale.
      </p><br />

      <h3 style={{paddingBottom:"6px"}}>Key Concepts of i18n</h3>
      <ul>
        <li><strong>Translation</strong>: Providing content in different languages.</li><br />
        <li><strong>Locale</strong>: A set of parameters that define the user's language, region, and any special variant preferences.</li><br />
        <li><strong>Formatting</strong>: Adjusting dates, numbers, and currency formats based on the user's locale.</li><br />
        <li><strong>Right-to-Left (RTL) Support</strong>: Supporting languages like Arabic or Hebrew that are written from right to left.</li>
      </ul><br />

      <h3>Popular Libraries for i18n in React.js</h3>
      <ol>
        <li><a href="https://react.i18next.com/" target="_blank" rel="noopener noreferrer">react-i18next</a>: A powerful and widely used library based on <code>i18next</code>.</li> <br />
        <li><a href="https://formatjs.io/docs/react-intl/" target="_blank" rel="noopener noreferrer">react-intl</a>: Part of the FormatJS suite, designed for React applications.</li> <br />
        <li><a href="https://lingui.dev/" target="_blank" rel="noopener noreferrer">LinguiJS</a>: Focused on developer productivity with minimal setup.</li>
      </ol>

     <br />

      <h3  style={{paddingBottom:"6px"}}>Implementing i18n with <code>react-i18next</code></h3>

      <h4>1. Install Dependencies</h4>
      <pre>
        <code>npm install i18next react-i18next i18next-http-backend i18next-browser-languagedetector</code>
      </pre><br />

      <h4>2. Set Up the i18n Configuration</h4>
      <p>Create a file <code>i18n.js</code> in your project root:</p>
      <pre>
        <code>
{`import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend) // Load translations from files
  .use(LanguageDetector) // Detect user's language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    fallbackLng: 'en', // Default language
    debug: true, // Enable for debugging
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translation files
    },
  });

export default i18n;`}
        </code>
      </pre><br />

      <h4>3. Create Translation Files</h4>
      <p>Organize translations in the <code>public/locales</code> directory. Example structure:</p>
      <pre>
        <code>{`
public
└── locales
    ├── en
    │   └── translation.json
    └── es
        └── translation.json
        `}</code>
      </pre> <br />

      <p>Example <code>translation.json</code> for English (<code>en/translation.json</code>):</p>
      <pre>
        <code>
{`{
  "welcome": "Welcome to our app!",
  "language": "Select your language"
}`}
        </code>
      </pre> <br />

      <p>Example <code>translation.json</code> for Spanish (<code>es/translation.json</code>):</p>
      <pre>
        <code>
{`{
  "welcome": "¡Bienvenido a nuestra aplicación!",
  "language": "Seleccione su idioma"
}`}
        </code>
      </pre><br />

      <h4>4. Initialize i18n in the App</h4>
      <p>Wrap your application with the <code>I18nextProvider</code> in <code>index.js</code> or <code>App.js</code>:</p>
      <pre>
        <code>
{`import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './i18n'; // Import i18n configuration

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);`}
        </code>
      </pre><br />

      <h4>5. Use Translations in Components</h4>
      <p>Use the <code>useTranslation</code> hook in your components:</p>
      <pre>
        <code>
{`import React from 'react';
import { useTranslation } from 'react-i18next';

const App = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div>
      <h1>{t('welcome')}</h1>
      <p>{t('language')}</p>
      <button onClick={() => changeLanguage('en')}>English</button>
      <button onClick={() => changeLanguage('es')}>Español</button>
    </div>
  );
};

export default App;`}
        </code>
      </pre>

      <br />

      <h3  style={{paddingBottom:"6px"}}>Additional Features</h3>
      <ul>
        <li><strong>Dynamic Translation</strong>: Load translations dynamically based on the user’s language.</li><br />
        <li><strong>Pluralization</strong>: Handle singular/plural forms with translation keys.</li><br />
        <li><strong>Formatting</strong>: Format dates, numbers, and currencies using <code>i18next</code> or external libraries like <code>Intl</code>.</li>
      </ul><br />

      <h4>Example of Pluralization</h4>
      <p>Update <code>translation.json</code>:</p>
      <pre>
        <code>
{`{
  "item_count": "You have {{count}} item.",
  "item_count_plural": "You have {{count}} items."
}`}
        </code>
      </pre>
      <p>In the component:</p>
      <pre>
        <code>
{`<p>{t('item_count', { count: 1 })}</p>
<p>{t('item_count', { count: 5 })}</p>`}
        </code>
      </pre>

      <br />

      <h3  style={{paddingBottom:"6px"}}>Tips for Effective i18n</h3>
      <ul>
        <li>Use <strong>keys</strong> that are descriptive and easy to maintain.</li><br />
        <li>Avoid hardcoding strings; always use the <code>t()</code> function.</li><br />
        <li>Regularly test translations in different locales.</li><br />
        <li>Ensure proper support for RTL languages.</li>
      </ul><br />


      <p>This approach makes your React app accessible to a global audience with minimal effort.</p>
    </div>
 
)}




{selectedChapter === 'chapter62' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Custom Hooks  </h1>

    
    <p>
      In React, <strong>Custom Hooks</strong> are functions that allow you to reuse stateful logic across different components. They provide a clean and efficient way to encapsulate logic that needs to be shared among multiple components without repeating code. Custom hooks are a powerful feature of React that makes your code more modular, readable, and maintainable.
    </p> <br/>

    <p>
      Custom hooks are typically used to handle complex logic such as managing forms, fetching data, or managing side effects like subscriptions or timers. While <strong>React hooks</strong> like <code>useState</code>, <code>useEffect</code>, and <code>useReducer</code> are built-in and provide state and lifecycle functionality, <strong>custom hooks</strong> allow you to create your own reusable hooks to share behavior across components.
    </p> <br/>

    <h3>How Custom Hooks Work</h3>
    <p>
      Custom hooks work by abstracting logic into reusable functions. Inside a custom hook, you can use built-in React hooks (like <code>useState</code>, <code>useEffect</code>, etc.), just like you would in a regular component.
    </p> <br/>

    <h4>Basic Structure of a Custom Hook:</h4>
    <pre>
      <code>
        {`import { useState, useEffect } from 'react';

function useCustomHook() {
  const [state, setState] = useState(initialValue);

  useEffect(() => {
    // Perform side effect (e.g., data fetching)
  }, []);

  return [state, setState];
}

export default useCustomHook;`}
      </code>
    </pre> <br/>
    <ul>
      <li><strong>Custom hook</strong> functions follow the naming convention of starting with "use" (e.g., <code>useCustomHook</code>).</li> <br/>
      <li>Inside the hook, you can use React’s built-in hooks like <code>useState</code>, <code>useEffect</code>, <code>useContext</code>, etc.</li> <br/>
      <li>The custom hook returns the state or behavior that other components can use.</li>
    </ul> <br/>

    <h3>Why Use Custom Hooks?</h3>
    <ul>
      <li><strong>Reusability:</strong> Custom hooks allow you to extract and reuse logic across multiple components, keeping your code DRY (Don't Repeat Yourself).</li> <br/>
      <li><strong>Separation of concerns:</strong> By moving logic out of components, your components focus more on rendering and less on business logic.</li> <br/>
      <li><strong>Improved readability:</strong> Custom hooks make your code easier to read and understand by separating complex logic into smaller, manageable pieces.</li>
    </ul> <br/>

    <h3>Example 1: Custom Hook for Fetching Data</h3>
    <p>
      Let's create a custom hook to fetch data from an API. Instead of repeating the fetching logic in every component, we can extract it into a reusable custom hook.
    </p>

    <pre>
      <code>
        {`import { useState, useEffect } from 'react';

function useFetch(url) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(url);
        const result = await response.json();
        setData(result);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [url]);

  return { data, loading, error };
}

export default useFetch;`}
      </code>
    </pre> <br/>

    <p>
      In the <code>useFetch</code> hook:
      <ul>
        <li>We manage state for <code>data</code>, <code>loading</code>, and <code>error</code>.</li> <br/>
        <li>It performs an asynchronous fetch operation inside the <code>useEffect</code> hook.</li> <br/>
        <li>It returns an object containing <code>data</code>, <code>loading</code>, and <code>error</code>.</li>
      </ul> <br/>
      Now, any component can use this <code>useFetch</code> hook:
    </p>

    <pre>
      <code>
        {`import React from 'react';
import useFetch from './useFetch';

function App() {
  const { data, loading, error } = useFetch('https://api.example.com/data');

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div>
      <h1>Data:</h1>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}

export default App;`}
      </code>
    </pre> <br/>

    <h3>Example 2: Custom Hook for Form Handling</h3>
    <p>
      Custom hooks are also useful for managing form states. Let's create a custom hook called <code>useForm</code> to manage form inputs and handle form submission.
    </p> <br/>

    <pre>
      <code>
        {`import { useState } from 'react';

function useForm(initialValues) {
  const [values, setValues] = useState(initialValues);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSubmit = (event, callback) => {
    event.preventDefault();
    callback(values); 
  };

  return {
    values,
    handleChange,
    handleSubmit,
  };
}

export default useForm;`}
      </code>
    </pre> <br/>

    <p>
      In the <code>useForm</code> hook:
      <ul>
        <li>We track the form field values using <code>useState</code>.</li> <br/>
        <li>The <code>handleChange</code> function updates the form values whenever an input changes.</li> <br/>
        <li>The <code>handleSubmit</code> function prevents the default form submission and calls the provided callback with the form values.</li>
      </ul> <br/>
      Now, any component can use this <code>useForm</code> hook:
    </p> <br/>

    <pre>
      <code>
        {`import React from 'react';
import useForm from './useForm';

function ContactForm() {
  const { values, handleChange, handleSubmit } = useForm({
    name: '',
    email: '',
    message: '',
  });

  const submitForm = (formValues) => {
    console.log('Form submitted:', formValues);
  };

  return (
    <form onSubmit={(event) => handleSubmit(event, submitForm)}>
      <div>
        <label>Name</label>
        <input
          type="text"
          name="name"
          value={values.name}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>Email</label>
        <input
          type="email"
          name="email"
          value={values.email}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>Message</label>
        <textarea
          name="message"
          value={values.message}
          onChange={handleChange}
        />
      </div>
      <button type="submit">Submit</button>
    </form>
  );
}

export default ContactForm;`}
      </code>
    </pre> <br/>

    <h3>Best Practices for Custom Hooks</h3>
    <ul>
      <li><strong>Follow the naming convention:</strong> Always start the custom hook name with "use" to follow React’s rules of hooks (e.g., <code>useFetch</code>, <code>useForm</code>).</li> <br/>
      <li><strong>Keep hooks focused:</strong> A custom hook should ideally perform one task (e.g., <code>useFetch</code> for fetching data).</li> <br/>
      <li><strong>Avoid side effects in the component:</strong> Custom hooks should handle side effects (e.g., data fetching, subscriptions) so components remain clean.</li> <br/>
      <li><strong>Return necessary state:</strong> Custom hooks should return only the required state and functions for the component, not extra logic.</li>
    </ul> <br/>

    <h3>Conclusion</h3>
    <p>
      Custom hooks are a powerful feature in React that allow you to reuse stateful logic and encapsulate complex behavior in a clean, modular way. By creating custom hooks like <code>useFetch</code> or <code>useForm</code>, you can separate concerns in your application, making your components more focused and readable. Custom hooks enable you to build more maintainable and scalable React applications while ensuring that complex logic is reusable and easily tested.
    </p>
  </div>
)}




{selectedChapter === 'chapter63' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>TypeScript with React.js</h1>

    <p>
      TypeScript is a statically typed superset of JavaScript that adds type checking to the language. 
      When combined with React, TypeScript provides better tooling, more reliable code, and helps catch errors during development. 
      TypeScript brings the power of type safety and object-oriented principles to React development, 
      making it easier to manage large applications and avoid common mistakes.
    </p> <br/>

    <p>
      In this guide, we’ll cover how to set up and use TypeScript in a React project, how it enhances the development experience, 
      and provide a comprehensive example.
    </p> <br/>

    <h3>Why Use TypeScript with React?</h3>
    <p>Using TypeScript with React brings several benefits:</p>
    <ul>
      <li><strong>Static Type Checking:</strong> TypeScript helps catch type errors during development, making it easier to avoid bugs.</li> <br/>
      <li><strong>Better IDE Support:</strong> TypeScript provides better autocompletion, intellisense, and error checking in modern IDEs like VSCode.</li> <br/>
      <li><strong>Improved Refactoring:</strong> Type checking allows for safer and easier refactoring of code, as the types are explicitly defined.</li> <br/>
      <li><strong>Better Documentation:</strong> Type annotations provide self-documenting code, making it easier to understand how components interact with one another.</li>
    </ul> <br/>

    <h3>Setting Up TypeScript in a React Project</h3>

    <h4>1. Create a React Project with TypeScript</h4>
    <p>
      You can create a new React project using TypeScript with <strong>Create React App</strong> by running the following command:
    </p> <br/>
    <pre>
      <code>npx create-react-app my-app --template typescript</code>
    </pre> <br/>
    <p>
      This command initializes a new React app with TypeScript preconfigured. The file extensions for TypeScript files will automatically be <code>.tsx</code> for files that contain JSX and <code>.ts</code> for plain TypeScript files.
    </p> <br/>
    <p>
      If you already have a React project set up, you can add TypeScript manually:
    </p> <br/>
    <ul>
      <li>Install the necessary TypeScript dependencies:</li> <br/>
      <pre>
        <code>npm install --save typescript @types/react @types/react-dom @types/jest</code>
      </pre> <br/>
      <li>Rename your React files from <code>.js</code> to <code>.tsx</code> for files containing JSX or <code>.ts</code> for plain TypeScript files.</li> <br/>
      <li>Create a <code>tsconfig.json</code> file in your project root, which will configure TypeScript for your project:</li> <br/>
      <pre>
        <code>npx tsc --init</code>
      </pre>
    </ul> <br/>

    <h3>TypeScript Basics in React</h3>
    <br/>
    <h4>2. Type Annotations for Props and State</h4>

    <h5>Functional Components</h5>
    <p>In React, functional components can receive props as input. TypeScript allows you to define the types of these props, making your code more predictable and error-resistant.</p>
    <pre>
      <code>
        {`// Greeting.tsx
import React from 'react';

// Define the type for props
interface GreetingProps {
  name: string;
}

const Greeting: React.FC<GreetingProps> = ({ name }) => {
  return <h1>Hello, {name}!</h1>;
};

export default Greeting;`}
      </code>
    </pre> <br/>
    <p><code>GreetingProps</code> is an interface that specifies that <code>name</code> should be a string. <code>React.FC{`<GreetingProps>`}</code> specifies that the <code>Greeting</code> component is a functional component that accepts <code>GreetingProps</code>.</p>
    <br/>
    <h5>Class Components</h5>
    <p>You can also use TypeScript with class components, specifying types for props and state.</p>
    <pre>
      <code>
        {`// Counter.tsx
import React, { Component } from 'react';

interface CounterState {
  count: number;
}

interface CounterProps {
  initialCount: number;
}

class Counter extends Component<CounterProps, CounterState> {
  constructor(props: CounterProps) {
    super(props);
    this.state = { count: props.initialCount };
  }

  increment = () => {
    this.setState((prevState) => ({ count: prevState.count + 1 }));
  };

  render() {
    return (
      <div>
        <p>Count: {this.state.count}</p>
        <button onClick={this.increment}>Increment</button>
      </div>
    );
  }
}

export default Counter;`}
      </code>
    </pre> <br/>
    <p><code>CounterState</code> defines the type for the component's state. <code>CounterProps</code> defines the type for the <code>initialCount</code> prop. <code>{`Component<CounterProps, CounterState>`}</code> specifies that <code>Counter</code> is a class component that accepts <code>CounterProps</code> and has <code>CounterState</code>.</p>
    <br/>
    <h4>3. Handling Events in TypeScript</h4>
    <p>TypeScript provides type definitions for common DOM events. You can define the types of event handlers to make your code more robust.</p>
    <pre>
      <code>
        {`// ButtonClick.tsx
import React, { useState } from 'react';

const ButtonClick: React.FC = () => {
  const [count, setCount] = useState<number>(0);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setCount(count + 1);
  };

  return (
    <div>
      <p>Count: {count}</p>
      <button onClick={handleClick}>Click me!</button>
    </div>
  );
};

export default ButtonClick;`}
      </code>
    </pre> <br/>
    <p><code>React.MouseEvent{`<HTMLButtonElement>`}</code> specifies that <code>handleClick</code> is an event handler for mouse clicks on a button element.</p>
    <br/>
    <h4>4. Using Context API with TypeScript</h4>
    <p>React’s Context API allows you to share state globally across components. You can also define types for context values to ensure consistency.</p>
    <pre>
      <code>
        {`// ThemeContext.tsx
import React, { createContext, useContext, useState } from 'react';

interface ThemeContextType {
  theme: string;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC = ({ children }) => {
  const [theme, setTheme] = useState<string>('light');

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};`}
      </code>
    </pre> <br/>
    <p><code>ThemeContextType</code> defines the shape of the context data, including the <code>theme</code> and <code>toggleTheme</code> function. <code>useTheme</code> is a custom hook to consume the context.</p>
    <br/>
    <h4>5. TypeScript with React Hooks</h4>
    <p>React hooks are a great feature, and TypeScript provides excellent support for them. You can specify types for hooks like <code>useState</code>, <code>useEffect</code>, and <code>useRef</code>.</p>
    <pre>
      <code>
        {`// CounterWithHooks.tsx
import React, { useState } from 'react';

const CounterWithHooks: React.FC = () => {
  const [count, setCount] = useState<number>(0);

  const increment = () => {
    setCount(count + 1);
  };

  return (
    <div>
      <p>Count: {count}</p>
      <button onClick={increment}>Increment</button>
    </div>
  );
};

export default CounterWithHooks;`}
      </code>
    </pre>
    <p><code>{`useState<number>(0)`}</code> specifies that the state variable <code>count</code> is a number.</p>
    <br/>
    <h4>6. Advanced TypeScript Features in React</h4>
    <p><strong>Generics in TypeScript:</strong> TypeScript allows you to use generics to create reusable components with flexible types.</p>
    <pre>
      <code>
        {`// DataDisplay.tsx
import React from 'react';

interface DataProps<T> {
  data: T;
}

function DataDisplay<T>({ data }: DataProps<T>) {
  return <div>{JSON.stringify(data)}</div>;
}

export default DataDisplay;`}
      </code>
    </pre>
    <p><code>DataProps{`<T>`}</code> is a generic interface that can accept any type <code>T</code>. The component <code>DataDisplay</code> will render data of any type passed to it.</p>
    <br/>
    <h4>Type Assertions</h4>
    <p>Type assertions are used when you want to tell TypeScript to treat a variable as a specific type. Use them when you are certain of the type but TypeScript cannot infer it automatically.</p>
    <pre>
      <code>const inputElement = document.getElementById('myInput') as HTMLInputElement;</code>
    </pre>
    <br/>
    <h3>Conclusion</h3>
    <p>Using TypeScript with React significantly enhances the development process by providing type safety, better tooling, and better maintainability of code. 
      With features like type annotations for props, state, events, context, and hooks, TypeScript helps developers write more reliable and predictable code.
    </p>
    <p>By using TypeScript with React, you improve the development experience, minimize errors, and ensure that your app is more scalable and easier to refactor in the future.</p>
  </div>
)}





{selectedChapter === 'chapter64' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Animations with Framer Motion and React Spring </h1>

    <section>
      <h2>1. Framer Motion</h2>
      <p>Framer Motion is a powerful library that allows you to animate components with minimal configuration. It’s designed specifically for React and provides a simple, declarative API for handling animations.</p>
      <br/>
      <h3>Getting Started with Framer Motion</h3>
      <p>To get started, install Framer Motion:</p>
     <pre><code>npm install framer-motion</code></pre>
      <br/>
      <h3>Basic Concepts in Framer Motion</h3>
      <ul>
        <li><strong>motion</strong>: A wrapper component that animates any React component (e.g., div, button).</li> <br/>
        <li><strong>animate</strong>: Specifies the final state of the component.</li> <br/>
        <li><strong>initial</strong>: Defines the initial state before the animation begins.</li> <br/>
        <li><strong>transition</strong>: Controls the timing and easing of the animation.</li> <br/>
        <li><strong>variants</strong>: A set of named animation states that can be applied to a component.</li>
      </ul> <br/>

      <h3>Example: Animating a Box with Framer Motion</h3>
   <pre><code>{`import React from 'react'; 
        import { motion } from 'framer-motion'; 

        const AnimatedBox = () => {
          return (
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
              style={{
                width: 200, height: 200, backgroundColor: 'coral', borderRadius: 10
              }}
            >
              <h2 style={{ textAlign: 'center', color: '#fff' }}>Hello, Framer Motion!</h2>
            </motion.div>
          );
        };

export default AnimatedBox;`}
      </code> </pre><br/>

      <h3>Animating with Variants</h3>
      <p>Variants allow you to organize and control multiple animation states:</p>
    <pre><code>
        {`import React from 'react'; 
        import { motion } from 'framer-motion'; 

        const BoxWithVariants = () => {
          const variants = {
            hidden: { opacity: 0, x: -100 },
            visible: { opacity: 1, x: 0 }
          };

          return (
            <motion.div
              initial="hidden"
              animate="visible"
              variants={variants}
              transition={{ duration: 1 }}
              style={{
                width: 200, height: 200, backgroundColor: 'teal', borderRadius: 10
              }}
            >
              <h2 style={{ textAlign: 'center', color: '#fff' }}>Animated Box</h2>
            </motion.div>
          );
        };

export default BoxWithVariants;`}
      </code></pre>
    </section> <br/>

    <section>
      <h2>2. React Spring</h2>
      <p>React Spring is a powerful library that allows you to create animations based on physics-based motion. It provides more advanced features, such as spring-based animations and smooth transitions.</p>
      <br/>
      <h3>Getting Started with React Spring</h3>
      <p>To get started, install React Spring:</p>
     <pre><code>npm install @react-spring/web</code></pre>
      <br/>
      <h3>Basic Concepts in React Spring</h3>
      <ul>
        <li><strong>useSpring</strong>: A hook that animates a single component or value over time.</li> <br/>
        <li><strong>useSprings</strong>: A hook to animate an array of components or values.</li> <br/>
        <li><strong>animated</strong>: A higher-order component that wraps a regular React component and applies animations.</li>
      </ul> <br/>

      <h3>Example: Animating a Box with React Spring</h3>
      <pre><code>
        {`import React from 'react'; 
        import { useSpring, animated } from '@react-spring/web'; 

        const AnimatedBoxWithSpring = () => {
          const props = useSpring({
            opacity: 1,
            from: { opacity: 0 },
            config: { duration: 1000 }
          });

          return (
            <animated.div
              style={{
                ...props,
                width: 200, height: 200, backgroundColor: 'purple', borderRadius: 10
              }}
            >
              <h2 style={{ textAlign: 'center', color: '#fff' }}>Hello, React Spring!</h2>
            </animated.div>
          );
        };

export default AnimatedBoxWithSpring;`}
      </code> </pre><br/>

      <h3>Using Springs for More Complex Animations</h3>
      <p>You can also animate other properties such as position, scale, or rotation with React Spring:</p>
     <pre><code>
        {`import React from 'react'; 
        import { useSpring, animated } from '@react-spring/web';

        const MoveAndScaleBox = () => {
          const props = useSpring({
            to: { x: 200, scale: 1.5 },
            from: { x: 0, scale: 1 },
            config: { tension: 200, friction: 20 }
          });

          return (
            <animated.div
              style={{
                ...props,
                width: 200, height: 200, backgroundColor: 'limegreen', borderRadius: 10
              }}
            >
              <h2 style={{ textAlign: 'center', color: '#fff' }}>Move and Scale</h2>
            </animated.div>
          );
        };

export default MoveAndScaleBox;`}
      </code></pre>
    </section> <br/>

    <section>
      <h2>Comparing Framer Motion and React Spring</h2>
      <p>Both Framer Motion and React Spring are excellent libraries, but they have different strengths:</p> <br/>
      <ul>
        <li><strong>Framer Motion</strong> is declarative, simple to use, and great for standard animations like opacity, scaling, and position transitions. It's especially useful for animating page routes and interactive UI components.</li> <br/>
        <li><strong>React Spring</strong> is more flexible, physics-based, and ideal for more complex animations. It's perfect for creating spring-based animations, such as drag-and-drop interactions and animating components over time.</li>
      </ul>
    </section> <br/>

    <section>
      <h2>Conclusion</h2>
      <p>Both Framer Motion and React Spring are powerful tools that can help you create engaging, interactive animations in your React applications. Choose the one that best fits your needs:</p> <br/>
      <ul>
        <li>For simple and declarative UI animations, go with <strong>Framer Motion</strong>.</li> <br/>
        <li>For complex, physics-based animations and more control, go with <strong>React Spring</strong>.</li>
      </ul> <br/>
      <p>With either library, you can make your React applications more dynamic and enjoyable for users.</p>
    </section>
  </div>
)}




{selectedChapter === 'chapter65' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Building Progressive Web Apps (PWAs) with React.js</h1>

    <section>
      
      <p>To make an app a PWA, it must meet the following requirements:</p> <br/>
      <ul>
        <li><strong>Responsive</strong>: It should work on any device and screen size.</li> <br/>
        <li><strong>Offline Support</strong>: It must be able to work offline or in low-network conditions.</li> <br/>
        <li><strong>App-like Interface</strong>: It should provide an app-like experience (e.g., fast load times, smooth animations).</li> <br/>
        <li><strong>Installable</strong>: Users should be able to add the app to their home screen.</li>
      </ul>
    </section> <br/>

    <section>
      <h2>Steps to Build a PWA with React</h2>
      <br/>
      <h3>1. Create a New React Project</h3>
      <p>To start, create a new React application using `create-react-app`:</p>
    <pre><code>
      {`npx create-react-app my-pwa
cd my-pwa`}</code></pre>
      <br/> 
      <h3>2. Enable PWA Features in React</h3>
      <p>Enable the service worker in `src/index.js` to make the app work offline:</p>
      <pre>
      <code>
        {`import React from 'react'; 
import ReactDOM from 'react-dom'; 
import './index.css'; 
import App from './App'; 
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// Register service worker for PWA functionality
serviceWorker.register();`}
      </code></pre>
      <br/>
      <h3>3. Add Offline Support Using Service Workers</h3>
      <p>Use service workers to cache assets and make your app work offline.</p>
      <br/>
      <h3>4. Make Your PWA Installable</h3>
      <p>Customize the `manifest.json` in the `public/` folder for app metadata.</p>
     <pre> <code>{`{
          "short_name": "My PWA",
          "name": "My Progressive Web App",
          "icons": [
            {
              "src": "favicon.ico",
              "sizes": "64x64 32x32 24x24 16x16",
              "type": "image/x-icon"
            },
            {
              "src": "icons/icon-192x192.png",
              "sizes": "192x192",
              "type": "image/png"
            },
            {
              "src": "icons/icon-512x512.png",
              "sizes": "512x512",
              "type": "image/png"
            }
          ],
          "start_url": ".",
          "display": "standalone",
          "background_color": "#ffffff",
          "theme_color": "#000000"
}`}
      </code></pre>
    </section>
    <br/>
    <section>
      <h2>Test and Optimize Your PWA</h2>
      <p>Test your PWA using Chrome DevTools and Lighthouse to ensure it works offline, is installable, and performs well.</p>
    </section>
    <br/>
    <section>
      <h2>Deploying Your PWA</h2>
      <p>Deploy your PWA to platforms like Netlify, Vercel, or GitHub Pages for easy and fast deployment.</p>
    </section>
    <br/>
    <section>
      <h2>Conclusion</h2>
      <p>With React, you can easily create a Progressive Web App that works seamlessly across devices and network conditions. By adding PWA features like service workers and offline support, you can provide a smooth, app-like experience for your users.</p>
    </section>
  </div>
)}




                </div>
            </div>
        </div>

    );

}


export default Reactjscourse;
